(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
Falcon.addBinding('dateText', true, (function() {
  var FORMAT;
  FORMAT = "M/D/YYYY";
  return function(element, valueAccessor) {
    var m, node, offset, value;
    value = ko.unwrap(valueAccessor());
    if (_.isDate(value) || _.isString(value)) {
      m = moment.utc(value);
    } else if (moment.isMoment(value)) {
      m = value;
    } else if (_.isObject(value)) {
      ({value, offset} = value);
      value = ko.unwrap(value);
      offset = ko.unwrap(offset);
      m = moment.utc(value);
      if (offset) {
        m = m.utcOffset(offset);
      }
    } else {
      m = moment(null);
    }
    //END if
    if (m.isValid()) {
      node = document.createTextNode(m.format(FORMAT));
    } else {
      //TODO: Make this configurable and then more generic
      node = document.createTextNode("Invalid Date");
    }
    //END if
    return ko.virtualElements.setDomNodeChildren(element, [node]);
  };
})());

//END return
//END init

},{}],2:[function(require,module,exports){
Falcon.addBinding('dateTimeText', true, (function() {
  var FORMAT;
  FORMAT = "MM/DD/YYYY h:mma";
  return function(element, valueAccessor) {
    var m, node, value;
    value = ko.unwrap(valueAccessor());
    m = moment(value);
    if (m.isValid()) {
      node = document.createTextNode(m.format(FORMAT));
    } else {
      node = document.createTextNode("Invalid Date");
    }
    //END if
    return ko.virtualElements.setDomNodeChildren(element, [node]);
  };
})());

//END return
//END init

},{}],3:[function(require,module,exports){
var CONSTANTS;

CONSTANTS = require("../$constants/default.constants");

Falcon.addBinding("dateValue", {
  'init': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
    var obs, onChange;
    obs = valueAccessor();
    if (!ko.isObservable(obs)) {
      return;
    }
    ko.computed({
      disposeWhenNodeIsRemoved: element,
      read: function() {
        var value;
        value = obs();
        if (value != null) {
          value = moment(value).format(CONSTANTS.DATE_FORMAT);
        }
        return element.value = value != null ? value : "";
      }
    });
    //END read
    //END computed
    element.addEventListener('change', onChange = function() {
      var m, value;
      value = element.value;
      m = moment(value, CONSTANTS.DATE_FORMAT);
      element.removeEventListener('change', onChange);
      if (m.isValid()) {
        obs(m.toDate());
      } else {
        obs(null);
      }
      //END if
      return element.addEventListener('change', onChange);
    });
    return Falcon.onDispose(element, function() {
      return element.removeEventListener('change', onChange);
    });
  }
});

//END onDispose
//END dateValue

},{"../$constants/default.constants":49}],4:[function(require,module,exports){
Falcon.addBinding('daysUntilText', true, function(element, valueAccessor, allBindings) {
  var add, daysUntil, m, node, offset, ref, value;
  value = ko.unwrap(valueAccessor());
  add = (ref = ko.unwrap(allBindings.get('daysUntilTextAdd'))) != null ? ref : 0;
  if (_.isDate(value) || _.isString(value)) {
    m = moment.utc(value);
  } else if (moment.isMoment(value)) {
    m = value;
  } else if (_.isObject(value)) {
    ({value, offset} = value);
    value = ko.unwrap(value);
    offset = ko.unwrap(offset);
    m = moment.utc(value);
    if (offset) {
      m = m.utcOffset(offset);
    }
  } else {
    m = moment(null);
  }
  //END if
  daysUntil = m.diff(moment.utc(), 'days') + add;
  if (daysUntil < 0) {
    daysUntil = 0;
  }
  node = document.createTextNode(daysUntil);
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

//END init

},{}],5:[function(require,module,exports){
Falcon.addBinding('decimal', true, function(element, valueAccessor) {
  var node, value;
  value = ko.unwrap(valueAccessor());
  node = document.createTextNode(numeral(value).format('0,0.00'));
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

//END return
//END init

},{}],6:[function(require,module,exports){
//---------------------------------------------
// followCursor
//---------------------------------------------
Falcon.addBinding('followCursor', (function() {
  return {
    'init': function(element, valueAccessor) {
      var $childElemens, $element;
      $element = $(element);
      $childElemens = null;
      ko.computed(() => {
        var querySelector;
        querySelector = ko.unwrap(valueAccessor());
        return $childElemens = $element.find(querySelector);
      });
      return element.addEventListener('mousemove', function(event) {
        var left, top, x, y;
        ({top, left} = $element.offset());
        x = event.pageX - left;
        y = event.pageY - top;
        return $childElemens.css({
          position: 'absolute',
          top: y,
          left: x
        });
      });
    }
  };
})());

//END init
//END followCursor

},{}],7:[function(require,module,exports){
Falcon.addBinding('fromNowText', true, function(element, valueAccessor) {
  var m, node, offset, value;
  value = ko.unwrap(valueAccessor());
  if (_.isDate(value) || _.isString(value)) {
    m = moment.utc(value);
  } else if (moment.isMoment(value)) {
    m = value;
  } else if (_.isObject(value)) {
    ({value, offset} = value);
    value = ko.unwrap(value);
    offset = ko.unwrap(offset);
    m = moment.utc(value);
    if (offset) {
      m = m.utcOffset(offset);
    }
  } else {
    m = moment(null);
  }
  //END if
  if (m.isValid()) {
    node = document.createTextNode(m.fromNow());
  } else {
    //TODO: Make this configurable and then more generic
    node = document.createTextNode("Invalid Date");
  }
  //END if
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

//END init

},{}],8:[function(require,module,exports){
Falcon.addBinding('hashHref', {
  'update': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
    var ref, ref1, ref2, url, value;
    value = (ref = valueAccessor()) != null ? ref : "";
    if (ko.isObservable(value)) {
      url = ((ref1 = value()) != null ? ref1 : "").toString();
    } else if (_.isFunction(value)) {
      url = ((ref2 = value(bindingContext['$data'])) != null ? ref2 : "").toString();
    } else {
      url = value.toString();
    }
    //END if
    return element.setAttribute("href", `#${url}`);
  }
});

//END addBinding

},{}],9:[function(require,module,exports){
Falcon.addBinding('href', function(element, valueAccessor) {
  element.setAttribute('href', ko.unwrap(valueAccessor()));
  return element.setAttribute('target', '_blank');
});

//END addBinding

},{}],10:[function(require,module,exports){
Falcon.addBinding('integer', true, function(element, valueAccessor) {
  var node, value;
  value = ko.unwrap(valueAccessor());
  node = document.createTextNode(numeral(value).format('0,0'));
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

//END return
//END init

},{}],11:[function(require,module,exports){
Falcon.addBinding('isHovered', {
  'init': function(element, valueAccessor) {
    var $element, mouseenter, mouseleave, obs;
    obs = valueAccessor();
    if (!ko.isObservable(obs)) {
      return;
    }
    $element = $(element);
    $element.on('mouseenter', mouseenter = function() {
      return obs(true);
    });
    $element.on('mouseleave', mouseleave = function() {
      return obs(false);
    });
    return Falcon.onDispose(element, function() {
      $element.off('mouseenter', mouseenter);
      return $element.off('mouseleave', mouseleave);
    });
  }
});

//END onDispose
//END isHovered

},{}],12:[function(require,module,exports){
Falcon.addBinding('moment', true, (function() {
  var $hours, $minutes, $seconds;
  $seconds = ko.observable(0);
  $minutes = ko.observable(0);
  $hours = ko.observable(0);
  setInterval(function() {
    return $seconds($seconds() + 1);
  }, 1000);
  setInterval(function() {
    return $minutes($minutes() + 1);
  }, 30 * 1000);
  setInterval(function() {
    return $hours($hours() + 1);
  }, 30 * 60 * 1000);
  return {
    'update': function(element, valueAccessor, allBindings) {
      var current_moment, now, textNode, value;
      ko.virtualElements.emptyNode(element);
      value = ko.unwrap(valueAccessor());
      if (value == null) {
        return;
      }
      current_moment = moment(value);
      now = moment().subtract(1, 'seconds');
      if (current_moment.isAfter(now)) {
        current_moment = now;
      }
      if (current_moment.isAfter(moment().subtract(1, 'minute'))) {
        current_moment = current_moment.fromNow();
        $seconds();
      } else if (current_moment.isAfter(moment().subtract(1, 'hour'))) {
        current_moment = current_moment.fromNow();
        $minutes();
      } else if (current_moment.isAfter(moment().subtract(1, 'days'))) {
        current_moment = current_moment.fromNow();
        $hours();
      } else if (current_moment.isAfter(moment().subtract(1, 'weeks'))) {
        current_moment = current_moment.format('dddd'); // Day of week
      } else {
        current_moment = current_moment.format('l'); // Physical Date
      }
      //END if
      textNode = document.createTextNode(current_moment);
      return ko.virtualElements.setDomNodeChildren(element, [textNode]);
    }
  };
})());

//END update
//END moment

},{}],13:[function(require,module,exports){
Falcon.addBinding('monthText', true, (function() {
  var FORMAT;
  FORMAT = "MMMM";
  return function(element, valueAccessor) {
    var m, node, value;
    value = ko.unwrap(valueAccessor());
    m = moment(value);
    if (m.isValid()) {
      node = document.createTextNode(m.format(FORMAT));
    } else {
      node = document.createTextNode("Invalid Date");
    }
    //END if
    return ko.virtualElements.setDomNodeChildren(element, [node]);
  };
})());

//END return
//END init

},{}],14:[function(require,module,exports){
Falcon.addBinding('monthYearText', true, (function() {
  var FORMAT;
  FORMAT = "MMMM, YYYY";
  return function(element, valueAccessor) {
    var m, node, value;
    value = ko.unwrap(valueAccessor());
    m = moment(value);
    if (m.isValid()) {
      node = document.createTextNode(m.format(FORMAT));
    } else {
      node = document.createTextNode("Invalid Date");
    }
    //END if
    return ko.virtualElements.setDomNodeChildren(element, [node]);
  };
})());

//END return
//END init

},{}],15:[function(require,module,exports){
Falcon.addBinding("onEnter", {
  'init': function(element, valueAccessor) {
    var keydown;
    element.addEventListener('keydown', keydown = function(event) {
      var callback, keyCode, ref;
      keyCode = (ref = event.keyCode) != null ? ref : event.which;
      if (keyCode !== KeyboardCommands.ENTER_KEY) {
        return true;
      }
      event.preventDefault();
      callback = valueAccessor();
      if (_.isFunction(callback)) {
        callback();
      }
      return false;
    });
    //END keydown
    return Falcon.onDispose(element, function() {
      return element.removeEventListener('keydown', keydown);
    });
  }
});

//END onDispose
//END onEnter

},{}],16:[function(require,module,exports){
Falcon.addBinding('onScrollBottom', (function() {
  var THRESHOLD;
  THRESHOLD = 100;
  return {
    'init': function(element, valueAccessor, allBindings) {
      var callback, clientHeight, isDisabled, is_refreshing, onScroll, ref, scrollHeight, scrollTop;
      is_refreshing = false;
      callback = valueAccessor();
      if (!_.isFunction(callback)) {
        callback = (function() {});
      }
      isDisabled = (ref = allBindings.get('onScrollBottomDisabled')) != null ? ref : false;
      scrollHeight = 0;
      clientHeight = 0;
      scrollTop = 0;
      element.addEventListener('scroll', onScroll = function() {
        var scrollTopTrigger, scrollableAmount;
        if (ko.unwrap(isDisabled)) {
          return;
        }
        scrollableAmount = element.scrollHeight - element.clientHeight;
        scrollTopTrigger = scrollableAmount - THRESHOLD;
        if (element.scrollTop >= scrollTopTrigger) {
          return callback();
        }
      });
      //END addEventListener
      return Falcon.onDispose(element, function() {
        return element.removeEventListener('scroll', onScroll);
      });
    }
  };
})());

//END init
//END onScrollBottom

},{}],17:[function(require,module,exports){
Falcon.addBinding('percent', true, function(element, valueAccessor) {
  var node, value;
  value = ko.unwrap(valueAccessor());
  node = document.createTextNode(numeral(value).format('0.00%'));
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

//END return
//END init

},{}],18:[function(require,module,exports){
//---------------------------------------------
// preventDefault
//---------------------------------------------
Falcon.addBinding('preventDefault', (function() {
  var stop;
  stop = function(event) {
    return event.preventDefault();
  };
  return {
    'init': function(element, valueAccessor) {
      var $element, value;
      $element = $(element);
      value = ko.unwrap(valueAccessor());
      if (!_.isString(value)) {
        value = "";
      }
      if (_.isEmpty(value)) {
        return;
      }
      if (value === 'touch') {
        element.addEventListener('touchstart', stop);
        element.addEventListener('touchend', stop);
      } else if (value === 'mouse') {
        element.addEventListener('mousedown', stop);
        element.addEventListener('mouseup', stop);
        element.addEventListener('click', stop);
      } else {
        element.addEventListener(value, stop);
      }
    }
  };
})());

//END init
//END preventDefault
//END if

},{}],19:[function(require,module,exports){
var Recaptcha;

Recaptcha = require('../recaptcha');

Falcon.addBinding('recaptcha', (function() {
  return {
    'init': function(element, valueAccessor, allBindings) {
      var onSubmit;
      onSubmit = function(event) {
        event.preventDefault();
        event.stopPropagation();
        return Recaptcha.execute().then(function(token) {
          var originalSubmit;
          originalSubmit = ko.unwrap(valueAccessor());
          return originalSubmit(token);
        });
      };
      //END then
      //END onSubmit
      element.addEventListener('submit', onSubmit);
      return Falcon.onDispose(element, function() {
        return element.removeEventListener('submit', onSubmit);
      });
    }
  };
})());

//END onDispose
//END init
//END recaptcha

},{"../recaptcha":89}],20:[function(require,module,exports){
var RPC;

RPC = require("../rpc");

Falcon.addBinding('s3Upload', (function() {
  var bucket;
  bucket = null;
  return {
    'init': function(element, valueAccessor, allBindings, viewModel, bindingContent) {
      var fileNameObs, fileUrlObs, isUploadingObs, onChange, options, ref;
      options = (ref = ko.unwrap(valueAccessor())) != null ? ref : {};
      fileUrlObs = options.fileUrl;
      fileNameObs = options.fileName;
      isUploadingObs = options.isUploading;
      if (!ko.isObservable(fileUrlObs)) {
        return typeof console !== "undefined" && console !== null ? console.error("'fileUrl' assignment must be an observable") : void 0;
      }
      element.addEventListener('change', onChange = function() {
        var file;
        if (!(element.files.length > 0)) {
          fileUrlObs(null);
          if (ko.isWriteableObservable(fileNameObs)) {
            fileNameObs(null);
          }
          return;
        }
        //END unless
        file = element.files[0];
        element.disabled = true;
        if (ko.isWriteableObservable(isUploadingObs)) {
          isUploadingObs(true);
        }
        return RPC.promiseUploadFile(file).then((url) => {
          fileUrlObs(url);
          if (ko.isWriteableObservable(fileNameObs)) {
            return fileNameObs(file.name);
          }
        }).fail(() => {
          if (typeof console !== "undefined" && console !== null) {
            console.error("An error occurred while uploading file");
          }
          fileUrlObs(null);
          if (ko.isWriteableObservable(fileNameObs)) {
            return fileNameObs(null);
          }
        }).fin(() => {
          element.disabled = false;
          if (ko.isWriteableObservable(isUploadingObs)) {
            return isUploadingObs(false);
          }
        }).done();
      });
      //END RPC
      //END addEventListener
      return Falcon.onDispose(element, function() {
        return element.removeEventListener('change', onChange);
      });
    }
  };
})());

//END return
//END s3Upload

},{"../rpc":90}],21:[function(require,module,exports){
var Contest, FPT, Franchisee, Region, User;

User = require("../$models/user.model");

Franchisee = require("../$models/franchisee.model");

FPT = require("../$models/fpt.model");

Contest = require("../$models/contest.model");

Region = require("../$models/region.model");

Falcon.addBinding('selectize', (function() {
  var generateOption, generateOptions;
  generateOption = function(option) {
    var label, search, value;
    value = label = search = null;
    if (option instanceof User) {
      value = option.get("id");
      label = `${option.get("name")} (${option.get("email")})`;
      search = label;
    } else if (option instanceof Franchisee) {
      value = option.get("id");
      label = option.get("name");
      search = label;
    } else if (option instanceof FPT) {
      value = option.get("id");
      label = option.get("name");
      search = label;
    } else if (option instanceof Contest) {
      value = option.get("id");
      label = option.get("name");
      search = label;
    } else if (option instanceof Region) {
      value = option.get("id");
      label = option.get("name");
      search = label;
    } else {
      if (typeof console !== "undefined" && console !== null) {
        console.error("[selectize.binding] Could not generate option for: ", option);
      }
    }
    //END if
    return {value, label, search};
  };
  //END generateOption
  generateOptions = function(options) {
    var option;
    if (Falcon.isCollection(options)) {
      options = options.all();
    }
    return (function() {
      var i, len, results1;
      results1 = [];
      for (i = 0, len = options.length; i < len; i++) {
        option = options[i];
        results1.push(generateOption(option));
      }
      return results1;
    })();
  };
  return {
    //END generateOptions
    'init': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
      var $element, _change, is_setting, observable, selectize, selectizeLoad, selectizeMaxItems, selectizeMaxOptions, selectizeOnCreate, selectizeOnRemove, selectizeOptions, values;
      values = null;
      selectizeOptions = {
        valueField: 'value',
        labelField: 'label',
        searchField: 'search',
        closeAfterSelect: false,
        hideSelected: true,
        persist: true
      };
      selectizeOnCreate = allBindings.get('selectizeOnCreate');
      selectizeOnRemove = allBindings.get('selectizeOnRemove');
      selectizeLoad = allBindings.get('selectizeLoad');
      selectizeMaxItems = ko.unwrap(allBindings.get('selectizeMaxItems'));
      selectizeMaxOptions = ko.unwrap(allBindings.get('selectizeMaxOptions'));
      if (_.isFunction(selectizeOnCreate)) {
        selectizeOptions['create'] = function(value) {
          var d;
          d = selectizeOnCreate.call(viewModel, value);
          return generateOption(d);
        };
      }
      //END create
      //END if
      if (_.isNumber(selectizeMaxItems)) {
        selectizeOptions['maxItems'] = selectizeMaxItems;
      }
      //END if
      if (_.isNumber(selectizeMaxOptions)) {
        selectizeOptions['maxOptions'] = selectizeMaxOptions;
      }
      //END if
      if (_.isFunction(selectizeLoad)) {
        selectizeOptions['load'] = function(query, callback) {
          return selectizeLoad(query, (results) => {
            results = generateOptions(results);
            return callback(results);
          });
        };
      }
      //END if
      $element = $(element).selectize(selectizeOptions);
      selectize = $element.get(0).selectize;
      if (_.isFunction(selectizeOnRemove)) {
        selectize.on('item_remove', function(value) {
          return selectizeOnRemove.call(viewModel, value);
        });
      }
      //END on
      //END if
      ko.computed({
        disposeWhenNodeIsRemoved: element,
        read: function() {
          values = ko.unwrap(valueAccessor());
          selectize.clearOptions();
          selectize.addOption(generateOptions(values));
          return selectize.refreshOptions(false);
        }
      });
      //END read
      //END computed
      if (allBindings.get('selectizeValue')) {
        observable = allBindings.get('selectizeValue');
        is_setting = false;
        ko.computed({
          disposeWhenNodeIsRemoved: element,
          read: function() {
            values = ko.unwrap(observable);
            if (is_setting) {
              return;
            }
            if (!_.isArray(values)) {
              values = [values];
            }
            values = _.uniq(values);
            return selectize.setValue(values);
          }
        });
        //END read
        //END computed
        if (ko.isObservable(observable)) {
          selectize.on("change", _change = function() {
            var value;
            is_setting = true;
            value = selectize.getValue();
            if (selectize.settings.mode === "multi") {
              if (_.isString(value)) {
                value = value.split(",");
              }
              if (!_.isArray(value)) {
                value = [];
              }
              value = _.chain(value).uniq().compact().value();
            }
            //END if
            observable(value);
            return is_setting = false;
          });
          //END on change
          return Falcon.onDispose(element, function() {
            return selectize.off("change", _change);
          });
        }
      }
    }
  };
})());

//END onDispose
//END if
//END if
//END return
//END selectize binding

},{"../$models/contest.model":57,"../$models/fpt.model":61,"../$models/franchisee.model":64,"../$models/region.model":75,"../$models/user.model":82}],22:[function(require,module,exports){
var User;

User = require('../$models/user.model');

Falcon.addBinding("src", (function() {
  var ERROR_SRC, _loadImage, _resolveFileSrc, _resolveSrc;
  ERROR_SRC = ""; //TODO: Find an image to add as the error source
  _resolveSrc = function(src) {
    src = ko.unwrap(src);
    if (src instanceof Comment) {
      src = src.get('user');
    }
    if (src instanceof User) {
      src = src.get('default_avatar_url');
    }
    return Helpers.trim(src);
  };
  //END _resolveSrc
  _resolveFileSrc = function(src) {
    var mimetype, thumbnail;
    thumbnail = src.get('thumbnail');
    if (!_.isEmpty(thumbnail)) {
      return thumbnail;
    }
    mimetype = Helpers.trim(src.get('mimetype')).toLowerCase();
    thumbnail = (function() {
      switch (mimetype) {
        case 'video/x-ms-asf':
          return "asf.png";
        case 'video/3gpp':
        case 'video/3gpp2':
          return "3gp.png";
        case 'application/x-7z-compressed':
          return "7z.png";
        case 'application/illustrator':
          return "ai.png";
        case 'application/vnd.android.package-archive':
          return "apk.png";
        case 'video/x-ms-asf':
          return "asf.png";
        case 'video/avi':
        case 'video/x-msvideo':
          return "avi.png";
        case 'image/bmp':
          return "bmp.png";
        case 'text/css':
          return "css.png";
        case 'text/csv':
          return "csv.png";
        case 'video/divx':
          return "divx.png";
        case 'application/x-msdownload':
          return "dll.png";
        case 'application/msword':
        case 'application/vnd.ms-word':
          return "doc.png";
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          return "docx.png";
        case 'image/vnd.dwg':
        case 'image/x-dwg':
          return "dwg.png";
        case 'application/postscript':
        case 'application/eps':
        case 'application/x-eps':
        case 'image/eps':
        case 'image/x-eps':
          return "eps.png";
        case 'application/x-msdos-program':
        case 'application/x-msdownload':
          return "exe.png";
        case 'video/x-flv':
          return "flv.png";
        case 'image/gif':
          return "gif.png";
        case 'application/gzip':
          return "gz.png";
        case 'text/html':
          return "html.png";
        case 'image/x-ico':
          return "ico.png";
        case 'application/x-iso9660-image':
          return "iso.png";
        case 'application/java-archive':
          return "jar.png";
        case 'image/jpeg':
          return "jpg.png";
        case 'application/javascript':
        case 'text/javascript':
          return "js.png";
        case 'video/quicktime':
          return "mov.png";
        case 'audio/mpeg':
        case 'audio/mpa':
        case 'audio/mpa-robust':
          return "mp3.png";
        case 'video/mp4':
        case 'audio/mp4':
          return "mp4.png";
        case 'video/mpeg':
          return "mpeg.png";
        case 'application/pdf':
        case 'application/x-pdf':
        case 'application/x-bzpdf':
        case 'application/x-gzpdf':
          return "pdf.png";
        case 'application/x-php':
          return "php.png";
        case 'image/png':
        case 'image/x-png':
          return "png.png";
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.ms-powerpoint.presentation.macroEnabled.12':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          return "ppt.png";
        case 'application/photoshop':
        case 'image/vnd.adobe.photoshop':
        case 'application/psd':
        case 'application/x-photoshop':
        case 'image/photoshop':
        case 'image/psd':
        case 'image/x-photoshop':
        case 'image/x-psd':
          return "psd.png";
        case 'application/rar':
        case 'application/x-rar-compressed':
          return "rar.png";
        case 'image/svg+xml':
          return "svg.png";
        case 'application/vnd.adobe.flash-movie':
        case 'application/x-shockwave-flash':
        case 'application/futuresplash':
          return "swf.png";
        case 'application/x-tar':
        case 'application/tar':
        case 'application/x-gtar':
          return "tar.png";
        case 'image/tiff':
        case 'application/tif':
        case 'application/tiff':
        case 'application/x-tif':
        case 'application/x-tiff':
        case 'image/tif':
        case 'image/x-tif':
        case 'image/x-tiff':
          return "tiff.png";
        case 'text/plain':
          return "txt.png";
        case 'audio/vnd.wave':
        case 'audio/wav':
        case 'audio/wave':
        case 'audio/x-wav':
        case 'audio/s-wav':
          return "wav.png";
        case 'application/zip':
        case 'application/x-compress':
        case 'application/x-compressed':
        case 'application/x-zip':
        case 'application/x-zip-compressed':
        case 'application/zip-compressed':
        case 'application/x-7zip-compressed':
          return "zip.png";
        default:
          return "blank.png";
      }
    })();
    // when '' then "ae.png"
    // when '' then "bak.png"
    // when '' then "cdr.png"
    // when '' then "dw.png"
    // when '' then "fw.png"
    // when '' then "ps.png"
    // when '' then "sys.png"
    //END switch
    return `/images/fileicons/${thumbnail}`;
  };
  //END _resolveFileSrc
  _loadImage = function(element, src, callback) {
    var _complete, _error, _load, image;
    if (element.getAttribute('src') === src) {
      return;
    }
    if ((!_.isString(src)) || _.isEmpty(src)) {
      DOMHelpers.addClass(element, 'loaded');
      element.setAttribute('src', "");
      return typeof callback === "function" ? callback() : void 0;
    }
    //END if
    image = new Image();
    DOMHelpers.removeClass(element, 'loaded');
    _complete = function() {
      DOMHelpers.addClass(element, 'loaded');
      image.removeEventListener('load', _load);
      image.removeEventListener('error', _error);
      return typeof callback === "function" ? callback() : void 0;
    };
    //END _complete
    image.addEventListener('load', _load = function() {
      if (image.height > image.width) {
        DOMHelpers.addClass(element, 'portrait');
        DOMHelpers.removeClass(element, 'landscape');
      } else {
        DOMHelpers.removeClass(element, 'portrait');
        DOMHelpers.addClass(element, 'landscape');
      }
      //END if
      element.setAttribute('src', src);
      return _complete();
    });
    //END load
    image.addEventListener('error', _error = function() {
      element.setAttribute('src', ERROR_SRC);
      return _complete();
    });
    //END addEventListener
    return image.src = src;
  };
  return {
    //END _loadImage
    'init': function(element, valueAccessor, allBindings) {
      var current_src;
      current_src = null;
      return ko.computed({
        disposeWhenNodeIsRemoved: element,
        read: function() {
          var is_loading, src, value;
          value = valueAccessor();
          src = _resolveSrc(value);
          if (src === current_src) {
            return;
          }
          current_src = src;
          is_loading = allBindings.get('srcIsLoading');
          if (ko.isObservable(is_loading)) {
            is_loading(true);
            return _loadImage(element, src, function() {
              return is_loading(false);
            });
          } else {
            return _loadImage(element, src);
          }
        }
      });
    }
  };
})());

//END if
//END read
//END computed
//END init
//END addBinding

},{"../$models/user.model":82}],23:[function(require,module,exports){
//---------------------------------------------
// stopEvent
//---------------------------------------------
Falcon.addBinding('stopEvent', (function() {
  var stop;
  stop = function(event) {
    event.stopPropagation();
    event.preventDefault();
    return false;
  };
  return {
    //END stop
    'init': function(element, valueAccessor) {
      var $element, value;
      $element = $(element);
      value = ko.unwrap(valueAccessor());
      if (!_.isString(value)) {
        value = "";
      }
      if (_.isEmpty(value)) {
        return;
      }
      if (value === 'touch') {
        element.addEventListener('touchstart', stop);
        element.addEventListener('touchend', stop);
      } else if (value === 'mouse') {
        element.addEventListener('mousedown', stop);
        element.addEventListener('mouseup', stop);
        element.addEventListener('click', stop);
      } else {
        element.addEventListener(value, stop);
      }
    }
  };
})());

//END init
//END stopEvent
//END if

},{}],24:[function(require,module,exports){
//---------------------------------------------
// stopPropagation
//---------------------------------------------
Falcon.addBinding('stopPropagation', (function() {
  var stop;
  stop = function(event) {
    return event.stopPropagation();
  };
  return {
    'init': function(element, valueAccessor) {
      var value;
      value = ko.unwrap(valueAccessor());
      if (!_.isString(value)) {
        value = "";
      }
      if (_.isEmpty(value)) {
        return;
      }
      if (value === 'touch') {
        element.addEventListener('touchstart', stop);
        element.addEventListener('touchend', stop);
      } else if (value === 'mouse') {
        element.addEventListener('mousedown', stop);
        element.addEventListener('mouseup', stop);
        element.addEventListener('click', stop);
      } else {
        element.addEventListener(value, stop);
      }
    }
  };
})());

//END stopPropagation
//END init
//END if
Falcon.addBinding('stopBubble', Falcon.getBinding('stopPropagation'));

},{}],25:[function(require,module,exports){
var ContestFinalist, ContestFinalists, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

ContestFinalist = require("../$models/contest_finalist.model");

module.exports = ContestFinalists = (function() {
  class ContestFinalists extends PromiseBaseCollection {};

  ContestFinalists.prototype.model = ContestFinalist;

  ContestFinalists.prototype.label = "ContestFinalists";

  return ContestFinalists;

}).call(this);

//END ContestFinalists

},{"../$models/contest_finalist.model":58,"./promise.base.collection":36}],26:[function(require,module,exports){
var ContestWinner, ContestWinners, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

ContestWinner = require("../$models/contest_winner.model");

module.exports = ContestWinners = (function() {
  class ContestWinners extends PromiseBaseCollection {};

  ContestWinners.prototype.model = ContestWinner;

  ContestWinners.prototype.label = "ContestWinners";

  return ContestWinners;

}).call(this);

//END ContestWinners

},{"../$models/contest_winner.model":59,"./promise.base.collection":36}],27:[function(require,module,exports){
var Contest, Contests, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

Contest = require("../$models/contest.model");

module.exports = Contests = (function() {
  class Contests extends PromiseBaseCollection {};

  Contests.prototype.model = Contest;

  Contests.prototype.label = "Contests";

  Contests.prototype.observables = {
    'sorted': function() {
      return this.sort((a, b) => {
        var a_end_date, a_type, b_end_date, b_type;
        a_type = a.get("type");
        b_type = b.get("type");
        if ((a_type === Contest.FRANCHISEE_TYPE) && (b_type !== Contest.FRANCHISEE_TYPE)) {
          return -1;
        }
        if ((a_type !== Contest.FRANCHISEE_TYPE) && (b_type === Contest.FRANCHISEE_TYPE)) {
          return 1;
        }
        if ((a_type === Contest.FPT_TYPE) && (b_type !== Contest.FPT_TYPE)) {
          return -1;
        }
        if ((a_type !== Contest.FPT_TYPE) && (b_type === Contest.FPT_TYPE)) {
          return 1;
        }
        if ((a_type === Contest.GLOBAL_TYPE) && (b_type !== Contest.GLOBAL_TYPE)) {
          return -1;
        }
        if ((a_type !== Contest.GLOBAL_TYPE) && (b_type === Contest.GLOBAL_TYPE)) {
          return 1;
        }
        a_end_date = moment(a.get("end_date"));
        b_end_date = moment(b.get("end_date"));
        if (a_end_date.isBefore(b_end_date)) {
          return -1;
        }
        if (a_end_date.isAfter(b_end_date)) {
          return 1;
        }
        return 0;
      });
    }
  };

  return Contests;

}).call(this);

//END observables
//END Contests

},{"../$models/contest.model":57,"./promise.base.collection":36}],28:[function(require,module,exports){
var Entries, Entry, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

Entry = require("../$models/entry.model");

module.exports = Entries = (function() {
  class Entries extends PromiseBaseCollection {};

  Entries.prototype.model = Entry;

  Entries.prototype.label = "Entries";

  return Entries;

}).call(this);

//END Entries

},{"../$models/entry.model":60,"./promise.base.collection":36}],29:[function(require,module,exports){
var FPTContestStatistic, FPTContestStatistics, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

FPTContestStatistic = require("../$models/fpt_contest_statistic.model");

module.exports = FPTContestStatistics = (function() {
  class FPTContestStatistics extends PromiseBaseCollection {};

  FPTContestStatistics.prototype.model = FPTContestStatistic;

  FPTContestStatistics.prototype.label = "FPTContestStatistics";

  return FPTContestStatistics;

}).call(this);

//END FPTContestStatistics

},{"../$models/fpt_contest_statistic.model":62,"./promise.base.collection":36}],30:[function(require,module,exports){
var FPTStatistic, FPTStatistics, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

FPTStatistic = require("../$models/fpt_statistic.model");

module.exports = FPTStatistics = (function() {
  class FPTStatistics extends PromiseBaseCollection {};

  FPTStatistics.prototype.model = FPTStatistic;

  FPTStatistics.prototype.label = "FPTStatistics";

  return FPTStatistics;

}).call(this);

//END FPTStatistics

},{"../$models/fpt_statistic.model":63,"./promise.base.collection":36}],31:[function(require,module,exports){
var FPT, FPTs, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

FPT = require("../$models/fpt.model");

module.exports = FPTs = (function() {
  class FPTs extends PromiseBaseCollection {};

  FPTs.prototype.model = FPT;

  FPTs.prototype.label = "FPTs";

  return FPTs;

}).call(this);

//END FPTs

},{"../$models/fpt.model":61,"./promise.base.collection":36}],32:[function(require,module,exports){
var FranchiseeContestStatistic, FranchiseeContestStatistics, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

FranchiseeContestStatistic = require("../$models/franchisee_contest_statistic.model");

module.exports = FranchiseeContestStatistics = (function() {
  class FranchiseeContestStatistics extends PromiseBaseCollection {};

  FranchiseeContestStatistics.prototype.model = FranchiseeContestStatistic;

  FranchiseeContestStatistics.prototype.label = "FranchiseeContestStatistics";

  return FranchiseeContestStatistics;

}).call(this);

//END FranchiseeContestStatistics

},{"../$models/franchisee_contest_statistic.model":65,"./promise.base.collection":36}],33:[function(require,module,exports){
var FranchiseeSetting, FranchiseeSettings, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

FranchiseeSetting = require("../$models/franchisee_setting.model");

module.exports = FranchiseeSettings = (function() {
  class FranchiseeSettings extends PromiseBaseCollection {};

  FranchiseeSettings.prototype.model = FranchiseeSetting;

  FranchiseeSettings.prototype.label = "FranchiseeSettings";

  return FranchiseeSettings;

}).call(this);

//END FranchiseeSettings

},{"../$models/franchisee_setting.model":66,"./promise.base.collection":36}],34:[function(require,module,exports){
var FranchiseeStatistic, FranchiseeStatistics, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

FranchiseeStatistic = require("../$models/franchisee_statistic.model");

module.exports = FranchiseeStatistics = (function() {
  class FranchiseeStatistics extends PromiseBaseCollection {};

  FranchiseeStatistics.prototype.model = FranchiseeStatistic;

  FranchiseeStatistics.prototype.label = "FranchiseeStatistics";

  return FranchiseeStatistics;

}).call(this);

//END FranchiseeStatistics

},{"../$models/franchisee_statistic.model":67,"./promise.base.collection":36}],35:[function(require,module,exports){
var Franchisee, Franchisees, PromiseBaseCollection;

PromiseBaseCollection = require("./promise.base.collection");

Franchisee = require("../$models/franchisee.model");

module.exports = Franchisees = (function() {
  class Franchisees extends PromiseBaseCollection {};

  Franchisees.prototype.model = Franchisee;

  Franchisees.prototype.label = "Franchisees";

  return Franchisees;

}).call(this);

//END Franchisees

},{"../$models/franchisee.model":64,"./promise.base.collection":36}],36:[function(require,module,exports){
var PromiseBaseCollection,
  splice = [].splice;

module.exports = PromiseBaseCollection = (function() {
  var DATETIME_FORMAT, makeFilterKey;

  class PromiseBaseCollection extends Falcon.Collection {
    constructor() {
      super(...arguments);
      this.hasNextPage = ko.observable(true);
      this.sort_key = ko.observable(this.sort_key);
      this.sort_parameter = ko.observable(this.sort_parameter);
      this.sort_direction = ko.observable(this.sort_direction);
    }

    //END constructor
    promiseFetch(options) {
      return Q.Promise((resolve, reject) => {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, `An error occurred while fetching ${this.label}`);
        return this.fetch(options);
      });
    }

    //END promiseFetch
    promiseFetchNextPage(options = {}) {
      return Q.Promise((resolve, reject) => {
        var next_page_number, previous_page_number;
        previous_page_number = this.getPageNumber();
        next_page_number = (previous_page_number != null ? previous_page_number : 1) + 1;
        this.setPageNumber(next_page_number);
        if (options['fill_options'] == null) {
          options['fill_options'] = {
            'method': 'append'
          };
        }
        return this.promiseFetch(options).then(resolve).fail((error) => {
          this.setPageNumber(previous_page_number);
          return reject(error);
        });
      });
    }

    //END promiseFetchNextPage
    promiseCreateAll(options) {
      return Q.Promise((resolve, reject) => {
        var promises;
        promises = [];
        this.each((model) => {
          return promises.push(model.promiseCreate(options));
        });
        //END each
        return Q.all(promises).then(resolve, reject);
      });
    }

    //END promiseCreateAll
    parseResponseData(data, type, options) {
      if (type === Falcon.DELETE) {
        return [];
      }
      return this.model.prototype.expand(data).toArray();
    }

    //END parseResponseData
    sync(type, options, context) {
      var filter, previous_length, ref, success, value;
      if (_.isFunction(options)) {
        options = {
          complete: options
        };
      }
      if (!_.isObject(options)) {
        options = {};
      }
      if (options['params'] == null) {
        options['params'] = {};
      }
      if (this.filters != null) {
        ref = this.filters;
        for (filter in ref) {
          value = ref[filter];
          if (!(!(filter in options['params']))) {
            continue;
          }
          value = ko.unwrap(value);
          options['params'][filter] = encodeURIComponent((function() {
            switch (false) {
              case !_.isArray(value):
                return value.join(",");
              case !Falcon.isCollection(value):
                return value.pluck("id").join(",");
              case !Falcon.isModel(value):
                return value.get("id");
              case !_.isDate(value):
                return moment(value).format();
              default:
                return value;
            }
          })());
        }
      }
      //END switch
      //END for
      //END if
      if (this.is_paged) {
        if (this.hasPageSize()) {
          options['params']['page[size]'] = this.getPageSize();
        }
        if (this.hasPageNumber()) {
          options['params']['page[number]'] = this.getPageNumber();
        }
      } else {
        options['params']['page'] = false;
      }
      if (this.hasSort()) {
        //END if
        options['params']['sort'] = encodeURIComponent(this.getSortQueryParam());
      }
      previous_length = this.length();
      success = options['success'];
      options['success'] = (collection, response) => {
        var count, has_next_page, number, page, ref1, size;
        has_next_page = false;
        this.meta = (ref1 = response != null ? response['meta'] : void 0) != null ? ref1 : null;
        if (this.meta != null) {
          ({count, page} = this.meta);
          this.count = count;
          if (page != null) {
            ({size, number} = page);
            this.setPageSize(size);
            this.setPageNumber(number);
            if ((size != null) && (number != null) && (count != null)) {
              has_next_page = (size * number) < this.count;
            }
          }
        } else {
          //END if
          //END if
          has_next_page = previous_length !== this.length();
        }
        //END if
        this.hasNextPage(has_next_page);
        return success != null ? success.call(this, collection, response) : void 0;
      };
      //END success
      return super.sync(type, options, context);
    }

    //END makeFilterKey
    clearFilters() {
      this.filters = null;
      return this;
    }

    //END clearFilters
    clearFilter(...keys) {
      var key;
      if (this.filters == null) {
        return this;
      }
      key = makeFilterKey(keys);
      if (!(key in this.filters)) {
        return this;
      }
      delete this.filters[key];
      return this;
    }

    //END clearFilter
    getFilter(...keys) {
      var key;
      if (this.filters == null) {
        return void 0;
      }
      key = makeFilterKey(keys);
      return this.filters[key];
    }

    //END getFilter
    setFilter(...keys) {
      var key, limit, ref, value;
      ref = keys, [...keys] = ref, [value] = splice.call(keys, -1);
      key = makeFilterKey(keys);
      if (this.filters == null) {
        this.filters = {};
      }
      this.filters[key] = value;
      limit = Helpers.trim(limit).toLowerCase();
      return this;
    }

    //END setFilter
    toggleFilter(...keys) {
      var is_empty, ref, value;
      ref = keys, [...keys] = ref, [value] = splice.call(keys, -1);
      is_empty = (function() {
        switch (false) {
          case !_.isArray(value):
            return value.length === 0;
          case !_.isString(value):
            return value.length === 0;
          case !Falcon.isCollection(value):
            return value.length() === 0;
          default:
            return value == null;
        }
      })();
      //END switch
      if (is_empty) {
        this.clearFilter(...keys);
      } else {
        this.setFilter(...keys, value);
      }
      //END if
      return this;
    }

    //END toggleFilter
    getIsPaged() {
      return this.is_paged;
    }

    setIsPaged(is_paged) {
      this.is_paged = is_paged;
      return this;
    }

    //END setIsPaged
    getPageSize() {
      return this.page_size;
    }

    hasPageSize() {
      return this.page_size != null;
    }

    setPageSize(size) {
      this.page_size = size;
      return this;
    }

    //END setPageSize
    getPageNumber() {
      return this.page_number;
    }

    hasPageNumber() {
      return this.page_number != null;
    }

    setPageNumber(number) {
      this.page_number = number;
      return this;
    }

    //END setPageNumber
    hasSort() {
      return this.sort_key() != null;
    }

    sortBy(key, direction = "asc", parameter = null) {
      if (key == null) {
        this.clearSort();
      }
      if (!_.isString(key)) {
        throw new Error("key must be a String");
      }
      //END unless
      this.setSortKey(key);
      this.setSortDirection(direction);
      this.setSortParameter(parameter);
      return this;
    }

    //END sortBy
    clearSort() {
      this.sort_key(null);
      this.sort_direction(null);
      this.sort_parameter(null);
      return this;
    }

    //END clear Sort
    getSortQueryParam() {
      var sort_query_param;
      if (!this.hasSort()) {
        return null;
      }
      sort_query_param = "";
      if (this.getSortDirection() === "descending") {
        sort_query_param = "-";
      } else {
        sort_query_param = "+";
      }
      //END if
      sort_query_param += this.getSortKey();
      if (this.hasSortParameter()) {
        sort_query_param += `[${this.getSortParameter()}]`;
      }
      //END if
      return sort_query_param;
    }

    //END getSortQueryParam
    getSortKey() {
      return this.sort_key();
    }

    hasSortKey() {
      return this.sort_key() != null;
    }

    setSortKey(key) {
      this.sort_key(key);
      return this;
    }

    //END setSortKey
    getSortDirection() {
      var ref;
      if ((ref = this.sort_direction()) === "-" || ref === "desc" || ref === "descending") {
        return "descending";
      } else {
        return "ascending";
      }
    }

    //END if
    //END getSortDirection
    setSortDirection(sort_direction) {
      if (!_.isString(sort_direction)) {
        sort_direction = "ascending";
      }
      sort_direction = Helpers.trim(sort_direction).toLowerCase();
      if (sort_direction === "-" || sort_direction === "desc" || sort_direction === "descending") {
        this.sort_direction("descending");
      } else {
        this.sort_direction("ascending");
      }
      //END if
      return this;
    }

    //END setSortDirection
    toggleSortDirection() {
      if (this.getSortDirection() === "descending") {
        this.setSortDirection("ascending");
      } else {
        this.setSortDirection("descending");
      }
      //END if
      return this;
    }

    //END toggleSortDirection
    getSortParameter() {
      return this.sort_parameter();
    }

    hasSortParameter() {
      return this.sort_parameter() != null;
    }

    setSortParameter(parameter) {
      this.sort_parameter(parameter);
      return this;
    }

    //END setSortParameter
    clearSortParameter() {
      return this.setSortParameter(null);
    }

    clone() {
      var clone;
      clone = super.clone(...arguments);
      clone.filters = _.clone(this.filters);
      clone.sort_key = this.sort_key;
      clone.sort_direction = this.sort_direction;
      clone.page_size = this.page_size;
      clone.page_number = this.page_number;
      return clone;
    }

    //END clone
    reset() {
      var ret;
      ret = super.reset(...arguments);
      this.page_size = null;
      this.page_number = null;
      this.hasNextPage(true);
      return ret;
    }

    //END reset
    hardReset() {
      var ret;
      ret = this.reset();
      this.filters = null;
      this.sort_key = null;
      this.sort_direction = "+";
      return ret;
    }

  };

  DATETIME_FORMAT = "";

  PromiseBaseCollection.prototype.label = "";

  PromiseBaseCollection.prototype.filters = null;

  PromiseBaseCollection.prototype.meta = null;

  PromiseBaseCollection.prototype.count = null;

  PromiseBaseCollection.prototype.is_paged = true;

  PromiseBaseCollection.prototype.page_size = null;

  PromiseBaseCollection.prototype.page_number = null;

  PromiseBaseCollection.prototype.hasNextPage = null; //Becomes an obsevable

  PromiseBaseCollection.prototype.sort_key = null;

  PromiseBaseCollection.prototype.sort_parameter = null;

  PromiseBaseCollection.prototype.sort_direction = null;

  //END sync
  makeFilterKey = function(keys) {
    var i, k, key, len;
    key = 'filter';
    for (i = 0, len = keys.length; i < len; i++) {
      k = keys[i];
      key += `[${k}]`;
    }
    return key;
  };

  return PromiseBaseCollection;

}).call(this);

//END hardReset
//END class

},{}],37:[function(require,module,exports){
var PromiseBaseCollection, Question, Questions;

PromiseBaseCollection = require("./promise.base.collection");

Question = require("../$models/question.model");

module.exports = Questions = (function() {
  class Questions extends PromiseBaseCollection {};

  Questions.prototype.model = Question;

  Questions.prototype.label = "Questions";

  return Questions;

}).call(this);

//END Questions

},{"../$models/question.model":71,"./promise.base.collection":36}],38:[function(require,module,exports){
var PromiseBaseCollection, RaceOption, RaceOptions;

PromiseBaseCollection = require("./promise.base.collection");

RaceOption = require("../$models/race_option.model");

module.exports = RaceOptions = (function() {
  class RaceOptions extends PromiseBaseCollection {};

  RaceOptions.prototype.model = RaceOption;

  RaceOptions.prototype.label = "RaceOptions";

  return RaceOptions;

}).call(this);

//END RaceOptions

},{"../$models/race_option.model":73,"./promise.base.collection":36}],39:[function(require,module,exports){
var PromiseBaseCollection, RaceSelection, RaceSelections;

PromiseBaseCollection = require("./promise.base.collection");

RaceSelection = require("../$models/race_selection.model");

module.exports = RaceSelections = (function() {
  class RaceSelections extends PromiseBaseCollection {};

  RaceSelections.prototype.model = RaceSelection;

  RaceSelections.prototype.label = "RaceSelections";

  return RaceSelections;

}).call(this);

//END Surveys

},{"../$models/race_selection.model":74,"./promise.base.collection":36}],40:[function(require,module,exports){
var PromiseBaseCollection, Race, Races;

PromiseBaseCollection = require("./promise.base.collection");

Race = require("../$models/race.model");

module.exports = Races = (function() {
  class Races extends PromiseBaseCollection {};

  Races.prototype.model = Race;

  Races.prototype.label = "Races";

  return Races;

}).call(this);

//END Races

},{"../$models/race.model":72,"./promise.base.collection":36}],41:[function(require,module,exports){
var PromiseBaseCollection, RegionContestStatistic, RegionContestStatistics;

PromiseBaseCollection = require("./promise.base.collection");

RegionContestStatistic = require("../$models/region_contest_statistic.model");

module.exports = RegionContestStatistics = (function() {
  class RegionContestStatistics extends PromiseBaseCollection {};

  RegionContestStatistics.prototype.model = RegionContestStatistic;

  RegionContestStatistics.prototype.label = "RegionContestStatistics";

  return RegionContestStatistics;

}).call(this);

//END RegionContestStatistics

},{"../$models/region_contest_statistic.model":76,"./promise.base.collection":36}],42:[function(require,module,exports){
var PromiseBaseCollection, RegionStatistic, RegionStatistics;

PromiseBaseCollection = require("./promise.base.collection");

RegionStatistic = require("../$models/region_statistic.model");

module.exports = RegionStatistics = (function() {
  class RegionStatistics extends PromiseBaseCollection {};

  RegionStatistics.prototype.model = RegionStatistic;

  RegionStatistics.prototype.label = "RegionStatistics";

  return RegionStatistics;

}).call(this);

//END RegionStatistics

},{"../$models/region_statistic.model":77,"./promise.base.collection":36}],43:[function(require,module,exports){
var PromiseBaseCollection, Region, Regions;

PromiseBaseCollection = require("./promise.base.collection");

Region = require("../$models/region.model");

module.exports = Regions = (function() {
  class Regions extends PromiseBaseCollection {};

  Regions.prototype.model = Region;

  Regions.prototype.label = "Regions";

  return Regions;

}).call(this);

//END Regions

},{"../$models/region.model":75,"./promise.base.collection":36}],44:[function(require,module,exports){
var PromiseBaseCollection, SurveyAnswer, SurveyAnswers;

PromiseBaseCollection = require("./promise.base.collection");

SurveyAnswer = require("../$models/survey_answer.model");

module.exports = SurveyAnswers = (function() {
  class SurveyAnswers extends PromiseBaseCollection {};

  SurveyAnswers.prototype.model = SurveyAnswer;

  SurveyAnswers.prototype.label = "SurveyAnswers";

  return SurveyAnswers;

}).call(this);

//END SurveyAnswers

},{"../$models/survey_answer.model":80,"./promise.base.collection":36}],45:[function(require,module,exports){
var PromiseBaseCollection, SurveyResponse, SurveyResponses;

PromiseBaseCollection = require("./promise.base.collection");

SurveyResponse = require("../$models/survey_response.model");

module.exports = SurveyResponses = (function() {
  class SurveyResponses extends PromiseBaseCollection {};

  SurveyResponses.prototype.model = SurveyResponse;

  SurveyResponses.prototype.label = "SurveyResponses";

  return SurveyResponses;

}).call(this);

//END Surveys

},{"../$models/survey_response.model":81,"./promise.base.collection":36}],46:[function(require,module,exports){
var PromiseBaseCollection, Survey, Surveys;

PromiseBaseCollection = require("./promise.base.collection");

Survey = require("../$models/survey.model");

module.exports = Surveys = (function() {
  class Surveys extends PromiseBaseCollection {};

  Surveys.prototype.model = Survey;

  Surveys.prototype.label = "Surveys";

  return Surveys;

}).call(this);

//END Surveys

},{"../$models/survey.model":79,"./promise.base.collection":36}],47:[function(require,module,exports){
var PromiseBaseCollection, UserContestStatistic, UserContestStatistics;

PromiseBaseCollection = require("./promise.base.collection");

UserContestStatistic = require("../$models/user_contest_statistic.model");

module.exports = UserContestStatistics = (function() {
  class UserContestStatistics extends PromiseBaseCollection {};

  UserContestStatistics.prototype.model = UserContestStatistic;

  UserContestStatistics.prototype.label = "UserContestStatistics";

  return UserContestStatistics;

}).call(this);

//END UserContestStatistics

},{"../$models/user_contest_statistic.model":83,"./promise.base.collection":36}],48:[function(require,module,exports){
var PromiseBaseCollection, User, Users;

PromiseBaseCollection = require("./promise.base.collection");

User = require("../$models/user.model");

module.exports = Users = (function() {
  class Users extends PromiseBaseCollection {};

  Users.prototype.model = User;

  Users.prototype.label = "Users";

  return Users;

}).call(this);

//END Users

},{"../$models/user.model":82,"./promise.base.collection":36}],49:[function(require,module,exports){
module.exports = {
  URL_REGEX: /(https?:\/\/)?(([^\s]+\.)?[^\s]+\.[^\s]+)/gi,
  STRICT_URL_REGEX: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]+)([\/\w \.-]*)*\/?$/i,
  EMAIL_REGEX: /^([a-z0-9_\.\+\-]+)@([\da-z\.\+\-]+)\.([a-z\.]+)$/i,
  UUID_REGEX: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
  PASSWORD_REGEX: /^([^\s]{5}[^\s]+)$/i,
  HASHTAG_REGEX: /#([a-zA-Z0-9\-_]+)/gi,
  HTML_TAG_REGEX: /<[^>]+>/gi,
  DATE_FORMAT: "M/D/YYYY"
};

},{}],50:[function(require,module,exports){
var STATES;

STATES = [];

STATES.push(STATES['AL'] = {
  abbr: "AL",
  name: "Alabama"
});

STATES.push(STATES['AK'] = {
  abbr: "AK",
  name: "Alaska"
});

STATES.push(STATES['AZ'] = {
  abbr: "AZ",
  name: "Arizona"
});

STATES.push(STATES['AR'] = {
  abbr: "AR",
  name: "Arkansas"
});

STATES.push(STATES['CA'] = {
  abbr: "CA",
  name: "California"
});

STATES.push(STATES['CO'] = {
  abbr: "CO",
  name: "Colorado"
});

STATES.push(STATES['CT'] = {
  abbr: "CT",
  name: "Connecticut"
});

STATES.push(STATES['DE'] = {
  abbr: "DE",
  name: "Delaware"
});

STATES.push(STATES['DC'] = {
  abbr: "DC",
  name: "District Of Columbia"
});

STATES.push(STATES['FL'] = {
  abbr: "FL",
  name: "Florida"
});

STATES.push(STATES['GA'] = {
  abbr: "GA",
  name: "Georgia"
});

STATES.push(STATES['HI'] = {
  abbr: "HI",
  name: "Hawaii"
});

STATES.push(STATES['ID'] = {
  abbr: "ID",
  name: "Idaho"
});

STATES.push(STATES['IL'] = {
  abbr: "IL",
  name: "Illinois"
});

STATES.push(STATES['IN'] = {
  abbr: "IN",
  name: "Indiana"
});

STATES.push(STATES['IA'] = {
  abbr: "IA",
  name: "Iowa"
});

STATES.push(STATES['KS'] = {
  abbr: "KS",
  name: "Kansas"
});

STATES.push(STATES['KY'] = {
  abbr: "KY",
  name: "Kentucky"
});

STATES.push(STATES['LA'] = {
  abbr: "LA",
  name: "Louisiana"
});

STATES.push(STATES['ME'] = {
  abbr: "ME",
  name: "Maine"
});

STATES.push(STATES['MD'] = {
  abbr: "MD",
  name: "Maryland"
});

STATES.push(STATES['MA'] = {
  abbr: "MA",
  name: "Massachusetts"
});

STATES.push(STATES['MI'] = {
  abbr: "MI",
  name: "Michigan"
});

STATES.push(STATES['MN'] = {
  abbr: "MN",
  name: "Minnesota"
});

STATES.push(STATES['MS'] = {
  abbr: "MS",
  name: "Mississippi"
});

STATES.push(STATES['MO'] = {
  abbr: "MO",
  name: "Missouri"
});

STATES.push(STATES['MT'] = {
  abbr: "MT",
  name: "Montana"
});

STATES.push(STATES['NE'] = {
  abbr: "NE",
  name: "Nebraska"
});

STATES.push(STATES['NV'] = {
  abbr: "NV",
  name: "Nevada"
});

STATES.push(STATES['NH'] = {
  abbr: "NH",
  name: "New Hampshire"
});

STATES.push(STATES['NJ'] = {
  abbr: "NJ",
  name: "New Jersey"
});

STATES.push(STATES['NM'] = {
  abbr: "NM",
  name: "New Mexico"
});

STATES.push(STATES['NY'] = {
  abbr: "NY",
  name: "New York"
});

STATES.push(STATES['NC'] = {
  abbr: "NC",
  name: "North Carolina"
});

STATES.push(STATES['ND'] = {
  abbr: "ND",
  name: "North Dakota"
});

STATES.push(STATES['OH'] = {
  abbr: "OH",
  name: "Ohio"
});

STATES.push(STATES['OK'] = {
  abbr: "OK",
  name: "Oklahoma"
});

STATES.push(STATES['OR'] = {
  abbr: "OR",
  name: "Oregon"
});

STATES.push(STATES['PA'] = {
  abbr: "PA",
  name: "Pennsylvania"
});

STATES.push(STATES['RI'] = {
  abbr: "RI",
  name: "Rhode Island"
});

STATES.push(STATES['SC'] = {
  abbr: "SC",
  name: "South Carolina"
});

STATES.push(STATES['SD'] = {
  abbr: "SD",
  name: "South Dakota"
});

STATES.push(STATES['TN'] = {
  abbr: "TN",
  name: "Tennessee"
});

STATES.push(STATES['TX'] = {
  abbr: "TX",
  name: "Texas"
});

STATES.push(STATES['UT'] = {
  abbr: "UT",
  name: "Utah"
});

STATES.push(STATES['VT'] = {
  abbr: "VT",
  name: "Vermont"
});

STATES.push(STATES['VA'] = {
  abbr: "VA",
  name: "Virginia"
});

STATES.push(STATES['WA'] = {
  abbr: "WA",
  name: "Washington"
});

STATES.push(STATES['WV'] = {
  abbr: "WV",
  name: "West Virginia"
});

STATES.push(STATES['WI'] = {
  abbr: "WI",
  name: "Wisconsin"
});

STATES.push(STATES['WY'] = {
  abbr: "WY",
  name: "Wyoming"
});

module.exports = STATES;

},{}],51:[function(require,module,exports){
var EMAIL_REGEX, Helpers, PASSWORD_REGEX, STRICT_URL_REGEX, URL_REGEX, UUID_REGEX;

({URL_REGEX, EMAIL_REGEX, STRICT_URL_REGEX, PASSWORD_REGEX, UUID_REGEX} = require("../$constants/default.constants"));

module.exports = Helpers = new ((function() {
  var _Class;

  _Class = class {
    //END if
    //END trim
    trimSlashes(str) {
      return (str != null ? str : "").toString().replace(/^\/+/, '').replace(/\/+$/, '');
    }

    reduceSlashes(str) {
      return Helpers.trimSlashes(str).replace(/\/\/+/gi, '/');
    }

    injectHTMLEntities(str) {
      return str.replace("&", "&amp;").replace("<", "&lt;").replace(">", "&gt;").replace("  ", " &nbsp;");
    }

    //END injectHTMLEntities
    injectAnchorTags(str) {
      var label, match, protocol, regex, returned_str, start_index, url;
      returned_str = "";
      regex = new RegExp(URL_REGEX);
      start_index = 0;
      while (match = regex.exec(str)) {
        returned_str += str.slice(start_index, match.index);
        start_index = regex.lastIndex;
        [label, protocol, url] = match;
        if (protocol == null) {
          protocol = "http://";
        }
        url = protocol + url;
        returned_str += `<a href=\"${url}\">${label}</a>`;
      }
      //END while
      returned_str += str.slice(start_index);
      return returned_str;
    }

    //END injectAnchorTags

      //--------------------------------------------------------------
    // Method: concat
    //	Concatenates all of the values, observable or not into a single
    //	string.
    //--------------------------------------------------------------
    concat() {
      var arg, i, len, ret;
      ret = "";
      for (i = 0, len = arguments.length; i < len; i++) {
        arg = arguments[i];
        arg = ko.unwrap(arg);
        if (arg != null) {
          ret += arg.toString();
        }
      }
      //END for
      return ret;
    }

    //END concat
    join(arr, glue) {
      arr = ko.unwrap(arr);
      if (!_.isArray(arr)) {
        arr = [];
      }
      return arr.join(glue);
    }

    //END join

      //--------------------------------------------------------------
    // Method: isEmail
    //	Checks to see if the string or observable is an email address
    //--------------------------------------------------------------
    isEmail(emailStr) {
      emailStr = ko.unwrap(emailStr);
      if (!_.isString(emailStr)) {
        return false;
      }
      emailStr = Helpers.trim(emailStr);
      return (new RegExp(EMAIL_REGEX)).test(emailStr);
    }

    //END isEmail

      //--------------------------------------------------------------
    // Method: isUrl
    //	Checks to see if the string or observable is a url
    //--------------------------------------------------------------
    isUrl(urlStr) {
      urlStr = ko.unwrap(urlStr);
      if (!_.isString(urlStr)) {
        return false;
      }
      urlStr = Helpers.trim(urlStr);
      return (new RegExp(STRICT_URL_REGEX)).test(urlStr);
    }

    //END isUrl
    hasUrl(string) {
      if (!_.isString(string)) {
        return false;
      }
      return (new RegExp(URL_REGEX)).test(string);
    }

    //END hasUrl
    isPassword(password) {
      password = ko.unwrap(password);
      if (!_.isString(password)) {
        return false;
      }
      return (new RegExp(PASSWORD_REGEX)).test(password);
    }

    //END isPassword
    isUUID(uuid) {
      uuid = ko.unwrap(uuid);
      if (!_.isString(uuid)) {
        return false;
      }
      return (new RegExp(UUID_REGEX)).test(uuid);
    }

    //END isUUID
    makeErrorData(error) {
      return {
        errors: [error]
      };
    }

    parseError(response, default_human = "An error occurred") {
      var ref;
      if (response instanceof Error) {
        return {
          human: response.message
        };
      }
      if (!_.isObject(response)) {
        return {
          human: default_human
        };
      }
      if (!response.hasOwnProperty('human')) {
        return {
          human: default_human
        };
      }
      return {
        human: (ref = response.human) != null ? ref : default_human,
        //TODO: Add Validations
        validations: {}
      };
    }

    //END parseError
    parseDate(date_string) {
      var date;
      date = date_string;
      return date;
    }

    //END parseDate
    parseInt(value) {
      if (value === null) {
        return null;
      }
      value = parseInt(value);
      if (_.isNaN(value)) {
        return null;
      } else {
        return value;
      }
    }

    //END parseInt

      //--------------------------------------------------------------
    // Method: pluralize
    //	Simple if statement to pluralize a label based on a count value
    //--------------------------------------------------------------
    pluralize(count, one_label, many_label) {
      count = ko.unwrap(count);
      if (count === 1) {
        return `${count} ${one_label}`;
      } else {
        return `${count} ${many_label}`;
      }
    }

    //END if
    //END pluralize
    possessive(obs) {
      var value;
      value = Helpers.trim(ko.unwrap(obs));
      if (!_.isString(value)) {
        return "";
      }
      if (value.lastIndexOf("s") === value.length - 1) {
        return `${value}'`;
      } else {
        return `${value}'s`;
      }
    }

    //END if
    //END possessive

      //--------------------------------------------------------------
    // Method: toggle
    //	Toggles a label based on a predicate value
    //--------------------------------------------------------------
    toggle(predicate, true_value, false_value) {
      predicate = ko.unwrap(predicate);
      if (_.isNumber(predicate)) {
        predicate = predicate === 1;
      }
      return (predicate ? true_value : false_value);
    }

    //END toggle
    isLessThan(a, b) {
      a = ko.unwrap(a);
      b = ko.unwrap(b);
      return a < b;
    }

    //END isLessThan
    isGreaterThan(a, b) {
      a = ko.unwrap(a);
      b = ko.unwrap(b);
      return a > b;
    }

    //END isGreaterThan

      //--------------------------------------------------------------
    // Method: isBetween
    //	Checks if a value is in between a range, exclusive
    //--------------------------------------------------------------
    isBetween(count, min, max) {
      count = ko.unwrap(count);
      if (count <= min) {
        return false;
      }
      if (count >= max) {
        return false;
      }
      return true;
    }

    //END isBetween

      //--------------------------------------------------------------
    // Method: isntBetween
    //	Checks if a value is in between a range, exclusive
    //--------------------------------------------------------------
    isntBetween(count, min, max) {
      return !Helpers.isBetween(...arguments);
    }

    not(value) {
      return !ko.unwrap(value);
    }

    //--------------------------------------------------------------
    // Method: formatUrl
    //	Formats the url properly
    //--------------------------------------------------------------
    formatUrl(url) {
      var has_protocol;
      url = Helpers.trim(ko.unwrap(url));
      has_protocol = (url.toLowerCase().indexOf("http://") === 0) || (url.toLowerCase().indexOf("https://") === 0);
      if (!has_protocol) {
        url = `http://${url}`;
      }
      return url;
    }

    //END formatUrl
    compare(a, b) {
      a = ko.unwrap(a);
      b = ko.unwrap(b);
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }

    //END compare
    compareInt(a, b) {
      a = parseInt(ko.unwrap(a));
      b = parseInt(ko.unwrap(b));
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }

    //END compareInt
    compareFloat(a, b) {
      a = parseFloat(ko.unwrap(a));
      b = parseFloat(ko.unwrap(b));
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    }

    //END compareFloat
    regexIndexOf(str, regex, offset = 0) {
      var index;
      if (!_.isString(str)) {
        return -1;
      }
      if (!_.isRegExp(regex)) {
        return -1;
      }
      index = str.substring(offset).search(regex);
      return (index < 0 ? -1 : index + offset);
    }

    //END regexIndexOf
    randomId() {
      return Math.floor(Math.random() * 1000000000 + 1);
    }

    hasWord(string, word) {
      var regex, regex_str;
      string = Helpers.trim(ko.unwrap(string)) + " ";
      regex_str = Helpers.trim(ko.unwrap(word)).replace(/([!$^{[.+\\(?])/gi, "\\$1");
      regex = new RegExp(`${regex_str}([^a-zA-Z0-9-_])`, "gi");
      return regex.test(string);
    }

    //END hasWord
    equals(one, two, strict = true) {
      if (strict) {
        return ko.unwrap(one) === ko.unwrap(two);
      } else {
        return ko.unwrap(one) === ko.unwrap(two);
      }
    }

    //END if
    //END equals
    padLeft(string, padding, length) {
      if (!((padding != null) && padding.length > 0)) {
        return string;
      }
      while (string.length < length) {
        string = `${padding}${string}`;
      }
      //END while
      return string;
    }

  };

  _Class.prototype.IS_SAFARI = navigator.userAgent.indexOf("Safari") > -1;

  //--------------------------------------------------------------
  // Method: trim
  //	Trims white space from the beginning and end of a string
  //--------------------------------------------------------------
  _Class.prototype.trim = (function() {
    if (String.prototype.trim != null) {
      return function(str) {
        return String.prototype.trim.call((str != null ? str : "").toString());
      };
    } else {
      return function(str) {
        return (str != null ? str : "").toString().replace(/^\s+/, '').replace(/\s+$/, '');
      };
    }
  })();

  return _Class;

}).call(this))();

//END padLeft
//END Helpers

},{"../$constants/default.constants":49}],52:[function(require,module,exports){
var DOMHelpers;

window.DOMHelpers = module.exports = DOMHelpers = new (class {
  defer(duration, callback) {
    if (_.isFunction(duration)) {
      [callback, duration] = [duration, null];
    }
    if (_.isNumber(duration)) {
      return setTimeout((function() {
        return requestAnimationFrame(callback);
      }), duration);
    } else {
      return setTimeout(function() {
        return requestAnimationFrame(callback);
      });
    }
  }

  //END if
  //END defer
  classList(element) {
    var classList, item, ref;
    if (element == null) {
      return [];
    }
    if ('classList' in element) {
      return element.classList;
    }
    classList = ((ref = element.className) != null ? ref : "").replace(/\s+/, " ").split(" ");
    classList = (function() {
      var j, len, results;
      results = [];
      for (j = 0, len = classList.length; j < len; j++) {
        item = classList[j];
        if (item.length > 0) {
          results.push(item);
        }
      }
      return results;
    })();
    classList.contains = function(item) {
      return Array.prototype.indexOf.call(classList, item) > -1;
    };
    return classList;
  }

  //END classList
  findScrollParent(element) {
    var parent, ref;
    parent = element.parentNode;
    if (parent == null) {
      return element;
    }
    if ((parent === document.body) || ((ref = window.getComputedStyle(parent).overflowY) === 'auto' || ref === 'scroll')) {
      return parent;
    }
    return DOMHelpers.findScrollParent(parent);
  }

  //END findScrollParent
  findFormParent(element) {
    var parent, ref;
    if ((parent = element.parentNode) == null) {
      return null;
    }
    if (((ref = parent.tagName) != null ? ref : "").toString().toLowerCase() === "form") {
      return parent;
    }
    return DOMHelpers.findFormParent(parent);
  }

  //END findFormParent
  findParentByTagName(element, tag_name) {
    var parent;
    tag_name = tag_name.toLowerCase();
    parent = element.parentNode;
    while ((parent != null) && parent.nodeType !== Node.ELEMENT_NODE) {
      parent = parent.parentNode;
    }
    if (parent == null) {
      return null;
    }
    if (parent.tagName.toLowerCase() === tag_name) {
      return parent;
    }
    return DOMHelpers.findParentByTagName(parent, tag_name);
  }

  //END findParentByClassName
  findParentByClassName(element, class_name) {
    var parent;
    parent = element.parentNode;
    while ((parent != null) && parent.nodeType !== Node.ELEMENT_NODE) {
      parent = parent.parentNode;
    }
    if (parent == null) {
      return null;
    }
    if (DOMHelpers.classList(parent).contains(class_name)) {
      return parent;
    }
    return DOMHelpers.findParentByClassName(parent, class_name);
  }

  //END findParentByClassName
  findSiblingByClassName(element, class_name) {
    var sibling;
    sibling = element.nextSibling;
    while ((sibling != null) && sibling.nodeType !== Node.ELEMENT_NODE) {
      sibling = sibling.nextSibling;
    }
    if (sibling == null) {
      return null;
    }
    if (DOMHelpers.classList(sibling).contains(class_name)) {
      return sibling;
    }
    return DOMHelpers.findSiblingByClassName(sibling, class_name);
  }

  //END findSiblingByClassName
  findDescendantByClassName(element, class_name) {
    return element.querySelector(`.${class_name}`);
  }

  //END findDescendantByClassName
  hasClass(element, className) {
    return DOMHelpers.classList(element).contains(className);
  }

  addClass(element, className) {
    if (element == null) {
      return this;
    }
    if ('classList' in element) {
      if (!element.classList.contains(className)) {
        element.classList.add(className);
      }
    } else {
      if (!DOMHelpers.classList(element).contains(className)) {
        element.className += ` ${className}`;
      }
    }
    //END if
    return this;
  }

  //END addClass
  addClassAsync(element, className) {
    DOMHelpers.defer(67, function() {
      return DOMHelpers.addClass(element, className);
    });
    return this;
  }

  //END addClass
  removeClass(element, className) {
    if (element == null) {
      return this;
    }
    if ('classList' in element) {
      if (element.classList.contains(className)) {
        element.classList.remove(className);
      }
    } else {
      element.className = element.className.replace(className, "");
    }
    //END if
    return this;
  }

  //END removeClass
  removeClassAsync(element, className) {
    DOMHelpers.defer(67, function() {
      return DOMHelpers.removeClass(element, className);
    });
    return this;
  }

  //END removeClass
  toggleClass(element, className, predicate) {
    if (predicate) {
      DOMHelpers.addClass(element, className);
    } else {
      DOMHelpers.removeClass(element, className);
    }
    //END if
    return this;
  }

  //END toggleClass
  toggleClassAsync(element, className, predicate) {
    DOMHelpers.defer(function() {
      return DOMHelpers.toggleClass(element, className, predicate);
    });
    return this;
  }

  //END toggleClassAsync
  hasPreviousSibling(element) {
    var previous;
    previous = element.previousSibling;
    if (previous == null) {
      return false;
    }
    if (previous.nodeType === Node.ELEMENT_NODE) {
      return true;
    }
    return DOMHelpers.hasPreviousSibling(previous);
  }

  //END hasPreviousSibling
  hasNextSibling(element) {
    var next;
    next = element.nextSibling;
    if (next == null) {
      return false;
    }
    if (next.nodeType === Node.ELEMENT_NODE) {
      return true;
    }
    return DOMHelpers.hasNextSibling(next);
  }

  //END hasNextSibling
  removeNode(element) {
    element.parentNode.removeChild(element);
    return this;
  }

  //END removeNode
  getDuration(element) {
    var computed_duration, duration;
    computed_duration = window.getComputedStyle(element).transitionDuration;
    duration = parseFloat(computed_duration);
    return Math.floor(duration * 1000);
  }

  //END getDuration
  scrollToInputElement(element, scroll_parent) {
    var $element, ref, ref1;
    if (scroll_parent == null) {
      scroll_parent = DOMHelpers.findScrollParent(element);
    }
    if (!((element != null) && (scroll_parent != null))) {
      return;
    }
    if ((ref = window.getComputedStyle(element).position) === 'absolute' || ref === 'fixed') {
      return;
    }
    if ((ref1 = element.tagName.toLowerCase()) !== 'input' && ref1 !== 'textarea') {
      return;
    }
    $element = $(element);
    return scroll_parent.scrollTop = $element.offset().top + $element.outerHeight();
  }

  //END scrollToElement
  getTransformString(element) {
    var computed_style;
    computed_style = window.getComputedStyle(element, null);
    return computed_style.getPropertyValue('transform') || computed_style.getPropertyValue('-webkit-transform') || computed_style.getPropertyValue('-moz-transform') || computed_style.getPropertyValue('-ms-transform') || computed_style.getPropertyValue('-o-transform');
  }

  //END getTransformString
  setTransform(element, transformString) {
    element.style.webkitTransform = transformString;
    element.style.MozTransform = transformString;
    element.style.msTransform = transformString;
    element.style.OTransform = transformString;
    element.style.transform = transformString;
    return this;
  }

  //END setTransform
  removeTransform(element) {
    element.style.webkitTransform = null;
    element.style.MozTransform = null;
    element.style.msTransform = null;
    element.style.OTransform = null;
    element.style.transform = null;
    return this;
  }

  //END removeTransform
  afterTransition(element, callback) {
    var _callback, duration, timeout;
    duration = DOMHelpers.getDuration(element);
    timeout = null;
    _callback = function() {
      element.removeEventListener("webkitTransitionEnd", _callback);
      if (timeout != null) {
        clearTimeout(timeout);
      }
      _callback = null;
      return callback();
    };
    //END _callback

    // Add callbacks for detecting the transition end
    // 50 is added to the timeout as an aribtrary non-noticable
    // number to trigger the timeout presumably after the actual
    // animation is finished.
    element.addEventListener("webkitTransitionEnd", _callback);
    if (duration) {
      timeout = setTimeout(_callback, duration + 50);
    }
    return this;
  }

  //END afterTransition
  setOpacity(element, opacity) {
    element.style.opacity = opacity;
    element.style.filter = `alpha(opacity=${opacity * 100})`;
    return this;
  }

  //END setOpacity
  setScale(element, scale_x, scale_y) {
    if (scale_y == null) {
      scale_y = scale_x;
    }
    DOMHelpers.setTransform(element, 'scale(#{scale_x}, #{scale_y})');
    return this;
  }

  //END setScale
  getStyle(element, key) {
    var ref;
    return (ref = window.getComputedStyle(element)) != null ? ref[key] : void 0;
  }

  hideKeyboard() {
    var activeElement;
    if ((activeElement = document.activeElement) == null) {
      return this;
    }
    activeElement.blur();
    return this;
  }

  //END hideKeyboard
  getOffsetTop(element) {
    var offsetParent, parentOffsetTop, ref, ref1;
    offsetParent = element.offsetParent;
    parentOffsetTop = 0;
    if ((offsetParent != null ? offsetParent.nodeType : void 0) === Node.ELEMENT_NODE) {
      parentOffsetTop = (ref = DOMHelpers.getOffsetTop(offsetParent)) != null ? ref : 0;
    }
    //END if
    return ((ref1 = element.offsetTop) != null ? ref1 : 0) + parentOffsetTop;
  }

  //END getOffsetTop
  findNodeByClassName(node_list, class_name) {
    var j, len, node;
    for (j = 0, len = node_list.length; j < len; j++) {
      node = node_list[j];
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (DOMHelpers.classList(node).contains(class_name)) {
          return node;
        }
      }
    }
    //END for
    return null;
  }

  //END findNodeByClassName
  getCaretPosition(element) {
    var $document, $window, pre_caret_range, range, ref, ref1, selection, text_range;
    $document = (ref = element.ownerDocument) != null ? ref : element.document;
    $window = (ref1 = $document.defaultView) != null ? ref1 : $document.parentWindow;
    if ('getSelection' in $window) {
      selection = $window.getSelection();
      if (!(selection.rangeCount > 0)) {
        return 0;
      }
      range = selection.getRangeAt(0);
      pre_caret_range = range.cloneRange();
      pre_caret_range.selectNodeContents(element);
      pre_caret_range.setEnd(range.endContainer, range.endOffset);
      return pre_caret_range.toString().length;
    } else if ((selection = $document.selection) && selection.type !== "Control") {
      text_range = selection.createRange();
      pre_caret_range = $document.body.createTextRange();
      pre_caret_range.moveToElementText(element);
      pre_caret_range.setEndPoint("EndToEnd", text_range);
      return pre_caret_range.text.length;
    }
    //END if
    return 0;
  }

  //END getCaretPosition

    //TODO: Make this work for older browsers
  setCaretPosition(node, offset) {
    var range, recurse, result, selection;
    if (node == null) {
      return;
    }
    recurse = function(node) {
      var j, len, ref, result;
      if (node.nodeType === Node.TEXT_NODE) {
        return {node, offset};
      }
      ref = node.childNodes;
      //END if
      for (j = 0, len = ref.length; j < len; j++) {
        node = ref[j];
        if (typeof result !== "undefined" && result !== null) {
          return result;
        }
        switch (node.nodeType) {
          case Node.TEXT_NODE:
            if (offset <= node.length) {
              return {node, offset};
            }
            offset -= node.length;
            break;
          //END when
          case Node.ELEMENT_NODE:
            result = recurse(node);
            if (result != null) {
              return result;
            }
        }
      }
      //END when
      //END switch
      //END for
      return null;
    };
    //END recurse
    result = recurse(node);
    if (result != null) {
      ({node, offset} = result);
      range = document.createRange();
      selection = window.getSelection();
      range.setStart(node, offset);
      range.collapse(true);
      selection.removeAllRanges();
      return selection.addRange(range);
    }
  }

  //END if
  //END setCaretPosition

    //TODO: Make this work for older browsers
  getCaretNode(element) {
    var node, selection;
    selection = typeof window.getSelection === "function" ? window.getSelection() : void 0;
    if (selection == null) {
      return null;
    }
    node = selection.anchorNode;
    if (node == null) {
      return null;
    }
    if (!element.contains(node)) {
      return null;
    }
    return node;
  }

  //END getCaretNode

    //TODO: Make this work for older browsers
  injectNodeAtCaret(node) {
    var range, selection;
    selection = window.getSelection();
    if (selection.rangeCount > 0) {
      range = selection.getRangeAt(0);
      range.deleteContents();
      range.insertNode(node);
      range.setStartAfter(node);
      range.collapse(true);
      selection.removeAllRanges();
      return selection.addRange(range);
    }
  }

  //END if
  //END injectNodeAtCaret
  collapseAllHighlghts() {
    var ref;
    return (ref = window.getSelection()) != null ? ref.removeAllRanges() : void 0;
  }

  //END collapseAllHighlghts
  collapseHighlight() {
    var endContainer, endOffset, range, selection;
    selection = window.getSelection();
    if (!(selection.rangeCount > 0)) {
      return 0;
    }
    ({endOffset, endContainer} = selection.getRangeAt(0));
    selection.removeAllRanges();
    range = document.createRange();
    range.setStart(endContainer, endOffset);
    range.collapse(true);
    return selection.addRange(range);
  }

  //END collapseHighlight
  highlight(element, start_offset, end_offset) {
    var childNode, currentNode, endNode, j, len, previousNode, range, ref, selection, startNode;
    if (!_.isNumber(start_offset)) {
      return;
    }
    if (!_.isNumber(end_offset)) {
      return;
    }
    if (!(start_offset < end_offset)) {
      return;
    }
    range = document.createRange();
    selection = window.getSelection();
    startNode = null;
    endNode = null;
    currentNode = null;
    previousNode = null;
    ref = element.childNodes;
    for (j = 0, len = ref.length; j < len; j++) {
      childNode = ref[j];
      previousNode = currentNode;
      currentNode = childNode;
      while (currentNode.childNodes.length > 0) {
        currentNode = currentNode.childNodes[0];
      }
      //END while
      if (previousNode != null) {
        if (startNode == null) {
          start_offset -= previousNode.length;
        }
        if (endNode == null) {
          end_offset -= previousNode.length;
        }
      }
      if ((startNode == null) && start_offset <= currentNode.length) {
        //END if
        startNode = currentNode;
      }
      if ((endNode == null) && end_offset <= currentNode.length) {
        endNode = currentNode;
      }
      if ((startNode != null) && (endNode != null)) {
        break;
      }
    }
    //END for
    if (startNode == null) {
      startNode = element;
    }
    if (endNode == null) {
      endNode = currentNode;
    }
    if ((startNode != null) && (endNode != null)) {
      range.setStart(startNode, start_offset);
      range.setEnd(endNode, end_offset);
      selection.removeAllRanges();
      return selection.addRange(range);
    }
  }

  //END if
  //END highlight
  hasSelection(element) {
    var i, j, range, ref, selection;
    selection = window.getSelection();
    if (!(selection.rangeCount > 0)) {
      return false;
    }
    for (i = j = 0, ref = selection.rangeCount; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
      range = selection.getRangeAt(i);
      if (!range.collapsed) {
        if (element.contains(range.startContainer)) {
          return true;
        }
        if (element.contains(range.endContainer)) {
          return true;
        }
      }
    }
    //END unless
    //END for
    return false;
  }

  //END hasSelection
  getText(node) {
    switch (false) {
      case !('textContent' in node):
        return node.textContent;
      case !('text' in node):
        return node.text;
      case !('innerText' in node):
        return node.innerText;
      case !('data' in node):
        return node.data;
      default:
        throw new Error("Could not get text of node");
    }
  }

  //END getText
  setText(node, text) {
    switch (false) {
      case !('textContent' in node):
        return node.textContent = text;
      case !('text' in node):
        return node.text = text;
      case !('innerText' in node):
        return node.innerText = text;
      case !('data' in node):
        return node.data = text;
      default:
        throw new Error("Could not set text of node");
    }
  }

  //END setText
  concatText(target_text_node, text) {
    switch (false) {
      case !('textContent' in target_text_node):
        return target_text_node.textContent += text;
      case !('text' in target_text_node):
        return target_text_node.text += text;
      case !('innerText' in target_text_node):
        return target_text_node.innerText += text;
      case !('data' in target_text_node):
        return target_text_node.data += text;
      default:
        throw new Error("Could not set text of node");
    }
  }

})();

//END concatText
//END DOMHelpers

},{}],53:[function(require,module,exports){
var RequestHelpers;

module.exports = RequestHelpers = new ((function() {
  var UNAUTHORIZED, _Class;

  _Class = class {
    preparePromiseOptions(resolve, reject, options, default_human_error) {
      var _error, _success;
      if (_.isFunction(options)) {
        options = {
          complete: options
        };
      }
      if (!_.isObject(options)) {
        options = {};
      }
      _success = options.success;
      options.success = function(model) {
        resolve(model);
        if (_.isFunction(_success)) {
          return _success.apply(this, arguments);
        }
      };
      //END options.success
      _error = options.error;
      options.error = function(model, error, options, {xhr}) {
        error = (function() {
          var ref;
          switch (parseInt((ref = xhr != null ? xhr.status : void 0) != null ? ref : 0)) {
            case 401:
              return UNAUTHORIZED;
            default:
              return Helpers.parseError(error, default_human_error);
          }
        })();
        //END switch
        reject(error);
        if (_.isFunction(_error)) {
          return _error.apply(this, arguments);
        }
      };
      //END options.error
      return options;
    }

    //END preparePromiseOptions
    isUnauthorized(error) {
      return error === UNAUTHORIZED;
    }

  };

  UNAUTHORIZED = {
    human: "Session Expired"
  };

  return _Class;

}).call(this))();

//END RequestHelpers

},{}],54:[function(require,module,exports){
module.exports = {
  code: "en/ca",
  translations: {
    "USA/English": "Canada/English",
    "Enter Your Game Code": "Enter Your Game Code",
    "{{daysLeftPrefix}}": ""
  }
};

},{}],55:[function(require,module,exports){
module.exports = {
  code: "en/us",
  translations: {
    "USA/English": "USA/English",
    "Enter Your Game Code": "Enter Your Game Code",
    "{{daysLeftPrefix}}": ""
  }
};

},{}],56:[function(require,module,exports){
var AgraveUni, CcedillaUni, EacuteUni, EcircUni, EgraveUni, agraveUni, ccedillaUni, eacuteUni, ecircUni, egraveUni;

AgraveUni = "\u00C0"; // À

CcedillaUni = "\u00C7"; // Ç

EgraveUni = "\u00C8"; // È

EacuteUni = "\u00C9"; // É

EcircUni = "\u00CA"; // Ê

// TODO: Î
agraveUni = "\u00E0"; // à

ccedillaUni = "\u00E7"; // ç

egraveUni = "\u00E8"; // è

eacuteUni = "\u00E9"; // é

ecircUni = "\u00EA"; // ê

module.exports = {
  code: "fr/ca",
  translations: {
    "JOIN US ON THE LINE": "JOIGNEZ-VOUS À NOUS<br>À LA LIGNE DE DÉPART",
    "It's time for Factory to Finish Line 2026 &mdash; your chance to join Team<br>Snap-on&reg; and Team Penske&reg; for one of two once-in-a-lifetime<br>experiences that money just can't buy.": "La promotion « Factory to Finish Line » 2026 est arrivée — voilà votre chance de vous<br>joindre à l’équipe Snap-on® et l’équipe Team Penske® pour vivre<br>l'une des deux expériences uniques qui n’ont pas de prix.",
    "10 WINNERS": "10 GAGNANTS",
    "DAIRYLAND GRAND PRIZE&nbsp;PACKAGE": "GRAND PRIX DAIRYLAND",
    "Win an Insider Plant Tour of the Snap-on Milwaukee, WI hand tool plant, where you'll join Team Snap-on&reg; for a look behind the scenes &mdash; and take home a valuable Ultimate Socket and Pliers Drawer &mdash; plus Team Penske VIP tickets to the INDYCAR&reg; race at Road America&reg;.": "Gagnez une visite privée de l'usine d'outils à main Snap-on à Milwaukee, WI, où vous vous joindrez à l'équipe Snap-on® pour y découvrir les coulisses — et ramènerez à la maison un précieux tiroir Ultimate de douilles et de pinces — plus des billets VIP Team Penske pour assister à la course INDYCAR® à Road America®.",
    "HOT LAP WEEK": "SEMAINE DU TOUR FATIDIQUE",
    "This week is your opportunity to earn bonus Pit Passes and win a TRITON&trade;. Use this to get a jump on the rest of the field in Phase 2.": "Cette semaine, vous avez la chance de remporter des laissez-passer « Direct au puits » en prime et un TRITON™. Profitez-en pour aider vos clients à prendre de l'avance sur le reste du peloton lors de la Phase 2.",
    "DIXIELAND GRAND PRIZE&nbsp;PACKAGE": "GRAND PRIX DIXIELAND",
    "Win an Insider Plant Tour of the Snap-on Murphy, NC power tool plant, where you'll join Team Snap-on for a look behind the scenes &mdash; and take home a valuable Murphy Ultimate Power Cart &mdash; plus Team Penske VIP tickets to the NASCAR race at EchoPark&reg; Speedway in Hampton, GA!": "Gagnez une visite privée de l'usine d'outils mécaniques Snap-on à Murphy, NC, où vous vous joindrez à l'équipe Snap-on pour y découvrir les coulisses — et ramènerez à la maison un précieux chariot d’outils mécaniques Murphy Ultimate — plus des billets VIP Team Penske pour assister à la course NASCAR au EchoPark® Speedway à Hampton, GA!",
    "Log Your Entries": "ENREGISTREZ VOS CHANCES",
    "Winners Drawn": "SÉLECTION DES GAGNANTS",
    "January 5 - February 20": "5 JANVIER - 20 FÉVRIER",
    "February 21": "21 FÉVRIER",
    "February 21 - 27": "21 AU 27 FÉVRIER",
    "February 28": "28 FÉVRIER",
    "February 28 - April 10": "28 FÉVRIER - 10 AVRIL",
    "April 11": "11 AVRIL",
    "Every entry also gives you a chance to win.": "Chaque bulletin vous donne une chance de gagner.",
    "$50,000 Tool Package": "50 000 $ en outils",
    "Contest Re-opens soon!": "Le concours commence bientôt!",
    "COMING SOON": "DISPONIBLE BIENTÔT",
    "Game&nbsp;starts January&nbsp;5,&nbsp;2026": "LA&nbsp;PROMOTION&nbsp;COMMENCE LE 5&nbsp;JANVIER&nbsp;2026",
    "Enter Your Game Code": "ENTRER VOTRE CODE DE JEU",
    "Continue": "CONTINUER",
    "Email": "Courriel",
    "Snap-on is a trademark of Snap-on Incorporated.": "SNAP-ON EST UNE MARQUE DE COMMERCE DE SNAP-ON INCORPORATED.",
    "&copy;Snap-on Incorporated 2023. All other marks are trademarks of their respective holders.": `&copy;SNAP-ON INCORPORATED 2023. TOUTES LES AUTRES MARQUES DE COMMERCE SONT LA PROPRI${EacuteUni}T${EacuteUni} DE LEUR D${EacuteUni}TENTEUR RESPECTIF.`,
    "&copy;Snap-on Incorporated 2024. All other marks are trademarks of their respective holders.": `&copy;SNAP-ON INCORPORATED 2024. TOUTES LES AUTRES MARQUES DE COMMERCE SONT LA PROPRI${EacuteUni}T${EacuteUni} DE LEUR D${EacuteUni}TENTEUR RESPECTIF.`,
    "Snap-on is a trademark of Snap-on Incorporated. All rights reserved. &copy;Snap-on Incorporated. All other marks are trademarks of their respective holders. Trademarks granted by license from Penske Racing, Inc.": "Snap-on est une marque de commerce de Snap-on Incorporated. Tous droits réservés. &copy;Snap-on Incorporated. Toutes les autres marques de commerce sont la propriété de leur détenteur respectif. Marques de commerce sous licence de Penske Racing, Inc.",
    "Privacy": `VIE PRIV${EacuteUni}E`,
    "Terms of Use": "CONDITIONS D'UTILISATION",
    "Official Rules": `R${egraveUni}glements officiels`,
    "We think you're in the": `Nous pensons que vous ${EcircUni}tes r${EacuteUni}sidents de`,
    "Is that correct?": "Est-ce exact?",
    // "USA/English": "USA/English"
    // "Canada/English": "Canada/English"
    // "Canada/Francais": "Canada/Fran#{ccedillaUni}ais"
    "Excellent!": "Excellent!",
    "Excellent": "Excellent",
    "Sign in or register<br>to claim this entry": `OUVRIR UNE SESSION OU S'INSCRIRE POUR R${EacuteUni}CLAMER VOTRE BULLETIN`,
    "is a valid code.": "est un code valide.",
    "Sign in or register to claim this entry": `Ouvrir une session ou s'inscrire pour r${eacuteUni}clamer votre bulletin`,
    "Sign In": "S'ENREGISTRER",
    "Signin": "S'ENREGISTRER",
    "Sign In": "S'ENREGISTRER",
    "Sign Out": "FERMER LA SESSION",
    "Register": "S'inscrire",
    "Your Email Address": "Votre adresse de courriel",
    "Password": "Mot de passe",
    "Enter your Password": "Entrer votre mot de passe",
    "Enter Your Password": "Entrer votre mot de passe",
    "Keep me signed in": "Garder ma session ouverte",
    "Continue": "Continuer",
    "Forgot Your Password?": `J'AI OUBLI${EacuteUni} MON MOT DE PASSE`,
    "Name - First Name Last Name": `Nom - Pr${eacuteUni}nom`,
    "Name": "Nom",
    "Your Name": "Votre nom",
    "First Name": `PR${EacuteUni}NOM`,
    "Your First Name": `Votre PR${EacuteUni}NOM`,
    "Last Name": "Nom",
    "Your Last Name": "Votre nom",
    "Email Address": "ADRESSE DE COURRIEL",
    "Your Email Address": "Votre adresse de courriel",
    "Verify Email Address": `V${EacuteUni}RIFIER L'ADRESSE DE COURRIEL`,
    "Phone Number": `NUM${EacuteUni}RO DE T${EacuteUni}L${EacuteUni}PHONE`,
    "Your Phone Number": `Votre num${EacuteUni}ro de t${EacuteUni}l${EacuteUni}phone`,
    "PASSWORD": "MOT DE PASSE",
    "Choose A Password": "Choisir un mot de passe",
    "Verify Password": `V${EacuteUni}RIFIER LE MOT DE PASSE`,
    "Verify Your Password": `V${EacuteUni}rifier le mot de passe`,
    "Passwords do not match": "LES MOTS DE PASSE NE CONCORDENT PAS",
    "Check this box to verify that you <br /> have read the": "Cochez cette case pour confirmer que<br /> vous avez lu",
    "official rules": `les r${EgraveUni}glements officiels`,
    "(Official Rules)": `(les r${EgraveUni}glements officiels)`,
    "Opt-in for a chance to win the Custom Snap-on RC Truck or Boat": `S'inscrire pour courir la chance de gagner une t${EacuteUni}l${EacuteUni}commande pour bateau ou camion Snap-on.`,
    "(See your Snap-on franchisee for contest rules)": `(voir votre franchis${EacuteUni} Snap-on pour les d${EacuteUni}tails)`,
    "Opt-in for a chance to win the 5,000 Snap-on Shopping Spree": "S'inscrire pour courir la chance de gagner un magasinage en folie Snap-on de 5 000 $.",
    "Opt-in for a chance to win the 50,000 Ultimate Snap-on Tool Set": "S'inscrire pour courir la chance de gagner un ensemble ultime de 50 000 $ en outils.",
    "Would you like Snap-on Tools <br /> to send you game updates?": `Voulez-vous que Outils Snap-on <br /> vous envoie des mises ${AgraveUni} jour sur le concours?`,
    "Send me Snap-on game updates, newsletters and promotions by email.": `Envoyez-moi des mises ${AgraveUni} jour, des bulletins ${EacuteUni}lectroniques et des promotions par courriel.`,
    "Back": `PR${EacuteUni}C${EacuteUni}DENT`,
    "Check this box to verify that you have read the": "Cochez cette case pour confirmer que vous avez lu",
    "Opt-in for a chance to win the Snap-on Customize Roll Cab Contest": "COCHEZ POUR COURIR LA CHANCE DE GAGNER LE CONCOURS « PERSONNALISER VOTRE SERVANTE MOBILE SNAP-ON",
    "YOU'RE ENTERED [FIRST NAME]!": `VOUS ${EcircUni}TES INSCRIT [PR${EacuteUni}NOM]!`,
    "GOOD LUCK!": "BONNE CHANCE!",
    "You&lsquo;ve Just Added": "VOUS VENEZ D'AJOUTER",
    "YOU'VE JUST ADDED [X] ENTRY FOR THIS DRAWING": "VOUS VENEZ D'AJOUTER [X] BULLETIN(S) POUR CE TIRAGE.",
    "Entries in this Phase": "Bulletin(s) dans cette phase",
    "Days Until Prize Drawing": "Jour(s) avant le tirage",
    "Days Until Contest Opens": `Jour(s) avant le d${EacuteUni}but du concours`,
    "won this phase!": `a remport${EacuteUni} cette phase!`,
    "Entries for Shopping Spree": "BULLETINS DANS CETTE PHASE",
    "Win a chance to build<br/>&amp; Customize your own<br/>Snap-on<span>&reg;</span> Roll Cab": "COUREZ LA CHANCE DE<br/>CONSTRUIRE ET DE<br/>PERSONNALISER VOTRE<br/>SERVANTE MOBILE SNAP-ON<span>&reg;</span>",
    "In Algona, Iowa": `${AgraveUni} ALGONA, IOWA`,
    "&ndash; The Storage Capital Of the World": `&ndash; LA CAPITALE MONDIALE DES UNIT${EacuteUni}S DE RANGEMENT`,
    "Currently you have<br />contest entries": `VOUS AVEZ PR${EacuteUni}SENTEMENT<br/>BULLETINS DANS CETTE PHASE`,
    "Days Left to Enter": "JOURS RESTANTS<br/>POUR PARTICIPER",
    "Prize Drawing on October 5th": "LE TIRAGE A LIEU LE 5 OCTOBRE",
    "Sorry our login information doesn't match our records.": `D${eacuteUni}sol${eacuteUni}, vos donn${eacuteUni}es d'ouverture de session ne correspondent pas ${agraveUni} celles de nos dossiers.`,
    "An unspecified error has occurred.": "Une erreur inconnue est survenue.",
    "Please try reloading the page.": "Veuillez actualiser cette page.",
    "Sorry, this game code isn't valid.": `D${eacuteUni}sol${eacuteUni}, ce code de jeu est non valide.`,
    "/images/slide-1-desktop.png": "/images/slide-1-desktop.fr.png",
    "/images/slide-2-desktop.png": "/images/slide-2-desktop.fr.png",
    "/images/slide-3-desktop.png": "/images/slide-3-desktop.fr.png",
    "/images/slide-1-mobile.png": "/images/slide-1-mobile.fr.png",
    "/images/slide-2-mobile.png": "/images/slide-2-mobile.fr.png",
    "/images/slide-3-mobile.png": "/images/slide-3-mobile.fr.png",
    "/images/thanks.png": "/images/thanks.fr.png",
    "/images/franchisee-pt-1-header.png": "/images/franchisee-pt-1-header.fr.png",
    "/images/franchisee-pt-2-header.png": "/images/franchisee-pt-2-header.fr.png",
    "/images/fpt-header.png": "/images/fpt-header.fr.png",
    "/images/global-header.png": "/images/global-header.fr.png",
    "https://www.snapon.com/Terms-and-Conditions": "https://www.snapon.com/Terms-and-Conditions",
    "https://policies.snapon.com/en/rw": "https://policies.snapon.com/fr/rw",
    "Edit Profile": "modifier le profil",
    "Enter Another Game Code": "entrer un autre code de jeu",
    "Add This Code": "ajouter ce code",
    "Account Information": "RENSEIGNEMENTS SUR LE COMPTE",
    "Change Password": "CHANGER LE MOT DE PASSE",
    "Current Password": "MOT DE PASSE ACTUEL",
    "Your Current Password...": "Votre mot de passe actuel...",
    "New Password": "NOUVEAU MOT DE PASSE",
    "New Password...": "NOUVEAU MOT DE PASSE...",
    "Retype New Password": "CONFIRMER LE MOT DE PASSE",
    "Retype New Password...": "CONFIRMER LE MOT DE PASSE...",
    "Change": "MODIFIER",
    "Address": "ADRESSE",
    "Apt/Suite #": "App./Suite",
    "City": "VILLE",
    "State": `${EacuteUni}TAT`,
    "Save": "ENREGISTRER",
    "Zip Code": "CODE POSTA",
    "Hello": "Bonjour",
    "Home": "Accueil",
    "Changing...": "En cours de modification...",
    "Saving...": "En cours d'enregistrement...",
    "Province": "Province",
    "Retype Password...": "Tapez de nouveau le mot de passe...",
    "Email Address...": "ADRESSE DE COURRIEL...",
    "Email Must Not Be Empty": "Adresse de courriel obligatoire",
    "Email must not be empty": "Adresse de courriel obligatoire",
    "Your Name...": "Votre nom...",
    "Name must not be empty": "Nom obligatoire",
    "Password must be at least 6 characters long and must not contain white space": `LE MOT DE PASSE DOIT COMPTER AU MOINS 6 CARACT${EgraveUni}RES ET NE CONTENIR AUCUN ESPACE`,
    "Email is formatted incorrectly": "FORMAT DE COURRIEL NON VALIDE",
    "Invalid email or password": "COURRIEL OU MOT DE PASSE NON VALIDE",
    "Please enter a valid phone number": `Veuillez entrer un num${egraveUni}ro de t${egraveUni}l${egraveUni}phone valide`,
    "That&apos;s A Valid Code. Good Luck!": "C&apos;EST UN CODE VALIDE. BONNE CHANCE!",
    "You&apos;ve Just Added": "VOUS VENEZ D'AJOUTER",
    "Entry for This Drawing": "BULLETIN(S) POUR CE TIRAGE.",
    "Enter Contest": "PARTICIPER",
    "Retype Email Address": "Inscrire votre adresse de courriel de nouveau",
    "Retype Your Email Address": "Inscrire votre adresse de courriel de nouveau",
    "Please re-enter your email": "Veuillez inscrire votre adresse de courriel de nouveau",
    "Emails do not match": "Les adresses de courriel ne concordent pas",
    "./videos/boat_en.mp4": "./videos/boat_fr.mp4",
    "./videos/boat_en.ogv": "./videos/boat_fr.ogv",
    "./videos/boat_en.webm": "./videos/boat_fr.webm",
    "Winning Entries": void 0,
    "SEE YOUR FRANCHISEE FOR OFFICIAL GAME RULES": `VOYEZ VOTRE FRANCHIS${EacuteUni} POUR CONNAÎTRE LES R${EgraveUni}GLEMENTS OFFICIELS`,
    "DID YOU SIGN UP FOR DOUBLE-PLAY?": `VOUS VOUS ${EcircUni}TES INSCRIT AU DOUBLE JEU?`,
    "THAT'S GREAT - YOU CAN USE THE SAME LOGIN!": `MERVEILLEUX &mdash; VOUS POUVEZ ALORS UTILISER LE M${EcircUni}ME IDENTIFIANT!`,
    "Entries for cooler cart": `Bulletins pour le chariot-glaci${egraveUni}re`,
    "Log In": "OUVRIR UNE SESSION",
    "Login": "OUVRIR UNE SESSION",
    "Verify Email": "CONFIRMER LE COURRIEL",
    "Phone": "T&Eacute;L&Eacute;PHONE",
    "Opt-in for a chance to win the MECUM AUCTION EXPERIENCE": "INSCRIVEZ-VOUS POUR COURIR LA CHANCE DE REMPORTER L&rsquo;EXP&Eacute;RIENCE &laquo; VENTE AUX ENCH&Egrave;RES &raquo; MECUM",
    "Submit": "SOUMETTRE",
    "You've got a valid code!": "VOTRE CODE EST VALIDE!",
    "Log in to Claim Your Piece": "CONNECTEZ-VOUS POUR R&Eacute;CLAMER VOTRE PI&Egrave;CE DE JEU.",
    "Your Email": "VOTRE COURRIEL",
    "Register to Claim Your Piece": "Inscrivez-vous pour r&eacute;clamer votre pi&egrave;ce",
    "First name must not be empty": "Pr&eacute;nom obligatoire",
    "Last name must not be empty": "Nom obligatoire",
    "Please re-enter your password": "Veuillez entrer votre mot de passe de nouveau",
    "Please enter your current password": "Veuillez entrer votre mot de passe actuel",
    "Please enter a new password": "Veuillez entrer un nouveau mot de passe",
    "Go!": "ALLEZ!",
    "You Have": "VOUS AVEZ",
    "Entries<br/>To Win": "BULLETIN DE<br/>PARTICIPATION",
    "You've<small>Completed<br/>a car!</small>": "VOUS AVEZ <small>TERMIN&Eacute;<br/> UNE VOITURE!</small>",
    "Enter a new code": "ENTREZ UN<br class='is-only-on-phone'/>NOUVEAU CODE",
    "{{daysLeftPrefix}}": "<strong>ENCORE</strong>",
    "<strong>Days Left, Contest Ends<strong> March 15": "<strong>JOURS...<br/>LE CONCOURS PREND FIN LE 15 MARS.",
    "Your Garage": "VOTRE GARAGE",
    "Get Another Entry with Every Completed Car": "OBTENEZ UN AUTRE BULLETIN POUR CHAQUE VOITURE COMPL&Egrave;TE.",
    "Share Your<br/>Collection": "PARTAGER VOTRE<br/>COLLECTION",
    "Completed Cars": "VOITURES COMPL&Egrave;TES",
    "Dashboard": "TABLEAU DE BORD",
    "Account Settings": "PARAM&Egrave;TRES DU COMPTE",
    "Skip": "PASSER",
    "Next": "SUIVANT",
    "Finish": "TERMINER",
    "WELCOME TO<br/>Partners in Profitability<br/>LET\'S GET STARTED": "BIENVENUE &Agrave;<br/>&laquo; Partners in Profitability &raquo;<br/>COMMENCEZ",
    "ENTER YOUR GAME CODE HERE": "ENTREZ VOS CODES DE JEU ICI",
    "Enter Your Code": "ENTREZ VOTRE CODE",
    "Get Started!": "COMMENCEZ!",
    "With each completed car,<br/> you get another free entry": "&Agrave; CHAQUE VOITURE COMPL&Egrave;TE, VOUS OBTENEZ<br/>UN AUTRE BULLETIN DE PARTICIPATION!",
    "Share your progress<br/>with your friends": "PARTAGER VOTRE<br/>POSITION AVEC VOS AMIS",
    "Take our brief <strong>Survey</strong> and <br/> receive a <strong>free entry.</strong>": "R&eacute;pondez &agrave; un cours <strong>SONDAGE</strong>, et obtenez un <strong>BULLETIN<br/>DE PARTICIPATION EN PRIME</strong>",
    "Take our brief<br/> survey and receive<br /> a free entry.": "R&eacute;pondez &agrave; un cours SONDAGE, et obtenez un BULLETIN DE PARTICIPATION EN PRIME",
    "Get Started": "COMMENCEZ!",
    "Start": "COMMENCEZ!",
    "<strong>Survey Complete!</strong><br/>Keep rolling! Way to score another entry": "<strong>Sondage termin&eacute;</strong><br/>Ne vous arr&ecirc;tez pas! Accumulez d'autres bulletins de participation.",
    "Survey Complete!<br/>Keep rolling! Way to score another entry": "Sondage termin&eacute;<br/>Ne vous arr&ecirc;tez pas! Accumulez d'autres bulletins de participation.",
    "/images/dashboard/grand-prize-mobile.png": "/images/dashboard/grand-prize-mobile_fr.png",
    "/images/dashboard/grand-prize.png": "/images/dashboard/grand-prize_fr.png",
    "/images/dashboard/1st-prize-mobile.png": "/images/dashboard/1st-prize-mobile_fr.png",
    "/images/dashboard/1st-prize.png": "/images/dashboard/1st-prize_fr.png",
    "/images/home/hero-mobile.png": "/images/home/hero-mobile_fr.png",
    "/images/hero.png": "/images/hero-fr.png",
    "/images/home/jan-through-march.png": "/images/home/jan-through-march_fr.png",
    "/images/home/1st-prize-mobile.png": "/images/home/1st-prize-mobile_fr.png",
    "/images/home/1st-prize.png": "/images/home/1st-prize_fr.png",
    "/images/home/every-eight-weeks-mobile.png": "/images/home/every-eight-weeks-mobile_fr.png",
    "/images/home/every-eight-weeks.png": "/images/home/every-eight-weeks_fr.png",
    "/images/tutorial/enter-game-code.jpg": "/images/tutorial/enter-game-code_fr.jpg",
    "/images/tutorial/pieces.jpg": "/images/tutorial/pieces_fr.jpg",
    "/images/tutorial/collectibles.jpg": "/images/tutorial/collectibles_fr.jpg",
    "/images/tutorial/share.jpg": "/images/tutorial/share_fr.jpg",
    "Thanks for playing!": "MERCI DE VOTRE PARTICIPATION!",
    "Winners will be announced in April 2019.": `LES GAGNANTS SERONT ANNONC${EacuteUni}S EN AVRIL 2019.`,
    "Follow Snap-on Tools on Facebook": "Suivez Outils Snap-on sur Facebook",
    "Total<small>Entries</small>": "<small>BULLETINS</small>AU TOTAL",
    "Scan QR or enter code": "Balayez le code QR ou entrez le code",
    "/images/garage-banner.jpg": "/images/garage-banner-fr.jpg",
    "Success valid code": `VOUS AVEZ R${EacuteUni}USSI!`,
    "Success": `VOUS AVEZ R${EacuteUni}USSI!`,
    "Congratulations": `F${EacuteUni}LICITATIONS!`,
    "You&apos;VE COMPLETED A CAR": `VOUS AVEZ TERMIN${EacuteUni} UNE VOITURE`,
    "/videos/video.mp4": "/videos/video-fr.mp4",
    "/images/footer-banner.png": "/images/footer-banner-fr.png",
    "/images/footer-banner-mobile.png": "/images/footer-banner-mobile-fr.png",
    "/images/game_over_en.png": "/images/game_over_fr.png",
    //----------------
    "9 GRAND PRIZE WINNERS": "9 GAGNANTS DU GRAND PRIX",
    "ENTER BY: Feb 12 / Mar 19 / Apr 23": `PARTICIPEZ D'ICI LE : 12 F${EacuteUni}VRIER/19 MARS/23 AVRIL`,
    "THE GRAND PRIZE PACKAGE INCLUDES:": "LE GRAND PRIX COMPREND :",
    "<strong>Corvette&reg; c8</strong> performance driving school at Spring Mountain Motor Resort": `<strong>CORVETTE C8</strong>, dans une ${eacuteUni}cole de conduite haute performance ${agraveUni} Spring Mountain Motor Resort PLUS`,
    "<strong>Drift</strong> experience in a smokin&apos;-hot drift car": `<strong>EXP${EacuteUni}RIENCE ULTIME</strong> au volant d'une voiture de haute performance`,
    "<strong>Off-road Course</strong> in a trophy truck": `<strong>PARCOURS HORS ROUTE</strong> au volant d'un camion prim${eacuteUni}`,
    "Enter Code": "ENTRER LE CODE",
    "Total Entries": "BULLETINS AU TOTAL",
    "days left to complete entries": "JOURS RESTANTS POUR PARTICIPER",
    "Every completed car earns an entry": `UN BULLETIN DE PARTICIPATION POUR CHAQUE VOITURE COMPL${EgraveUni}TE`,
    "Enter by:": "PARTICIPEZ D'ICI LE:",
    "Feb 12": `12 F${EacuteUni}VRIER`,
    "Mar 19": "19 MARS",
    "Apr 23": "23 AVRIL",
    "Success!": `R${EacuteUni}USSI!`,
    "You win 1 entry!": "VOUS REMPORTEZ 1 BULLETIN DE PARTICIPATION",
    "Car Completed": `VOITURE COMPL${EgraveUni}TE`,
    "Send me Snap-on game updates, newsletters and promotions.": `ENVOYEZ-MOI DES MISES ${AgraveUni} JOUR SUR LE CONCOURS, <br /> DES BULLETINS ${EacuteUni}LECTRONIQUES ET DES PROMOTIONS.`,
    "Forgot Password": `J'AI OUBLI${EacuteUni} MON MOT DE PASSE`,
    "Survey Complete!<br/>Way to score another entry!": "Sondage termin&eacute;!<br />En route vers une autre carte de participation",
    "Tired of typing? Scan the QR code with your smart phone camera!": `Fatigu${eacuteUni} de taper? Balayez le code QR avec la cam${eacuteUni}ra de votre t${eacuteUni}l${eacuteUni}phone intelligent!`,
    "WE HOPE YOU<br />REACHED THE PODIUM": `NOUS ESP${EacuteUni}RONS QUE<br />VOUS AVEZ ATTEINT LE PODIUM`,
    "Dream Drive III has ended, and we&apos;re loading up the trailers and planning for next year&apos;s promotion. Thank you for playing, and be sure to follow Snap-on Tools on Facebook and Instagram.": `La promotion Dream Drive II est termin${eacuteUni}e et nous nous affairons ${agraveUni} remplir les remorques et a planifi${eacuteUni} la promotion de l'an prochain. Merci d'avoir particip${eacuteUni}, et ne manquez pas de suivre Outils Snap-on sur Facebook et Instagram.`,
    "<small>In this race,</small>Every day is qualifying": "<small>DANS CETTE COURSE,</small> CHAQUE JOUR EST UNE",
    "<small>Welcome</small>": "<small>BIENVENUE</small>",
    "Your Total Laps": "Total de vos tours",
    "Congratulations!": `F${EacuteUni}LICITATIONS!`,
    "You've gained": `Vous avez remport${eacuteUni}`,
    "You've earned": `Vous avez remport${eacuteUni}`,
    "Lap": "TOUR",
    "Laps": "TOURS",
    "Go": "PARTEZ",
    "PRIZE PACKAGE INCLUDES:": "PRIX OFFERTS:",
    "<strong>Five winners and their guests</strong> will be Snap-on VIPs at the 2023 Indy 500<sup>&reg;</sup>": `<strong>CINQ GAGNANTS ET LEUR INVIT${EacuteUni}</strong> seront des VIP de Snap-on au Indy 500<sup>&reg;</sup> 2023.`,
    "<strong>Ten winners and their guests</strong> will attend the Ultimate Go-Fast Experience at Spring Mountain Motor Resort": `<strong>DIX GAGNANTS ET LEUR INVIT${EacuteUni}</strong> remportent l'exp${eacuteUni}rience ultime « Go-Fast » au Spring Mountain Motor Resort`,
    "You entered the mystery code!": `Vous avez entr${eacuteUni} le code myst${egraveUni}re!`,
    "Check back the week of": `V${eacuteUni}rifiez la semaine du`,
    "to pick your driver. If you pick right, you'll gain an additional lap when they win.": `pour s${eacuteUni}lectionner votre pilote. Si vous s${eacuteUni}lectionnez le pilote gagnant, vous remportez un tour suppl${eacuteUni}mentaire.`,
    "Don't be left at the starting line.": `Ne restez pas sur la ligne de d${eacuteUni}part.`,
    "Pick your winning driver for this week's race.": `S${eacuteUni}lectionnez votre pilote gagnant de la course de cette semaine.`,
    "Pick your winning driver for this weeks race!": `S${eacuteUni}lectionnez votre pilote gagnant de la course de cette semaine!`,
    "You've selected": `Vous avez s${eacuteUni}lectionn${eacuteUni}`,
    "Your pick this week:": "Cette semaine, vous avez choisi :",
    "for this week's race. It's time to start chilling the champagne.": "pour la course de cette semaine. Il est temps de mettre le champagne au frais.",
    "Take the survey,": `R${EacuteUni}PONDEZ AU SONDAGE,`,
    "Take a survey": `R${EacuteUni}PONDEZ AU SONDAGE`,
    "Congratulations!": `F${EacuteUni}LICITATIONS!`,
    "You've Gained": `Vous avez remport${eacuteUni}`,
    "Earn an Entry!": "REMPORTEZ UN CHANCE!",
    "Take a few moments to complete a survey, and you'll earn an extra entry. Take all three, and you will get a bonus fourth entry.": "Prenez quelques minutes pour répondre à un sondage et vous obtenez un bulletin de participation supplémentaire.",
    "Win Extra Entries!": "REMPORTEZ DES CHANCES SUPPLÉMENTAIRES!",
    "Pick the Winning Driver": `S${eacuteUni}lectionnez le pilote gagnant`,
    "Pick a driver for the upcoming race. Whether it's the points leader or your gut for a dark horse, you'll gain an extra lap if they win!": `S${eacuteUni}lectionnez un pilote pour la prochaine course.  Que ce soit le pilote ayant le plus de points ou celui qui vous inspire, sa victoire vous permettra de remporter un tour suppl${eacuteUni}mentaire!`,
    "Select": `S${EacuteUni}LECTIONNER`,
    "Checkered flag": "DRAPEAU EN DAMIERS",
    "Enter by April 22": "PARTICIPEZ D'ICI LE 22 AVRIL",
    "Find out who wins the Snap-on Custom Racing Helmet. Maybe you'll be swigging the champagne (or cold milk, of course).": `D${eacuteUni}couvrez qui gagne le casque de course Snap-on personnalis${eacuteUni}. Vous sabrerez peut-${ecircUni}tre le champagne (ou du lait frais).`,
    "Off the line": `LA LIGNE DE D${EacuteUni}PART`,
    "Go! Go! Go! All laps gained during this period enter you to win the INDY 500 Experience and Ultimate Go-Fast Experience at Spring Mountain Motor Resort.": `Allez! Allez! Allez! Tous les tours accumul${eacuteUni}s pendant cette p${eacuteUni}riode vous donnent la chance de remporter l'exp${eacuteUni}rience INDY 500 et l'exp${eacuteUni}rience du CFS 500 ultime « Go-Fast » au Spring Mountain Motor Resort.`,
    "WIDE OPEN": "VITESSE MAXIMALE",
    "Keep the momentum going. All laps gained during this period enter you to win the Ultimate Go-Fast Experience at Spring Mountain Motor Resort.": `Ne perdez pas le rythme. Tous les tours accumul${eacuteUni}s pendant cette p${eacuteUni}riode vous donnent la chance de remporter l'exp${eacuteUni}rience ultime « Go-Fast » au Spring Mountain Motor Resort.`,
    "FASTEST LAP": "TOUR LE PLUS RAPIDE",
    "ENTER BY MARCH 18": "PARTICIPEZ D'ICI LE 18 MARS",
    "Keep the pedal to the metal and find out who gets the Snap-on SubStation Power Cart.": `Ne relâchez pas l'acc${eacuteUni}l${eacuteUni}rateur et d${eacuteUni}couvrez qui remporte le chariot de recharge Snap-on.`,
    "Pit stop": `ARR${EcircUni}T AU PUITS`,
    "ENTER BY FEBRUARY 11": `PARTICIPEZ D'ICI LE 11 F${EacuteUni}VRIER`,
    "Fuel up and find out who gets the Neon Sign!": `Faites le plein et d${eacuteUni}couvrez qui remporte l'affiche n${eacuteUni}on!`,
    "No entry found matching this code": `Aucun bulletin n'a ${eacuteUni}t${eacuteUni} trouv${eacuteUni} pour ce code.`,
    "Invalid game code. Please try again.": `Code de jeu non valide. Veuillez r${eacuteUni}essayer.`,
    "Game code is already claimed. Please try again.": `Ce code de jeu a d${eacuteUni}j${agraveUni} ${eacuteUni}t${eacuteUni} r${eacuteUni}clam${eacuteUni}. Veuillez r${eacuteUni}essayer.`,
    "Email is already taken.": `Cette adresse de courriel est d${eacuteUni}j${agraveUni} utilis${eacuteUni}e.`,
    "Email is already taken. Click <a href=\"#/forgot_password\">here</a> to reset password.": `Cette adresse de courriel est d${eacuteUni}j${agraveUni} utilis${eacuteUni}e. <a href=\"#/forgot_password\">Cliquez ici pour r${eacuteUni}initialiser le mot de passe.</a>`,
    "Account exists, please <a href=\"#/login\">login</a> or <a href=\"#/forgot_password\">reset password</a>": `Le compte existe d${eacuteUni}j${agraveUni}. <a href=\"#/login\">Veuillez ouvrir une session</a> ou <a href=\"#/forgot_password\">r${eacuteUni}initialiser votre mot de passe.</a>`,
    "Share your win!": "Partagez votre victoire!",
    "super-speedway-share.png": "super-speedway-share-fr.png",
    "/images/contests/phase-1.png": "/images/contests/phase-1.fr.png",
    "/images/contests/phase-2.png": "/images/contests/phase-2.fr.png",
    "/images/contests/phase-3.png": "/images/contests/phase-3.fr.png",
    "/images/contests/phase-4.png": "/images/contests/phase-4.fr.png",
    "<strong>Indy Meet</strong> &amp;<br /> <strong>Compete Adventure</strong>": "<strong>LA FOLLE</strong><br /><strong>AVENTURE INDY</strong>",
    "WINNERS AT EVERY TURN &ndash; INCLUDING 12 GRAND PRIZES": `DES GAGNANTS ${AgraveUni} CHAQUE TOUR &ndash; Y COMPRIS 12 GRANDS PRIX`,
    "Watch the video to learn more": `Visionnez la vid${eacuteUni}o pour obtenir un compl${eacuteUni}ment d'information`,
    "January": "JANVIER",
    "Qualifying": "QUALIFICATION",
    "February": `F${EacuteUni}VRIER`,
    "Green Flag": "DRAPEAU VERT",
    "March": "MARS",
    "Flat Out": "TOUT DONNER",
    "April": "AVRIL",
    "Final Sprint": "SPRINT FINAL",
    "There are over 1,100 total prizes. So enter early and often through April, and rack up those laps!": "Plus de 1 100 prix &ndash; participez tôt et souvent, et accumulez les tours!",
    "Upcoming Phases": "PHASES SUIVANTES",
    "snapon.com": "snapon.com",
    "GO": "ALLER",
    "Welcome": "BIENVENUE",
    "Welcome,": "Bienvenue,",
    "to pick your driver for a chance to gain additional laps!": `pour s${eacuteUni}lectionner votre pilote et courir la chance de remporter des tours suppl${eacuteUni}mentaires.`,
    "to pick your driver for a chance to gain additional miles!": `pour s${eacuteUni}lectionner votre pilote et courir la chance de remporter des milles suppl${eacuteUni}mentaires!`,
    "to pick your driver for a chance to gain additional entries!": `pour s${eacuteUni}lectionner votre pilote et courir la chance de remporter des bulletins suppl${eacuteUni}mentaires!`,
    "Pedal to the Metal": "PLEINS GAZ",
    "Welcome to the team": `BIENVENUE DANS L'${EacuteUni}QUIPE`,
    "Pit boss bonus": "PRIME AU PUITS",
    "Hit the nitrous": `ACC${EacuteUni}L${EacuteUni}RATION MAXIMALE`,
    "Reset": `R${EacuteUni}INITIALISER`,
    "Password Reset Sent!": `Le mot de passe a ${eacuteUni}t${eacuteUni} r${eacuteUni}initialis${eacuteUni}!`,
    'Snap-on Logo': "Logo Snap-on",
    'Win a VIP trip': "Gagnez un voyage",
    'Your total laps:': "VOTRE TOTAL DE TOURS:",
    'Five grand prize winners will receive': "CINQ GAGNANTS DU GRAND PRIX REMPORTENT",
    'Airfare': `Transport a${eacuteUni}rien`,
    'Hotel': `H${eacuteUni}bergement`,
    'Meals': "Repas",
    'Transportation': "Transport",
    'Event Tickets': `Billets pour l'${eacuteUni}v${eacuteUni}nement`,
    'VIP Pass to the Snap-on Hospitality Suite for the entire weekend': "Passe VIP pour l'Hospitality Suite de Snap-on pendant tout le week-end",
    'To Honda Indy Toronto': "AU HONDA INDY TORONTO",
    'July 14 - 16, 2023': "14 AU 16 JUILLET 2023",
    "Let\'s get this show": "VOTRE CHEMIN VERS",
    "Off the road": "DES SOMMETS INEXPLORÉS",
    "Score some": "Un peu de temps",
    "Travis time": "Avec Travis",
    "Time to get more than your": "PLUS QUE LES",
    "Hands Dirty": "MAINS SALES",
    "You could win prizes throughout the promotion, including the Grand Prize:": "Vous pouvez gagner des prix tout au long de la promotion, y compris le grand prix:",
    "3-DAY GRAND CANYON UTV ADVENTURE": "AVENTURE DE 3 JOURS EN VUTT AU GRAND CANYON",
    "Ten Grand Prize winners will spend three days and two nights under Southwestern skies with their Snap-on cohorts, a professional chef and Travis Pastrana himself showing you the ropes of piloting a Can-Am UTV over the dirt, gravel and sand of Bryce Canyon, the Mt. Trumbull Wilderness and the world\'s greatest natural wonder &ndash; the Grand Canyon.": "Dix gagnants du grand prix passeront trois jours et deux nuits sous le ciel du Sud-Ouest avec leurs collègues de Snap-on, un chef professionnel et Travis Pastrana, en personne, pour vous montrer les ficelles de la conduite d'un VUTT Can-Am dans la poussière, le gravier et le sable au Bryce Canyon, Mt. Trumbull Wilderness, et de la plus grande merveille naturelle du monde : le Grand Canyon.",
    "Enter your miles here": "ENTRER VOS MILLES ICI",
    "Every mile is an entry to win &ndash;<br />so START RACKING \'EM UP TODAY": "CHAQUE MILLE EST UNE CHANCE DE GAGNER &ndash;<br />COMMENCEZ À LES ACCUMULER DÈS MAINTENANT",
    "/images/hero-label-phase-1-mobile.png": "/images/hero-label-phase-1-mobile.fr.png",
    "/images/hero-label-phase-2-mobile.png": "/images/hero-label-phase-2-mobile.fr.png",
    "/images/hero-label-phase-3-mobile.png": "/images/hero-label-phase-3-mobile.fr.png",
    "/images/hero-label-phase-4-mobile.png": "/images/hero-label-phase-4-mobile.fr.png",
    "/images/hero-phase-1.png": "/images/hero-phase-1.fr.png",
    "/images/hero-phase-2.png": "/images/hero-phase-2.fr.png",
    "/images/hero-phase-3.png": "/images/hero-phase-3.fr.png",
    "/images/hero-phase-4.png": "/images/hero-phase-4.fr.png",
    "/images/prizes/pizza-oven.png": "/images/prizes/pizza-oven.fr.png",
    "/images/prizes/pizza-oven-mobile.png": "/images/prizes/pizza-oven-mobile.fr.png",
    "/images/prizes/knife.png": "/images/prizes/knife.fr.png",
    "/images/prizes/knife-mobile.png": "/images/prizes/knife-mobile.fr.png",
    "/images/prizes/game-tote.png": "/images/prizes/game-tote.fr.png",
    "/images/prizes/game-tote-mobile.png": "/images/prizes/game-tote-mobile.fr.png",
    "/images/prizes/sticker-pack.png": "/images/prizes/sticker-pack.fr.png",
    "/images/prizes/sticker-pack-mobile.png": "/images/prizes/sticker-pack-mobile.fr.png",
    "/images/prizes/metal-sign.png": "/images/prizes/metal-sign.fr.png",
    "/images/prizes/metal-sign-mobile.png": "/images/prizes/metal-sign-mobile.fr.png",
    "/images/prizes/water-bottle.png": "/images/prizes/water-bottle.fr.png",
    "/images/prizes/water-bottle-mobile.png": "/images/prizes/water-bottle-mobile.fr.png",
    "/images/prizes/final-chance.png": "/images/prizes/final-chance.fr.png",
    "/images/prizes/final-chance-mobile.png": "/images/prizes/final-chance-mobile.fr.png",
    "/images/pitpasses.png": "/images/pitpasses-fr.png",
    "/images/customizedbyu.png": "/images/customizedbyu-fr.png",
    "/images/customized4u.png": "/images/customized4u-fr.png",
    "/images/phase-complete.png": "/images/phase-complete-fr.png",
    "/images/phase-complete-stacked.png": "/images/phase-complete-stacked-fr.png",
    "Additional Prizes you could win": "PRIX SUPPLÉMENTAIRES QUE VOUS POURRIEZ GAGNER",
    "for miles earned by January 26": "POUR LES MILLES ACCUMULÉS D'ICI LE 26 JANVIER",
    "for miles earned by February 23": "POUR LES MILLES ACCUMULÉS D'ICI LE 23 FÉVRIER",
    "for miles earned by March 29": "POUR LES MILLES ACCUMULÉS D'ICI LE 29 MARS",
    "Watch the": "VOYEZ L'APERÇU",
    "SUPERSPEEDWAY<br />PAY DIRT OVERVIEW": "DU SUPERSPEEDWAY<br />PAY DIRT",
    "Check out": "DÉCOUVREZ CE",
    "WHAT YOU HAVE A<br />SHOT AT WINNING": "QUE VOUS<br />POURRIEZ GAGNER.",
    "You have": "VOUS AVEZ",
    "Miles!": "milles!",
    "Mile": "MILLE",
    "Miles": "MILLES",
    "Gain a Mile": "REMPORTEZ UN MILLE",
    "Win Extra Miles!": "REMPORTEZ DES MILLES SUPPLÉMENTAIRES!",
    "Pick a driver for the upcoming race. Whether it\'s the points leader or your gut for a dark horse, you\'ll gain an extra mile if they win. And not only that &ndash; when Snap-on wins, everybody wins! If a Snap-on driver wins any of the three races, everyone who participated in picking a driver gets an extra mile. And if you pick a Snap-on driver and that driver wins, you get three extra miles!": "Sélectionnez un pilote pour la prochaine course. S'il gagne, vous gagnez un mille supplémentaire. Si un pilote Snap-on gagne, tous ceux qui l'ont choisi remportent un mille supplémentaire. Et si vous choisissez un pilote Snap-on gagnant, vous gagnez trois milles supplémentaires!",
    "For Choosing the Winning Driver": "POUR AVOIR CHOISI LE PILOTE GAGNANT",
    "For Your Driver Selection": "POUR VOTRE SÉLECTION DE PILOTE",
    "A PROMOTION SO MASSIVE IT NEEDS": "UNE PROMOTION SI IMPOSANTE QU’ELLE&nbsp;NÉCESSITE",
    "TWO GRAND PRIZES": "DEUX GRANDS PRIX",
    "Through each of the two phases, when you purchase select products, make payments and more, you\'ll earn a Pit Pass good for 1, 5, 10 or 20 entries.": "Au cours de chacune des deux phases, lorsque vous achetez des produits sélectionnés, que vous effectuez des paiements et plus encore, vous remportez un laissez-passer « Direct au puits » qui donne droit à 1, 5, 10 ou 20 bulletins de participation.",
    "Register your entries below, and you\'ll be qualified to win one of the two Grand Prizes!": "Enregistrez vos bulletins de participation ci-dessous pour courir la chance de gagner l\'un des deux&nbsp;grands&nbsp;prix!",
    "PHASE ONE GRAND PRIZE (10 TOTAL)": "GRAND PRIX DE LA PHASE UN (10 GAGNANTS)",
    "JANUARY 6 &ndash; FEBRUARY 14": "6 JANVIER &ndash; 14 FÉVRIER",
    "Win a Team Penske VIP Race Experience with Austin Cindric at Bristol Motor Speedway and an Elizabethton Insider Plant Tour, where you\'ll receive a Limited-Edition Tennessee Tool Drawer in PRO-FI&trade; Organization CUSTOMIZED FOR YOU.": "Gagnez une expérience de course VIP Team Penske en compagnie d’Austin Cindric au Bristol Motor Speedway et une visite privée de l'usine d’Elizabethton, où vous recevrez un tiroir à outils d’édition limitée Tennessee dans un système de rangement PRO-FI&trade; PERSONNALISÉ POUR VOUS.",
    "PHASE TWO GRAND PRIZE (10 TOTAL)": "GRAND PRIX DE LA PHASE DEUX (10 GAGNANTS)",
    "FEBRUARY 24 &ndash; APRIL 4": "24 FÉVRIER &ndash; 4 AVRIL",
    "Win a Team Penske VIP Race Experience with Josef Newgarden at Iowa Speedway and an Algona Insider Plant Tour, where you\'ll take home a Limited-Edition Hawkeye Hero 60&quot; EPIQ&trade; Series Roll Cab CUSTOMIZED BY YOU.": "Gagnez une expérience de course VIP Team Penske en compagnie de Josef Newgarden à l’Iowa Speedway et une visite privée de l'usine d’Algona, où vous repartirez avec une servante mobile de 60 po de série EPIQ&trade; d’édition limitée Hawkeye Hero PERSONNALISÉE PAR VOUS.",
    "UPCOMING PHASE": "Phase à venir",
    "PREVIOUS PHASE": "Phase précédente",
    "CURRENT PHASE": "Phase actuelle",
    "Pick your driver for this week\'s race to earn additional entries if they win!": "Sélectionnez votre pilote gagnant de la course de cette semaine!",
    "Pick your driver for this week\'s race!": "Sélectionnez votre pilote gagnant de la course de cette semaine",
    "Your total entries": "BULLETINS AU TOTAL",
    "Plant Tour Challenge": "VISITE DE L’USINE",
    "Each entry gets you closer to the next stop on your route =": "Chaque bulletin de participation vous rapproche de la victoire =",
    "Bonus Entries!": "BULLETINS EN PRIME!",
    "You are here": "VOUS ÊTES ICI",
    "Your total": "BULLETINS",
    "Entries": "AU TOTAL",
    "You are": "IL VOUS MANQUE",
    "entries away from": "bulletins pour",
    "entry away from": "bulletin pour",
    "You have completed the tour!": "Vous avez terminé la visite!",
    "Snap-on is a trademark of Snap-on Incorporated. All rights reserved. ©Snap-on Incorporated. All other marks are trademarks of their respective holders. Trademarks granted by license from Penske Racing, Inc.": "Snap-on est une marque de commerce de Snap-on Incorporated. Tous droits réservés. © Snap-on Incorporated. Toutes les autres marques de commerce sont la propriété de leur détenteur respectif. Marques de commerce sous licence de Penske Racing, Inc.",
    "TENNESSEE TWO-FER": "DOUBLÉ TENNESSEE",
    "Pick your favorite driver for the upcoming race, and if your driver wins, you win an extra entry. If a Snap-on driver wins, everyone who picked any driver wins an extra entry. And if you pick a Snap-on driver and he wins, you win three extra entries!": "Choisissez votre pilote favori pour la prochaine course, et si votre pilote gagne, vous gagnez un bulletin de participation supplémentaire. Si un pilote Snap-on remporte la course, tous les participants qui ont sélectionné un pilote remportent un bulletin de participation supplémentaire. Et si vous choisissez un pilote Snap-on gagnant, vous gagnez trois bulletins de participation supplémentaires!",
    "It's Hot Lap Week! Continue playing to boost your position in Phase Two, and be sure to ask your Franchisee how you can earn additional Pit Passes.": "C’est la semaine fatidique! Continuez de jouer pour améliorer votre position en phase deux, et assurez-vous de demander à votre franchisé comment vous pouvez accumuler des laissez-passer au puits supplémentaires.",
    "THE CHECKERED FLAGS&nbsp;HAVE FLOWN": "LE DRAPEAU À DAMIERS A&nbsp;ÉTÉ BRANDI",
    "Let's head to the winner's circle. Thank you for playing!<br>We hope you had a good time and great results,<br>and we'll see you on the grid next year.": "Le cercle des gagnants est arrivé. Merci d’avoir participé! Nous espérons que vous avez aimé la course et que vous avez obtenu de bons résultats. Nous nous reverrons à la ligne de départ l’an prochain.",
    "GAME OVER": "FIN DE LA PARTIE",
    "Another incredible game is in the books! Thank you for taking part - we hope you enjoyed the competition and finished strong. We can\'t wait to see you back on the line next year.": "Un autre programme de course passionnant dans votre historique! Merci d’avoir participé — nous espérons que vous avez aimé la compétition et que vous êtes arrivé haut dans le classement."
  }
};

},{}],57:[function(require,module,exports){
var Contest, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = Contest = (function() {
  class Contest extends PromiseBaseModel {
    //END observables
    isGlobalType() {
      return this.get('type') === Contest.GLOBAL_TYPE;
    }

    isFPTType() {
      return this.get('type') === Contest.FPT_TYPE;
    }

    isFranchiseeType() {
      return this.get('type') === Contest.FRANCHISEE_TYPE;
    }

    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(Contest.prototype.attributes);
    }

    //END expand
    hasEnded() {
      var m;
      m = moment.utc(this.get('end_date'));
      if (!m.isValid()) {
        return false;
      }
      return m.isBefore(moment.utc());
    }

  };

  Contest.prototype.endpoint = 'contests';

  Contest.prototype.type = 'contests';

  Contest.prototype.label = 'Contest';

  Contest.STATUSES = [Contest.NOT_STARTED_STATUS = "not_started", Contest.STARTED_STATUS = "started", Contest.COMPLETED_STATUS = "completed"];

  Contest.TYPES = [Contest.GLOBAL_TYPE = "global", Contest.FPT_TYPE = "fpt", Contest.FRANCHISEE_TYPE = "franchisee"];

  Contest.prototype.attributes = ['id', 'name', 'type', 'code', 'status', 'winners_count', 'start_date', 'end_date', 'created_at', 'updated_at'];

  Contest.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'code': void 0,
    'type': Contest.GLOBAL_TYPE,
    'status': Contest.NOT_STARTED_STATUS,
    'start_date': void 0,
    'end_date': void 0,
    'winners_count': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  return Contest;

}).call(this);

//enD hasEnded
//END Contest

},{"../jsonapi_expander":87,"./promise.base.model":70}],58:[function(require,module,exports){
var ContestFinalist, Helpers, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

Helpers = require("../$helpers/default.helpers");

module.exports = ContestFinalist = (function() {
  class ContestFinalist extends PromiseBaseModel {
    //END observables
    expand(data) {
      var Contest, Entry, FPT, Franchisee, FranchiseeContestStatistic, JSONApiExpander, User, UserContestStatistic;
      JSONApiExpander = require("../jsonapi_expander");
      Entry = require("./entry.model");
      Contest = require("./contest.model");
      User = require("./user.model");
      FPT = require("./fpt.model");
      Franchisee = require("./franchisee.model");
      FranchiseeContestStatistic = require("./franchisee_contest_statistic.model");
      UserContestStatistic = require("./user_contest_statistic.model");
      return new JSONApiExpander(data).relation('entry').attributes(Entry.prototype.attributes).done().relation('contest').attributes(Contest.prototype.attributes).done().relation('redeemer').attributes(User.prototype.attributes).done().relation('fpt').attributes(FPT.prototype.attributes).done().relation('franchisee').attributes(Franchisee.prototype.attributes).done().relation('franchisee_contest_statistic').attributes(FranchiseeContestStatistic.prototype.attributes).done().relation('user_contest_statistic').attributes(UserContestStatistic.prototype.attributes).done().attributes(ContestFinalist.prototype.attributes);
    }

  };

  ContestFinalist.prototype.endpoint = 'contest_finalists';

  ContestFinalist.prototype.type = 'contest_finalists';

  ContestFinalist.prototype.label = 'Contest Finalist';

  ContestFinalist.prototype.attributes = ['id', 'rank', 'contest_id', 'entry_id', 'franchisee_id', 'fpt_id', 'created_at', 'updated_at'];

  ContestFinalist.prototype.defaults = {
    'contest': function() {
      var Contest;
      Contest = require("./contest.model");
      return new Contest();
    },
    'redeemer': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'fpt': function() {
      var FPT;
      FPT = require("./fpt.model");
      return new FPT();
    },
    'franchisee': function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    },
    'entry': function() {
      var Entry;
      Entry = require("./entry.model");
      return new Entry();
    },
    'franchisee_contest_statistic': function() {
      var FranchiseeContestStatistic;
      FranchiseeContestStatistic = require("./franchisee_contest_statistic.model");
      return new FranchiseeContestStatistic();
    },
    'user_contest_statistic': function() {
      var UserContestStatistic;
      UserContestStatistic = require("./user_contest_statistic.model");
      return new UserContestStatistic();
    }
  };

  //END defaults
  ContestFinalist.prototype.observables = {
    'id': void 0,
    'rank': void 0,
    'entry_id': void 0,
    'contest_id': void 0,
    'franchisee_id': void 0,
    'fpt_id': void 0,
    'created_at': "",
    'updated_at': ""
  };

  return ContestFinalist;

}).call(this);

//END expand
//END ContestFinalist

},{"../$helpers/default.helpers":51,"../jsonapi_expander":87,"./contest.model":57,"./entry.model":60,"./fpt.model":61,"./franchisee.model":64,"./franchisee_contest_statistic.model":65,"./promise.base.model":70,"./user.model":82,"./user_contest_statistic.model":83}],59:[function(require,module,exports){
var ContestWinner, Helpers, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

Helpers = require("../$helpers/default.helpers");

module.exports = ContestWinner = (function() {
  class ContestWinner extends PromiseBaseModel {
    //END observables
    hasWinner() {
      if (Helpers.isUUID(this.get('entry_id'))) {
        return true;
      }
      if (Helpers.trim((this.get('winner_name') || "").toString()).length > 0) {
        return true;
      }
      return false;
    }

    //END hasWinner
    expand(data) {
      var Contest, FPT, Franchisee, JSONApiExpander, User;
      JSONApiExpander = require("../jsonapi_expander");
      Contest = require("./contest.model");
      User = require("./user.model");
      FPT = require("./fpt.model");
      Franchisee = require("./franchisee.model");
      return new JSONApiExpander(data).relation('contest').attributes(Contest.prototype.attributes).done().relation('redeemer').attributes(User.prototype.attributes).done().relation('fpt').attributes(FPT.prototype.attributes).done().relation('franchisee').attributes(Franchisee.prototype.attributes).done().attributes(ContestWinner.prototype.attributes);
    }

  };

  ContestWinner.prototype.endpoint = 'contest_winners';

  ContestWinner.prototype.type = 'contest_winners';

  ContestWinner.prototype.label = 'Contest Winner';

  ContestWinner.prototype.attributes = ['id', 'contest_id', 'entry_id', 'franchisee_id', 'fpt_id', 'winner_name', 'created_at', 'updated_at'];

  ContestWinner.prototype.defaults = {
    'contest': function() {
      var Contest;
      Contest = require("./contest.model");
      return new Contest();
    },
    'redeemer': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'fpt': function() {
      var FPT;
      FPT = require("./fpt.model");
      return new FPT();
    },
    'franchisee': function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    }
  };

  //END defaults
  ContestWinner.prototype.observables = {
    'id': void 0,
    'entry_id': void 0,
    'contest_id': void 0,
    'franchisee_id': void 0,
    'fpt_id': void 0,
    'winner_name': void 0,
    'created_at': "",
    'updated_at': ""
  };

  return ContestWinner;

}).call(this);

//END expand
//END ContestWinner

},{"../$helpers/default.helpers":51,"../jsonapi_expander":87,"./contest.model":57,"./fpt.model":61,"./franchisee.model":64,"./promise.base.model":70,"./user.model":82}],60:[function(require,module,exports){
var Entry, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = Entry = (function() {
  class Entry extends PromiseBaseModel {
    //END observables
    expand(data) {
      var Contest, Contests, FPT, Franchisee, JSONApiExpander, Region, User;
      JSONApiExpander = require("../jsonapi_expander");
      Franchisee = require("./franchisee.model");
      FPT = require("./fpt.model");
      Region = require("./region.model");
      User = require("./user.model");
      Contest = require("./contest.model");
      Contests = require("../$collections/contests.collection");
      return new JSONApiExpander(data).relation('redeemer').attributes(User.prototype.attributes).done().relation('franchisee').attributes(Franchisee.prototype.attributes).done().relation('fpt').attributes(FPT.prototype.attributes).done().relation('region').attributes(Region.prototype.attributes).done().relation('contests').attributes(Contest.prototype.attributes).done().relation('virtual_entries').attributes(Entry.prototype.attributes).done().attributes(Entry.prototype.attributes);
    }

    //END expand
    static isValidCode(code) {
      if (!_.isString(code)) {
        return false;
      }
      return /^[a-z]{12}$/i.test(code);
    }

  };

  Entry.prototype.endpoint = 'entries';

  Entry.prototype.type = 'entries';

  Entry.prototype.label = 'Entry';

  Entry.prototype.attributes = ['id', 'code', 'bonus_entries', 'redeemer_id', 'redeemed_at', 'created_at', 'updated_at', 'was_awarded_prize', 'is_instant_winner', 'reached_milestone'];

  Entry.prototype.defaults = {
    'redeemer': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'franchisee': function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    },
    'fpt': function() {
      var FPT;
      FPT = require("./fpt.model");
      return new FPT();
    },
    'region': function() {
      var Region;
      Region = require("./region.model");
      return new Region();
    },
    'contests': function() {
      var Contests;
      Contests = require("../$collections/contests.collection");
      return new Contests();
    },
    'virtual_entries': function() {
      var Entries;
      Entries = require("../$collections/entries.collection");
      return new Entries();
    }
  };

  //END defaults
  Entry.prototype.observables = {
    'id': void 0,
    'code': void 0,
    'bonus_entries': void 0,
    'redeemer_id': void 0,
    'redeemed_at': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'was_awarded_prize': void 0,
    'is_instant_winner': void 0,
    'reached_milestone': false
  };

  return Entry;

}).call(this);

//END isValidCode
//END Entry

},{"../$collections/contests.collection":27,"../$collections/entries.collection":28,"../jsonapi_expander":87,"./contest.model":57,"./fpt.model":61,"./franchisee.model":64,"./promise.base.model":70,"./region.model":75,"./user.model":82}],61:[function(require,module,exports){
var FPT, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = FPT = (function() {
  class FPT extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    hasOwner() {
      return Helpers.isUUID(this.get('owner_id'));
    }

    expand(data) {
      var FPTContestStatistic, FPTContestStatistics, FPTStatistic, FPTStatistics, JSONApiExpander, Region, RegionContestStatistic, RegionStatistic, User;
      JSONApiExpander = require("../jsonapi_expander");
      User = require("./user.model");
      Region = require("./region.model");
      FPTStatistic = require("./fpt_statistic.model");
      FPTStatistics = require("../$collections/fpt_statistics.collection");
      FPTContestStatistic = require("./fpt_contest_statistic.model");
      FPTContestStatistics = require("../$collections/fpt_contest_statistics.collection");
      RegionStatistic = require("./region_statistic.model");
      RegionContestStatistic = require("./region_contest_statistic.model");
      return new JSONApiExpander(data).relation('owner').attributes(User.prototype.attributes).done().relation('region').attributes(Region.prototype.attributes).relation('statistics').attributes(RegionStatistic.prototype.attributes).done().relation('contest_statistics').attributes(RegionContestStatistic.prototype.attributes).done().done().relation('statistics').attributes(FPTStatistic.prototype.attributes).done().relation('contest_statistics').attributes(FPTContestStatistic.prototype.attributes).done().attributes(FPT.prototype.attributes);
    }

  };

  FPT.prototype.endpoint = 'fpts';

  FPT.prototype.type = 'fpts';

  FPT.prototype.label = 'FPT';

  FPT.prototype.attributes = ['id', 'name', 'email', 'owner_id', 'region_id', 'snapon_sso_id', 'created_at', 'updated_at'];

  FPT.prototype.defaults = {
    'owner': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'region': function() {
      var Region;
      Region = require("./region.model");
      return new Region();
    },
    'statistics': function() {
      var FPTStatistics;
      FPTStatistics = require("../$collections/fpt_statistics.collection");
      return new FPTStatistics();
    },
    'contest_statistics': function() {
      var FPTContestStatistics;
      FPTContestStatistics = require("../$collections/fpt_contest_statistics.collection");
      return new FPTContestStatistics();
    }
  };

  //END defaults
  FPT.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'email': void 0,
    'owner_id': void 0,
    'region_id': void 0,
    'snapon_sso_id': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return FPT;

}).call(this);

//END expand
//END GameKit

},{"../$collections/fpt_contest_statistics.collection":29,"../$collections/fpt_statistics.collection":30,"../jsonapi_expander":87,"./fpt_contest_statistic.model":62,"./fpt_statistic.model":63,"./promise.base.model":70,"./region.model":75,"./region_contest_statistic.model":76,"./region_statistic.model":77,"./user.model":82}],62:[function(require,module,exports){
var FPTContestStatistic, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = FPTContestStatistic = (function() {
  class FPTContestStatistic extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    expand(data) {
      var Contest, JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      Contest = require("./contest.model");
      return new JSONApiExpander(data).attributes(FPTContestStatistic.prototype.attributes).relation('contest').attributes(Contest.prototype.attributes).done();
    }

  };

  FPTContestStatistic.prototype.endpoint = 'fpt_contest_statistics';

  FPTContestStatistic.prototype.type = 'fpt_contest_statistics';

  FPTContestStatistic.prototype.label = 'FPT Contest Statistics';

  FPTContestStatistic.prototype.attributes = ['fpt_id', 'contest_id', 'entry_count', 'virtual_entry_count', 'redeemed_entry_count', 'redeemed_virtual_entry_count', 'participant_count', 'game_kit_count', 'registered_franchisee_count'];

  FPTContestStatistic.prototype.defaults = {
    'fpt_id': void 0,
    'contest_id': void 0
  };

  //END defaults
  FPTContestStatistic.prototype.observables = {
    'entry_count': 0,
    'virtual_entry_count': 0,
    'redeemed_entry_count': 0,
    'redeemed_virtual_entry_count': 0,
    'participant_count': 0,
    'game_kit_count': 0,
    'registered_franchisee_count': 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return FPTContestStatistic;

}).call(this);

//END expand
//END FPTContestStatistic

},{"../jsonapi_expander":87,"./contest.model":57,"./promise.base.model":70}],63:[function(require,module,exports){
var FPTStatistic, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = FPTStatistic = (function() {
  class FPTStatistic extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(FPTStatistic.prototype.attributes);
    }

  };

  FPTStatistic.prototype.endpoint = 'fpt_statistics';

  FPTStatistic.prototype.type = 'fpt_statistics';

  FPTStatistic.prototype.label = 'FPT Statistics';

  FPTStatistic.prototype.attributes = ['fpt_id', 'entry_count', 'virtual_entry_count', 'redeemed_entry_count', 'redeemed_virtual_entry_count', 'participant_count', 'game_kit_count', 'registered_franchisee_count', "survey_response_count", 'regional_acquisition_percentage'];

  FPTStatistic.prototype.defaults = {
    'fpt_id': void 0
  };

  //END defaults
  FPTStatistic.prototype.observables = {
    'entry_count': 0,
    'virtual_entry_count': 0,
    'redeemed_entry_count': 0,
    'redeemed_virtual_entry_count': 0,
    'participant_count': 0,
    'game_kit_count': 0,
    'registered_franchisee_count': 0,
    "survey_response_count": 0,
    "regional_acquisition_percentage": 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return FPTStatistic;

}).call(this);

//END expand
//END FPTStatistic

},{"../jsonapi_expander":87,"./promise.base.model":70}],64:[function(require,module,exports){
var Franchisee, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = Franchisee = (function() {
  class Franchisee extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    hasOwner() {
      return Helpers.isUUID(this.get('owner_id'));
    }

    hasFPT() {
      return Helpers.isUUID(this.get('fpt_id'));
    }

    expand(data) {
      var FPT, FranchiseeContestStatistic, FranchiseeContestStatistics, FranchiseeStatistic, FranchiseeStatistics, JSONApiExpander, Region, User, Users;
      JSONApiExpander = require("../jsonapi_expander");
      FPT = require("./fpt.model");
      Region = require("./region.model");
      FranchiseeStatistic = require("./franchisee_statistic.model");
      FranchiseeStatistics = require("../$collections/franchisee_statistics.collection");
      FranchiseeContestStatistic = require("./franchisee_contest_statistic.model");
      FranchiseeContestStatistics = require("../$collections/franchisee_contest_statistics.collection");
      User = require("./user.model");
      Users = require("../$collections/users.collection");
      return new JSONApiExpander(data).relation('fpt').attributes(FPT.prototype.attributes).done().relation('region').attributes(Region.prototype.attributes).done().relation('owner').attributes(User.prototype.attributes).done().relation('users').attributes(User.prototype.attributes).done().relation('statistics').attributes(FranchiseeStatistic.prototype.attributes).done().relation('contest_statistics').attributes(FranchiseeContestStatistic.prototype.attributes).done().attributes(Franchisee.prototype.attributes);
    }

  };

  Franchisee.prototype.endpoint = 'franchisees';

  Franchisee.prototype.type = 'franchisees';

  Franchisee.prototype.label = 'Franchisee';

  Franchisee.prototype.attributes = ['id', 'name', 'email', 'address_1', 'address_2', 'city', 'state', 'country', 'zip_code', 'phone_number', 'mobile_phone_number', 'bp_number', 'locale', 'snapon_sso_id', 'owner_id', 'fpt_id', 'created_at', 'updated_at'];

  Franchisee.prototype.defaults = {
    'fpt': function() {
      var FPT;
      FPT = require("./fpt.model");
      return new FPT();
    },
    'region': function() {
      var Region;
      Region = require("./region.model");
      return new Region();
    },
    'owner': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'users': function() {
      var Users;
      Users = require("../$collections/users.collection");
      return new Users();
    },
    'statistics': function() {
      var FranchiseeStatistics;
      FranchiseeStatistics = require("../$collections/franchisee_statistics.collection");
      return new FranchiseeStatistics();
    },
    'contest_statistics': function() {
      var FranchiseeContestStatistics;
      FranchiseeContestStatistics = require("../$collections/franchisee_contest_statistics.collection");
      return new FranchiseeContestStatistics();
    },
    'franchisee_settings': function() {
      var FranchiseeSettings;
      FranchiseeSettings = require("../$collections/franchisee_settings.collection");
      return new FranchiseeSettings();
    }
  };

  //END defaults
  Franchisee.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'email': void 0,
    'address_1': void 0,
    'address_2': void 0,
    'city': void 0,
    'state': void 0,
    'country': void 0,
    'zip_code': void 0,
    'phone_number': void 0,
    'mobile_phone_number': void 0,
    'bp_number': void 0,
    'owner_id': void 0,
    'fpt_id': void 0,
    'snapon_sso_id': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'locale': void 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return Franchisee;

}).call(this);

//END expand
//END Franchisee

},{"../$collections/franchisee_contest_statistics.collection":32,"../$collections/franchisee_settings.collection":33,"../$collections/franchisee_statistics.collection":34,"../$collections/users.collection":48,"../jsonapi_expander":87,"./fpt.model":61,"./franchisee_contest_statistic.model":65,"./franchisee_statistic.model":67,"./promise.base.model":70,"./region.model":75,"./user.model":82}],65:[function(require,module,exports){
var FranchiseeContestStatistic, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = FranchiseeContestStatistic = (function() {
  class FranchiseeContestStatistic extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    expand(data) {
      var Contest, JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      Contest = require("./contest.model");
      return new JSONApiExpander(data).attributes(FranchiseeContestStatistic.prototype.attributes).relation('contest').attributes(Contest.prototype.attributes).done();
    }

  };

  FranchiseeContestStatistic.prototype.endpoint = 'franchisee_contest_statistics';

  FranchiseeContestStatistic.prototype.type = 'franchisee_contest_statistics';

  FranchiseeContestStatistic.prototype.label = 'Franchisee Contest Statistics';

  FranchiseeContestStatistic.prototype.attributes = ['franchisee_id', 'contest_id', 'entry_count', 'virtual_entry_count', 'redeemed_entry_count', 'redeemed_virtual_entry_count', 'participant_count', 'game_kit_count'];

  FranchiseeContestStatistic.prototype.defaults = {
    'franchisee_id': void 0,
    'contest_id': void 0
  };

  //END defaults
  FranchiseeContestStatistic.prototype.observables = {
    'entry_count': 0,
    'virtual_entry_count': 0,
    'redeemed_entry_count': 0,
    'redeemed_virtual_entry_count': 0,
    'participant_count': 0,
    'game_kit_count': 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return FranchiseeContestStatistic;

}).call(this);

//END expand
//END FranchiseeContestStatistic

},{"../jsonapi_expander":87,"./contest.model":57,"./promise.base.model":70}],66:[function(require,module,exports){
var FranchiseeSetting, Helpers, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

Helpers = require("../$helpers/default.helpers");

module.exports = FranchiseeSetting = (function() {
  class FranchiseeSetting extends PromiseBaseModel {
    //END observables
    expand(data) {
      var Franchisee, JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      Franchisee = require("./franchisee.model");
      return new JSONApiExpander(data).relation('franchisee').attributes(Franchisee.prototype.attributes).done().attributes(FranchiseeSetting.prototype.attributes);
    }

  };

  FranchiseeSetting.prototype.endpoint = 'franchisee_settings';

  FranchiseeSetting.prototype.type = 'franchisee_settings';

  FranchiseeSetting.prototype.label = 'Franchisee Setting';

  FranchiseeSetting.prototype.attributes = ['id', 'franchisee_id', 'leaderboard_length', 'created_at', 'updated_at'];

  FranchiseeSetting.prototype.defaults = {
    'franchisee': function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    }
  };

  //END franchisee
  //END defaults
  FranchiseeSetting.prototype.observables = {
    'id': void 0,
    'franchisee_id': void 0,
    'leaderboard_length': void 0,
    'created_at': "",
    'updated_at': ""
  };

  return FranchiseeSetting;

}).call(this);

//END expand
//END FranchiseeSetting

},{"../$helpers/default.helpers":51,"../jsonapi_expander":87,"./franchisee.model":64,"./promise.base.model":70}],67:[function(require,module,exports){
var FranchiseeStatistic, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = FranchiseeStatistic = (function() {
  class FranchiseeStatistic extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(FranchiseeStatistic.prototype.attributes);
    }

  };

  FranchiseeStatistic.prototype.endpoint = 'franchisee_statistics';

  FranchiseeStatistic.prototype.type = 'franchisee_statistics';

  FranchiseeStatistic.prototype.label = 'Franchisee Statistics';

  FranchiseeStatistic.prototype.attributes = ['franchisee_id', 'entry_count', 'virtual_entry_count', 'redeemed_entry_count', 'redeemed_virtual_entry_count', 'participant_count', 'game_kit_count', "survey_response_count"];

  FranchiseeStatistic.prototype.defaults = {
    'franchisee_id': void 0
  };

  //END defaults
  FranchiseeStatistic.prototype.observables = {
    'entry_count': 0,
    'virtual_entry_count': 0,
    'redeemed_entry_count': 0,
    'redeemed_virtual_entry_count': 0,
    'participant_count': 0,
    'game_kit_count': 0,
    "survey_response_count": 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return FranchiseeStatistic;

}).call(this);

//END expand
//END FranchiseeStatistic

},{"../jsonapi_expander":87,"./promise.base.model":70}],68:[function(require,module,exports){
var GameKit, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = GameKit = (function() {
  class GameKit extends PromiseBaseModel {
    //END observables
    expand(data) {
      var Contest, Contests, Entries, Entry, Franchisee, JSONApiExpander, User;
      JSONApiExpander = require("../jsonapi_expander");
      Entry = require("./entry.model");
      Entries = require("../$collections/entries.collection");
      Contests = require("../$collections/contests.collection");
      Contest = require("./contest.model");
      Franchisee = require("./franchisee.model");
      User = require("./user.model");
      return new JSONApiExpander(data).relation('franchisee').attributes(Franchisee.prototype.attributes).done().relation('entries').attributes(Entry.prototype.attributes).done().relation('contests').attributes(Contest.prototype.attributes).done().relation('redeemer').attributes(User.prototype.attributes).done().attributes(GameKit.prototype.attributes);
    }

    //END expand
    static isValidCode(code) {
      if (!_.isString(code)) {
        return false;
      }
      return /^[0-9]{10}$/.test(code);
    }

  };

  GameKit.prototype.endpoint = 'game_kits';

  GameKit.prototype.type = 'game_kits';

  GameKit.prototype.label = 'Game Kit';

  GameKit.prototype.attributes = ['id', 'code', 'contest_ids', 'participant_count', 'entry_count', 'redeemed_entry_count', 'franchisee_id', 'redeemed_at', 'created_at', 'updated_at'];

  GameKit.prototype.defaults = {
    'franchisee': function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    },
    'entries': function() {
      var Entries;
      Entries = require("../$collections/entries.collection");
      return new Entries();
    },
    'contests': function() {
      var Contests;
      Contests = require("../$collections/contests.collection");
      return new Contests();
    },
    'redeemer': function() {
      var User;
      User = require("./user.model");
      return new User();
    }
  };

  //END defaults
  GameKit.prototype.observables = {
    'id': void 0,
    'code': void 0,
    'entry_count': void 0,
    'redeemed_entry_count': void 0,
    'participant_count': void 0,
    'contest_ids': [],
    'franchisee_id': void 0,
    'redeemed_at': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  return GameKit;

}).call(this);

//END isValidCode
//END GameKit

},{"../$collections/contests.collection":27,"../$collections/entries.collection":28,"../jsonapi_expander":87,"./contest.model":57,"./entry.model":60,"./franchisee.model":64,"./promise.base.model":70,"./user.model":82}],69:[function(require,module,exports){
var Invite, PromiseBaseModel;

PromiseBaseModel = require("./promise.base.model");

module.exports = Invite = (function() {
  class Invite extends PromiseBaseModel {
    //END observables
    expand(data) {
      var FPT, Franchisee, JSONApiExpander, Region;
      JSONApiExpander = require("../jsonapi_expander");
      FPT = require("./fpt.model");
      Franchisee = require("./franchisee.model");
      Region = require("./region.model");
      return new JSONApiExpander(data).relation('fpt').attributes(FPT.prototype.attributes).done().relation('franchisee').attributes(Franchisee.prototype.attributes).done().relation('region').attributes(Region.prototype.attributes).done().attributes(Invite.prototype.attributes);
    }

  };

  Invite.prototype.endpoint = "invites";

  Invite.prototype.label = "Invite";

  Invite.TYPES = [Invite.ADMIN_TYPE = "admin", Invite.REGION_TYPE = "region", Invite.FPT_TYPE = "fpt", Invite.FRANCHISEE_TYPE = "franchisee"];

  Invite.prototype.attributes = ['id', 'code', 'type', 'email', 'fpt_id', 'franchisee_id', 'region_id', 'created_at', 'updated_at'];

  Invite.prototype.defaults = {
    'fpt': function() {
      var FPT;
      FPT = require("./fpt.model");
      return new FPT();
    },
    'franchisee': function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    },
    'region': function() {
      var Region;
      Region = require("./region.model");
      return new Region();
    }
  };

  //END defaults
  Invite.prototype.observables = {
    'id': void 0,
    'code': "",
    'type': Invite.ADMIN_TYPE,
    'email': "",
    'fpt_id': void 0,
    'franchisee_id': void 0,
    'region_id': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  return Invite;

}).call(this);

//END expand
//END invite

},{"../jsonapi_expander":87,"./fpt.model":61,"./franchisee.model":64,"./promise.base.model":70,"./region.model":75}],70:[function(require,module,exports){
var PromiseBaseModel;

module.exports = PromiseBaseModel = (function() {
  class PromiseBaseModel extends Falcon.Model {
    expand() {
      throw new Error(`expand not implemented for ${this.endpoint}`);
    }

    //END expand
    makeUrl(type, parent) {
      var endpoint, parent_url;
      if (parent == null) {
        return super.makeUrl(type, parent);
      }
      parent_url = parent.makeUrl(Falcon.GET);
      endpoint = (function() {
        switch (type) {
          //TODO: Determine the appropriate ur structure for parent GET and PUT
          case Falcon.GET:
          case Falcon.PUT:
            return this.endpoint + "/" + this.get('id');
          case Falcon.POST:
            return "links/" + this.endpoint;
          case Falcon.DELETE:
            return "links/" + this.endpoint + "/" + this.get('id');
          default:
            return this.endpoint;
        }
      }).call(this);
      //END endpoint
      return parent_url + "/" + endpoint;
    }

    //END makeUrl
    serializeRequestData(type, options) {
      var data;
      data = super.serializeRequestData(type, options);
      if ((options.parent != null) && type === Falcon.POST) {
        data = [data];
      }
      return {data};
    }

    //END serializeRequestData
    promiseFetch(options) {
      return Q.Promise((resolve, reject) => {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, `An error occurred while fetching ${this.label}`);
        return this.fetch(options);
      });
    }

    //END promiseFetch
    promiseCreate(options) {
      return Q.Promise((resolve, reject) => {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, `An error occurred while creating ${this.label}`);
        return this.create(options);
      });
    }

    //END promiseCreate
    promiseSave(options) {
      return Q.Promise((resolve, reject) => {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, `An error occurred while saving ${this.label}`);
        return this.save(options);
      });
    }

    //END promiseSave
    promiseDestroy(options) {
      return Q.Promise((resolve, reject) => {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, `An error occurred while destroying ${this.label}`);
        return this.destroy(options);
      });
    }

    //END promiseDestroy
    parseResponseData(data, type, options) {
      if (type === Falcon.DELETE) {
        return {};
      }
      return this.expand(data).toObject();
    }

  };

  PromiseBaseModel.prototype.attributes = [];

  PromiseBaseModel.prototype.label = "";

  PromiseBaseModel.prototype.type = "";

  return PromiseBaseModel;

}).call(this);

//END parseResponseData
//END PromiseBaseModel

},{}],71:[function(require,module,exports){
var PromiseBaseModel, Question, count;

PromiseBaseModel = require("./promise.base.model");

count = 0;

module.exports = Question = (function() {
  class Question extends PromiseBaseModel {
    //END observables
    makeIdentifier(index) {
      var identifier;
      identifier = `question--${this.get('id')}`;
      if (index) {
        identifier += `--${ko.unwrap(index)}`;
      }
      return identifier;
    }

    //END makeIdentifier
    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(Question.prototype.attributes);
    }

  };

  Question.prototype.endpoint = 'questions';

  Question.prototype.type = 'questions';

  Question.prototype.label = 'Question';

  Question.TYPES = [Question.MULTIPLE_CHOICE_TYPE = "multiple-choice", Question.SINGLE_CHOICE_TYPE = "single-choice"];

  Question.ALERT_TYPES = [Question.NONE = "No Alert", Question.STORAGE_LEAD = "Survey - Tool Storage", Question.DIAGNOSTICS_LEAD = "Survey - Diagnostic Scan Tool"];

  Question.prototype.attributes = ['id', 'question', 'question_fr', 'type', 'order', 'options', 'options_fr', 'survey_id', 'created_at', 'updated_at', 'alert_types'];

  Question.prototype.observables = {
    'id': void 0,
    'question': void 0,
    'question_fr': void 0,
    'type': void 0,
    'order': void 0,
    'survey_id': void 0,
    'options': [],
    'options_fr': [],
    'created_at': void 0,
    'updated_at': void 0,
    'alert_types': [],
    'is_single_choice': function() {
      return this.get('type') === Question.SINGLE_CHOICE_TYPE;
    },
    'is_multiple_choice': function() {
      return this.get('type') === Question.MULTIPLE_CHOICE_TYPE;
    }
  };

  return Question;

}).call(this);

//END expand
//END Question

},{"../jsonapi_expander":87,"./promise.base.model":70}],72:[function(require,module,exports){
var PromiseBaseModel, Race;

PromiseBaseModel = require("./promise.base.model");

module.exports = Race = (function() {
  class Race extends PromiseBaseModel {
    //END observables
    expand(data) {
      var JSONApiExpander, RaceOption;
      JSONApiExpander = require("../jsonapi_expander");
      RaceOption = require("./race_option.model");
      return new JSONApiExpander(data).relation('race_options').attributes(RaceOption.prototype.attributes).done().relation('selected_race_option').attributes(RaceOption.prototype.attributes).done().attributes(Race.prototype.attributes);
    }

  };

  Race.prototype.endpoint = 'races';

  Race.prototype.type = 'races';

  Race.prototype.label = 'Race';

  Race.prototype.attributes = ['id', 'name', 'name_fr', 'selected_race_option_id', 'start_date', 'end_date', 'created_at', 'updated_at'];

  Race.prototype.defaults = {
    'race_options': function() {
      var RaceOptions;
      RaceOptions = require("../$collections/race_options.collection");
      return new RaceOptions();
    },
    //END race_options
    'selected_race_option': function() {
      var RaceOption;
      RaceOption = require("./race_option.model");
      return new RaceOption();
    }
  };

  //END selected_race_option
  //END defaults
  Race.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'start_date': void 0,
    'end_date': void 0,
    'selected_race_option_id': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  return Race;

}).call(this);

//END expand
//END Race

},{"../$collections/race_options.collection":38,"../jsonapi_expander":87,"./promise.base.model":70,"./race_option.model":73}],73:[function(require,module,exports){
var PromiseBaseModel, RaceOption, count;

PromiseBaseModel = require("./promise.base.model");

count = 0;

module.exports = RaceOption = (function() {
  class RaceOption extends PromiseBaseModel {
    //END observables
    makeIdentifier(index) {
      var identifier;
      identifier = `race-option--${this.get('id')}`;
      if (index) {
        identifier += `--${ko.unwrap(index)}`;
      }
      return identifier;
    }

    //END makeIdentifier
    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(RaceOption.prototype.attributes);
    }

  };

  RaceOption.prototype.endpoint = 'race_options';

  RaceOption.prototype.type = 'race_options';

  RaceOption.prototype.label = 'RaceOption';

  RaceOption.prototype.attributes = ['id', 'label', 'label_fr', 'order', 'is_snapon_driver', 'race_id', 'created_at', 'updated_at'];

  RaceOption.prototype.observables = {
    'id': void 0,
    'label': void 0,
    'label_fr': void 0,
    'order': void 0,
    'race_id': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  return RaceOption;

}).call(this);

//END expand
//END RaceOption

},{"../jsonapi_expander":87,"./promise.base.model":70}],74:[function(require,module,exports){
var PromiseBaseModel, RaceSelection;

PromiseBaseModel = require("./promise.base.model");

module.exports = RaceSelection = (function() {
  class RaceSelection extends PromiseBaseModel {
    //END observables
    initialize() {
      return this.validation.decorate("validatable");
    }

    //END initialize
    expand(data) {
      var Entry, Franchisee, JSONApiExpander, Race, RaceOption, User;
      JSONApiExpander = require("../jsonapi_expander");
      Race = require("./race.model");
      RaceOption = require("./race_option.model");
      User = require("./user.model");
      Franchisee = require("./franchisee.model");
      Entry = require("./entry.model");
      return new JSONApiExpander(data).relation('race').attributes(Race.prototype.attributes).relation('race_options').attributes(RaceOption.prototype.attributes).done().done().relation('race_option').attributes(RaceOption.prototype.attributes).done().relation('user').attributes(User.prototype.attributes).done().relation('franchisee').attributes(Franchisee.prototype.attributes).done().relation('entry').attributes(Entry.prototype.attributes).done().attributes(RaceSelection.prototype.attributes);
    }

  };

  RaceSelection.prototype.endpoint = 'race_selections';

  RaceSelection.prototype.type = 'race-selections';

  RaceSelection.prototype.label = 'RaceSelection';

  RaceSelection.prototype.attributes = ['id', 'race_id', 'race_option_id', 'user_id', 'franchisee_id', 'entry_id', 'did_notify', 'did_notify_at', 'notify_milestone', 'created_at', 'updated_at'];

  RaceSelection.prototype.defaults = {
    race: function() {
      var Race;
      Race = require("./race.model");
      return new Race();
    },
    race_option: function() {
      var RaceOption;
      RaceOption = require("./race_option.model");
      return new RaceOption();
    },
    user: function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    franchisee: function() {
      var Franchisee;
      Franchisee = require("./franchisee.model");
      return new Franchisee();
    },
    entry: function() {
      var Entry;
      Entry = require("./entry.model");
      return new Entry();
    }
  };

  //END defaults
  RaceSelection.prototype.observables = {
    'id': void 0,
    'race_id': void 0,
    'race_option_id': void 0,
    'user_id': void 0,
    'franchisee_id': void 0,
    'entry_id': void 0,
    'did_notify': void 0,
    'did_notify_at': void 0,
    'notify_milestone': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    // Non serialized observables
    validation: void 0,
    has_error: function() {
      return ko.unwrap(this.validation.is_invalid);
    },
    error: function() {
      if (this.get('has_error')) {
        return ko.unwrap(this.validation.validation_message);
      } else {
        return void 0;
      }
    }
  };

  return RaceSelection;

}).call(this);

//END expand
//END RaceSelection

},{"../jsonapi_expander":87,"./entry.model":60,"./franchisee.model":64,"./promise.base.model":70,"./race.model":72,"./race_option.model":73,"./user.model":82}],75:[function(require,module,exports){
var PromiseBaseModel, Region;

PromiseBaseModel = require("./promise.base.model");

module.exports = Region = (function() {
  class Region extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    hasOwner() {
      return Helpers.isUUID(this.get('owner_id'));
    }

    expand(data) {
      var JSONApiExpander, RegionContestStatistic, RegionContestStatistics, RegionStatistic, RegionStatistics, User;
      JSONApiExpander = require("../jsonapi_expander");
      User = require("./user.model");
      RegionStatistic = require("./region_statistic.model");
      RegionStatistics = require("../$collections/region_statistics.collection");
      RegionContestStatistic = require("./region_contest_statistic.model");
      RegionContestStatistics = require("../$collections/region_contest_statistics.collection");
      return new JSONApiExpander(data).attributes(Region.prototype.attributes).relation('owner').attributes(User.prototype.attributes).done().relation('statistics').attributes(RegionStatistic.prototype.attributes).done().relation('contest_statistics').attributes(RegionContestStatistic.prototype.attributes).done();
    }

  };

  Region.prototype.endpoint = 'regions';

  Region.prototype.type = 'regions';

  Region.prototype.label = 'Region';

  Region.prototype.attributes = ['id', 'name', 'owner_id', 'snapon_sso_id', 'created_at', 'updated_at'];

  Region.prototype.defaults = {
    'owner': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'statistics': function() {
      var RegionStatistics;
      RegionStatistics = require("../$collections/region_statistics.collection");
      return new RegionStatistics();
    },
    'contest_statistics': function() {
      var RegionContestStatistics;
      RegionContestStatistics = require("../$collections/region_contest_statistics.collection");
      return new RegionContestStatistics();
    }
  };

  //END defaults
  Region.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'owner_id': void 0,
    'snapon_sso_id': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return Region;

}).call(this);

//END expand
//END Region

},{"../$collections/region_contest_statistics.collection":41,"../$collections/region_statistics.collection":42,"../jsonapi_expander":87,"./promise.base.model":70,"./region_contest_statistic.model":76,"./region_statistic.model":77,"./user.model":82}],76:[function(require,module,exports){
var PromiseBaseModel, RegionContestStatistic;

PromiseBaseModel = require("./promise.base.model");

module.exports = RegionContestStatistic = (function() {
  class RegionContestStatistic extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    expand(data) {
      var Contest, JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      Contest = require("./contest.model");
      return new JSONApiExpander(data).attributes(RegionContestStatistic.prototype.attributes).relation('contest').attributes(Contest.prototype.attributes).done();
    }

  };

  RegionContestStatistic.prototype.endpoint = 'region_contest_statistics';

  RegionContestStatistic.prototype.type = 'region_contest_statistics';

  RegionContestStatistic.prototype.label = 'Region Contest Statistics';

  RegionContestStatistic.prototype.attributes = ['region_id', 'contest_id', 'entry_count', 'virtual_entry_count', 'redeemed_entry_count', 'redeemed_virtual_entry_count', 'participant_count', 'game_kit_count', 'registered_franchisee_count'];

  RegionContestStatistic.prototype.defaults = {
    'region_id': void 0,
    'contest_id': void 0
  };

  //END defaults
  RegionContestStatistic.prototype.observables = {
    'entry_count': 0,
    'virtual_entry_count': 0,
    'redeemed_entry_count': 0,
    'redeemed_virtual_entry_count': 0,
    'participant_count': 0,
    'game_kit_count': 0,
    'registered_franchisee_count': 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return RegionContestStatistic;

}).call(this);

//END expand
//END RegionContestStatistic

},{"../jsonapi_expander":87,"./contest.model":57,"./promise.base.model":70}],77:[function(require,module,exports){
var PromiseBaseModel, RegionStatistic;

PromiseBaseModel = require("./promise.base.model");

module.exports = RegionStatistic = (function() {
  class RegionStatistic extends PromiseBaseModel {
    //END average_entries_per_participant
    //END observables
    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(RegionStatistic.prototype.attributes);
    }

  };

  RegionStatistic.prototype.endpoint = 'region_statistics';

  RegionStatistic.prototype.type = 'region_statistics';

  RegionStatistic.prototype.label = 'Region Statistics';

  RegionStatistic.prototype.attributes = ['region_id', 'entry_count', 'virtual_entry_count', 'redeemed_entry_count', 'redeemed_virtual_entry_count', 'participant_count', 'game_kit_count', 'registered_franchisee_count', "survey_response_count"];

  RegionStatistic.prototype.defaults = {
    'region_id': void 0
  };

  //END defaults
  RegionStatistic.prototype.observables = {
    'entry_count': 0,
    'virtual_entry_count': 0,
    'redeemed_entry_count': 0,
    'redeemed_virtual_entry_count': 0,
    'participant_count': 0,
    'game_kit_count': 0,
    'registered_franchisee_count': 0,
    "survey_response_count": 0,
    'average_entries_per_participant': function() {
      var participant_count, redeemed_entry_count;
      participant_count = this.get('participant_count') || 0;
      if (!(participant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / participant_count;
    }
  };

  return RegionStatistic;

}).call(this);

//END expand
//END RegionStatistic

},{"../jsonapi_expander":87,"./promise.base.model":70}],78:[function(require,module,exports){
var PromiseBaseModel, Session;

PromiseBaseModel = require("./promise.base.model");

module.exports = Session = (function() {
  class Session extends PromiseBaseModel {
    //END defaults
    makeUrl() {
      return `${Falcon.baseApiUrl}/${this.endpoint}`;
    }

    serializeRequestData(type, options) {
      var data;
      ({data} = super.serializeRequestData(type, options));
      if ('user' in data) {
        data['users'] = data['user'];
        delete data['user'];
      }
      //END if
      return {data};
    }

    //END serializeRequestData
    expand(data) {
      var FPT, FPTs, Franchisee, Franchisees, JSONApiExpander, Region, Regions, User;
      JSONApiExpander = require("../jsonapi_expander");
      User = require("./user.model");
      Franchisee = require("./franchisee.model");
      Franchisees = require("../$collections/franchisees.collection");
      FPT = require("./fpt.model");
      FPTs = require("../$collections/fpts.collection");
      Region = require("./region.model");
      Regions = require("../$collections/regions.collection");
      return new JSONApiExpander(data).relation('user').attributes(User.prototype.attributes).done().relation('franchisees').attributes(Franchisee.prototype.attributes).done().relation('fpts').attributes(FPT.prototype.attributes).done().relation('regions').attributes(Region.prototype.attributes).done().attributes(Session.prototype.attributes);
    }

  };

  Session.prototype.endpoint = 'sessions';

  Session.prototype.type = 'sessions';

  Session.prototype.label = 'Session';

  Session.prototype.attributes = ['email', 'password', 'auth_token', 'recaptcha_token', 'otp_enabled', 'otp_verified'];

  Session.prototype.defaults = {
    'email': null,
    'password': null,
    'auth_token': null,
    'recaptcha_token': null,
    'otp_enabled': null,
    'otp_verified': null,
    'user': function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    'franchisees': function() {
      var Franchisees;
      Franchisees = require("../$collections/franchisees.collection");
      return new Franchisees();
    },
    'fpts': function() {
      var FPTs;
      FPTs = require("../$collections/fpts.collection");
      return new FPTs();
    },
    'regions': function() {
      var Regions;
      Regions = require("../$collections/regions.collection");
      return new Regions();
    }
  };

  return Session;

}).call(this);

//END expand
//END Session

},{"../$collections/fpts.collection":31,"../$collections/franchisees.collection":35,"../$collections/regions.collection":43,"../jsonapi_expander":87,"./fpt.model":61,"./franchisee.model":64,"./promise.base.model":70,"./region.model":75,"./user.model":82}],79:[function(require,module,exports){
var PromiseBaseModel, Survey;

PromiseBaseModel = require("./promise.base.model");

module.exports = Survey = (function() {
  class Survey extends PromiseBaseModel {
    //END observables
    expand(data) {
      var JSONApiExpander, Question, Questions;
      JSONApiExpander = require("../jsonapi_expander");
      Question = require("./question.model");
      Questions = require("../$collections/questions.collection");
      return new JSONApiExpander(data).relation('questions').attributes(Question.prototype.attributes).done().attributes(Survey.prototype.attributes);
    }

  };

  Survey.prototype.endpoint = 'surveys';

  Survey.prototype.type = 'surveys';

  Survey.prototype.label = 'Survey';

  Survey.prototype.attributes = ['id', 'name', 'name_fr', 'start_date', 'end_date', 'created_at', 'updated_at'];

  Survey.prototype.defaults = {
    'questions': function() {
      var Questions;
      Questions = require("../$collections/questions.collection");
      return new Questions();
    }
  };

  //END defaults
  Survey.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'start_date': void 0,
    'end_date': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  return Survey;

}).call(this);

//END expand
//END Survey

},{"../$collections/questions.collection":37,"../jsonapi_expander":87,"./promise.base.model":70,"./question.model":71}],80:[function(require,module,exports){
var PromiseBaseModel, SurveyAnswer;

PromiseBaseModel = require("./promise.base.model");

module.exports = SurveyAnswer = (function() {
  class SurveyAnswer extends PromiseBaseModel {
    //END observables
    initialize() {
      return this.validation.decorate("validatable");
    }

    //END initialize
    validate() {
      var Question, options, selections, type;
      Question = require("./question.model");
      type = this.question.get('type');
      options = this.question.get('options') || [];
      selections = this.get('selections') || [];
      if (selections.length <= 0) {
        return this.validation.setIsValid(false, "Please make a selection");
      }
      if (type === Question.SINGLE_CHOICE) {
        if (selections.length > 1) {
          return this.validation.setIsValid(false, "Single choice questions may only have one selection");
        }
      }
      if (selections.length > options.length) {
        //END if
        return this.validation.setIsValid(false, "Improper selections");
      }
      if (selections.length > _.uniq(selections).length) {
        return this.validation.setIsValid(false, "Duplicate selections");
      }
      return this.validation.setIsValid(true);
    }

    //END validate
    expand(data) {
      var JSONApiExpander, Question, Survey, User;
      JSONApiExpander = require("../jsonapi_expander");
      Survey = require("./survey.model");
      Question = require("./question.model");
      User = require("./user.model");
      return new JSONApiExpander(data).relation('survey_response').attributes(SurveyResponse.prototype.attributes).done().relation('survey').attributes(Survey.prototype.attributes).done().relation('responder').attributes(User.prototype.attributes).done().relation('question').attributes(Question.prototype.attributes).done().attributes(SurveyAnswer.prototype.attributes);
    }

  };

  SurveyAnswer.prototype.endpoint = 'survey_answers';

  SurveyAnswer.prototype.type = 'survey-answers';

  SurveyAnswer.prototype.label = 'SurveyAnswer';

  SurveyAnswer.prototype.attributes = ['id', 'selections', 'response_id', 'question_id', 'survey_id', 'responder_id', 'created_at', 'updated_at'];

  SurveyAnswer.prototype.defaults = {
    survey: function() {
      var Survey;
      Survey = require("./survey.model");
      return new Survey();
    },
    question: function() {
      var Question;
      Question = require("./question.model");
      return new Question();
    },
    responder: function() {
      var User;
      User = require("./user.model");
      return new User();
    }
  };

  //END defaults
  SurveyAnswer.prototype.observables = {
    'id': void 0,
    'question_id': void 0,
    'survey_id': void 0,
    'responder_id': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'input_selections': [], // Raw values from the form inputs
    'selections': {
      read: function() {
        var value;
        value = this.get('input_selections');
        if (value == null) {
          return [];
        }
        if (_.isArray(value)) {
          return value;
        }
        if (this.question.get('is_single_choice')) {
          return [value];
        }
        return [];
      },
      //END read
      write: function(value) {
        if (value == null) {
          value = [];
        }
        if (!_.isArray(value)) {
          value = [value];
        }
        value = value.map(function(item) {
          return item;
        });
        value = _.uniq(value);
        if (this.question.get('is_single_choice')) {
          value = value[0];
        }
        return this.set('input_selections', value);
      }
    },
    //END write
    //END selections

    // Non serialized observables
    validation: void 0,
    has_error: function() {
      return ko.unwrap(this.validation.is_invalid);
    },
    error: function() {
      return ko.unwrap(this.validation.validation_message);
    }
  };

  return SurveyAnswer;

}).call(this);

//END expand
//END SurveyAnswer

},{"../jsonapi_expander":87,"./promise.base.model":70,"./question.model":71,"./survey.model":79,"./user.model":82}],81:[function(require,module,exports){
var PromiseBaseModel, SurveyResponse;

PromiseBaseModel = require("./promise.base.model");

module.exports = SurveyResponse = (function() {
  class SurveyResponse extends PromiseBaseModel {
    //END observables
    initialize() {
      return this.validation.decorate("validatable");
    }

    //END initialize
    validate() {
      var is_valid;
      is_valid = true;
      if (this.answers.length() !== this.survey.questions.length()) {
        is_valid = false;
        this.validation.setIsValid(false, "Invalid number of answers given");
      }
      //eND if
      this.answers.each(function(answer) {
        return is_valid = answer.validate() && is_valid;
      });
      return is_valid;
    }

    //END validate
    mapSurvey(survey) {
      var SurveyAnswer;
      SurveyAnswer = require("../$models/survey_answer.model");
      this.fill({
        survey_id: survey.get('id'),
        survey: survey.serialize()
      });
      survey.questions.each((question) => {
        var answer;
        answer = this.answers.first((answer) => {
          return answer.get("question_id") === question.get("id");
        });
        if (answer == null) {
          answer = new SurveyAnswer();
          this.answers.push(answer);
        }
        //END unless
        return answer.fill({
          question_id: question.get('id'),
          question: question.serialize()
        });
      });
      return this;
    }

    //END mapSurvey
    expand(data) {
      var Entry, JSONApiExpander, Question, Survey, SurveyAnswer, SurveyAnswers, User, i, len, notificationType, ref;
      JSONApiExpander = require("../jsonapi_expander");
      Survey = require("./survey.model");
      Question = require("./question.model");
      User = require("./user.model");
      Entry = require("./entry.model");
      SurveyAnswer = require("./survey_answer.model");
      SurveyAnswers = require("../$collections/survey_answers.collection");
      // Hacky way to get notification alerts to show up.
      if (data['meta'] != null) {
        if (data['meta']['notifications'] != null) {
          ref = data['meta']['notifications'];
          for (i = 0, len = ref.length; i < len; i++) {
            notificationType = ref[i];
            Application.trigger("meta:notification", notificationType);
          }
        }
      }
      return new JSONApiExpander(data).relation('survey').attributes(Survey.prototype.attributes).relation('questions').attributes(Question.prototype.attributes).done().done().relation('responder').attributes(User.prototype.attributes).done().relation('answers').attributes(SurveyAnswer.prototype.attributes).done().relation('entry').attributes(Entry.prototype.attributes).done().attributes(SurveyResponse.prototype.attributes);
    }

  };

  SurveyResponse.prototype.endpoint = 'survey_responses';

  SurveyResponse.prototype.type = 'survey-responses';

  SurveyResponse.prototype.label = 'SurveyResponse';

  SurveyResponse.prototype.attributes = ['id', 'survey_id', 'responder_id', 'entry_id', 'created_at', 'updated_at'];

  SurveyResponse.prototype.defaults = {
    survey: function() {
      var Survey;
      Survey = require("./survey.model");
      return new Survey();
    },
    answers: function() {
      var SurveyAnswers;
      SurveyAnswers = require("../$collections/survey_answers.collection");
      return new SurveyAnswers();
    },
    responder: function() {
      var User;
      User = require("./user.model");
      return new User();
    },
    entry: function() {
      var Entry;
      Entry = require("./entry.model");
      return new Entry();
    }
  };

  //END defaults
  SurveyResponse.prototype.observables = {
    'id': void 0,
    'survey_id': void 0,
    'responder_id': void 0,
    'entry_id': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    // Non serialized observables
    validation: void 0,
    has_error: function() {
      return ko.unwrap(this.validation.is_invalid);
    },
    error: function() {
      if (this.get('has_error')) {
        return ko.unwrap(this.validation.validation_message);
      } else {
        return void 0;
      }
    }
  };

  return SurveyResponse;

}).call(this);

//END expand
//END SurveyResponse

},{"../$collections/survey_answers.collection":44,"../$models/survey_answer.model":80,"../jsonapi_expander":87,"./entry.model":60,"./promise.base.model":70,"./question.model":71,"./survey.model":79,"./survey_answer.model":80,"./user.model":82}],82:[function(require,module,exports){
var PromiseBaseModel, User,
  indexOf = [].indexOf;

PromiseBaseModel = require("./promise.base.model");

module.exports = User = (function() {
  class User extends PromiseBaseModel {
    //END first_name
    //END observables
    hasRole(...roles) {
      var assigned_roles, i, len, ref, role;
      assigned_roles = (ref = this.get('roles')) != null ? ref : [];
      for (i = 0, len = roles.length; i < len; i++) {
        role = roles[i];
        if (indexOf.call(assigned_roles, role) >= 0) {
          return true;
        }
      }
      //END for
      return false;
    }

    //END hasRole
    getFormattedAddress() {
      var address_1, address_2, city, line, lines, state, zip_code;
      lines = [];
      address_1 = this.get("address_1");
      if (address_1) {
        lines.push(address_1);
      }
      address_2 = this.get("address_2");
      if (address_2) {
        lines.push(address_2);
      }
      line = "";
      city = this.get("city");
      if (city) {
        line += city;
      }
      state = this.get("state");
      if (state) {
        if (line.length > 0) {
          line += ", ";
        }
        line += state;
      }
      //END if
      zip_code = this.get("zip_code");
      if (zip_code) {
        if (line.length > 0) {
          line += " ";
        }
        line += zip_code;
      }
      //END if
      lines.push(line);
      return lines.join("\n");
    }

    //END getFormattedAddress
    expand(data) {
      var JSONApiExpander, UserContestStatistic, UserContestStatistics;
      JSONApiExpander = require("../jsonapi_expander");
      UserContestStatistic = require("../$models/user_contest_statistic.model");
      UserContestStatistics = require("../$collections/user_contest_statistics.collection");
      return new JSONApiExpander(data).relation('contest_statistics').attributes(UserContestStatistic.prototype.attributes).done().attributes(User.prototype.attributes);
    }

  };

  User.prototype.endpoint = 'users';

  User.prototype.type = 'users';

  User.prototype.label = 'User';

  User.ROLES = [User.ADMIN_ROLE = 'admin', User.REGION_ROLE = 'region', User.FPT_ROLE = 'fpt', User.FRANCHISEE_ROLE = 'franchisee', User.USER_ROLE = 'user'];

  User.prototype.attributes = ['id', 'email', 'name', 'roles', 'created_at', 'updated_at', 'address_1', 'address_2', 'city', 'state', 'country', 'zip_code', 'phone_number', 'legal_agreements', 'snapon_sso_id', 'is_subscribed_to_newsletter', 'recaptcha_token'];

  User.prototype.defaults = {
    'contest_statistics': function() {
      var UserContestStatistics;
      UserContestStatistics = require("../$collections/user_contest_statistics.collection");
      return new UserContestStatistics();
    }
  };

  //END defaults
  User.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'email': void 0,
    'roles': [],
    'password': void 0,
    'address_1': void 0,
    'address_2': void 0,
    'city': void 0,
    'state': void 0,
    'country': void 0,
    'zip_code': void 0,
    'phone_number': void 0,
    'legal_agreements': void 0,
    'recaptcha_token': void 0,
    'is_subscribed_to_newsletter': void 0,
    'snapon_sso_id': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'first_name': function() {
      var name, ref, ref1;
      name = Helpers.trim((ref = this.get('name')) != null ? ref : "");
      return (ref1 = name.split(" ")[0]) != null ? ref1 : "";
    },
    //END first_name
    'last_name': function() {
      var first, name, ref, rest;
      name = Helpers.trim((ref = this.get('name')) != null ? ref : "");
      [first, ...rest] = name.split(" ");
      return rest.join(" ");
    }
  };

  return User;

}).call(this);

//END expand
//END User

},{"../$collections/user_contest_statistics.collection":47,"../$models/user_contest_statistic.model":83,"../jsonapi_expander":87,"./promise.base.model":70}],83:[function(require,module,exports){
var PromiseBaseModel, UserContestStatistic;

PromiseBaseModel = require("./promise.base.model");

module.exports = UserContestStatistic = (function() {
  class UserContestStatistic extends PromiseBaseModel {
    //END observables
    expand(data) {
      var JSONApiExpander;
      JSONApiExpander = require("../jsonapi_expander");
      return new JSONApiExpander(data).attributes(UserContestStatistic.prototype.attributes);
    }

  };

  UserContestStatistic.prototype.endpoint = 'user_contest_statistics';

  UserContestStatistic.prototype.type = 'user_contest_statistics';

  UserContestStatistic.prototype.label = 'Contest Winner';

  UserContestStatistic.prototype.attributes = ['user_id', 'contest_id', 'redeemed_entry_count'];

  UserContestStatistic.prototype.defaults = {
    'user_id': void 0,
    'contest_id': void 0
  };

  //END defaults
  UserContestStatistic.prototype.observables = {
    'redeemed_entry_count': void 0
  };

  return UserContestStatistic;

}).call(this);

//END expand
//END UserContestStatistic

},{"../jsonapi_expander":87,"./promise.base.model":70}],84:[function(require,module,exports){
var base;

if ((base = Function.prototype).bind == null) {
  base.bind = function(oThis) {
    var aArgs, fBound, fToBind, noop;
    if (typeof this !== "function") {
      throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
    }
    //END unless
    aArgs = Array.prototype.slice.call(arguments, 1);
    fToBind = this;
    noop = (function() {});
    fBound = function() {
      var context;
      context = this instanceof noop && oThis ? this : oThis;
      return fToBind.apply(context, aArgs.concat(Array.prototype.slice.call(arguments)));
    };
    //END fBound
    noop.prototype = this.prototype;
    fBound.prototype = new noop();
    return fBound;
  };
}

//END bind

},{}],85:[function(require,module,exports){
(function() {
  var browserRaf, canceled, i, len, ref, targetTime, vendor, w;
  w = window;
  ref = ['ms', 'moz', 'webkit', 'o'];
  for (i = 0, len = ref.length; i < len; i++) {
    vendor = ref[i];
    if (w.requestAnimationFrame) {
      break;
    }
    w.requestAnimationFrame = w[`${vendor}RequestAnimationFrame`];
    w.cancelAnimationFrame = w[`${vendor}CancelAnimationFrame`] || w[`${vendor}CancelRequestAnimationFrame`];
  }
  // deal with the case where rAF is built in but cAF is not.
  if (w.requestAnimationFrame) {
    if (w.cancelAnimationFrame) {
      return;
    }
    browserRaf = w.requestAnimationFrame;
    canceled = {};
    w.requestAnimationFrame = function(callback) {
      var id;
      return id = browserRaf(function(time) {
        if (id in canceled) {
          return delete canceled[id];
        } else {
          return callback(time);
        }
      });
    };
    return w.cancelAnimationFrame = function(id) {
      return canceled[id] = true;
    };
  } else {
    // handle legacy browsers which don’t implement rAF
    targetTime = 0;
    w.requestAnimationFrame = function(callback) {
      var currentTime;
      targetTime = Math.max(targetTime + 16, currentTime = +new Date());
      return w.setTimeout((function() {
        return callback(+new Date());
      }), targetTime - currentTime);
    };
    return w.cancelAnimationFrame = function(id) {
      return clearTimeout(id);
    };
  }
})();

},{}],86:[function(require,module,exports){
ko.subscribable.fn.decorate = function(...identifiers) {
  var extenders, i, identifier, len;
  extenders = {};
  for (i = 0, len = identifiers.length; i < len; i++) {
    identifier = identifiers[i];
    if (_.isString(identifier) && !_.isEmpty(identifier)) {
      extenders[identifier] = true;
    }
  }
  //END for
  return this.extend(extenders);
};


//END decorate
ko.extenders["errorable"] = function(target, options) {
  target.error = ko.observable("");
  target.has_error = ko.computed(function() {
    var err;
    err = target.error();
    if (!_.isString(err)) {
      err = "";
    }
    return Helpers.trim(err).length > 0;
  });
  //END has_error
  target.clearError = function() {
    return target.error("");
  };
  return target;
};

//END errorable extender
ko.extenders["validatable"] = function(target, options) {
  target.is_valid = ko.observable(false);
  target.is_invalid = ko.observable(false);
  target.has_validation = ko.computed(function() {
    return target.is_invalid() || target.is_valid();
  });
  target.validation_message = ko.observable(null);
  target.setIsValid = function(is_valid, message) {
    var is_invalid;
    if (is_valid != null) {
      is_invalid = !is_valid;
      target.is_invalid(is_invalid);
      target.is_valid(is_valid);
      target.validation_message(message);
      return !is_invalid;
    } else {
      target.resetValidations();
      return null;
    }
  };
  //END if
  //END setIsValid
  target.resetValidations = function() {
    target.is_invalid(false);
    target.is_valid(false);
    target.validation_message(null);
    return target;
  };
  //END resetValidations
  return target;
};

//END errorable extender
ko.extenders["lowercase"] = function(target, options) {
  target.subscribe(function(new_value) {
    if (new_value != null) {
      new_value = new_value.toString().toLowerCase();
    }
    return target(new_value);
  });
  //END subscribe
  return target;
};

//END errorable extender
ko.extenders["resetAfter"] = function(target, duration) {
  var original_value, timeout;
  if (!_.isNumber(duration)) {
    duration = 1000;
  }
  if (duration < 0) {
    duration = 0;
  }
  original_value = target();
  timeout = null;
  target.subscribe(function(new_value) {
    if (timeout != null) {
      clearTimeout(timeout);
    }
    timeout = null;
    if (new_value === original_value) {
      return;
    }
    return timeout = setTimeout(function() {
      timeout = null;
      return target(original_value);
    }, duration);
  });
  //END subscribe
  return target;
};

//END resetAfter extender
ko.extenders["transactable"] = function(target, options) {
  var previous;
  previous = ko.observable(target());
  target.commit = function() {
    return previous(target());
  };
  target.revert = function() {
    return target(previous());
  };
  target.hasChanged = function() {
    return target() !== previous();
  };
  return target;
};

//END transactable extender

},{}],87:[function(require,module,exports){
var JSONApiExpander, JSONApiExpanderBase, generateBaseOutputObject,
  indexOf = [].indexOf;

generateBaseOutputObject = function($included_datum) {
  if (!_.isObject($included_datum)) {
    throw new Error("$included_datum must be an object");
  }
  //END unless
  return {$included_datum};
};

JSONApiExpanderBase = (function() {
  //END generateBaseOutputObject
  class JSONApiExpanderBase {
    constructor(data, output, parent) {
      if (!_.isObject(data)) {
        throw new Error("data must be an object");
      }
      //END unless
      if (!_.isArray(output)) {
        throw new Error("output must be an array");
      }
      //END unless
      this.data = data;
      this.output = output;
      this.parent = parent;
    }

    //END constructor
    cleanOutputObject(output_object) {
      if (!_.isObject(output_object)) {
        throw new Error("output_object must be an Object");
      }
      if ('$included_datum' in output_object) {
        //END unless
        return delete output_object['$included_datum'];
      }
    }

    //END cleanOutputObject
    getRelationships(output_object, key) {
      var $included_datum;
      if (!_.isObject(output_object)) {
        throw new Error("output_object must be an Object");
      }
      //END unless
      ({$included_datum} = output_object);
      if ($included_datum == null) {
        if (this.debug) {
          if (typeof console !== "undefined" && console !== null) {
            console.warn("Missing '$included_datum' property on: ", output_object);
          }
        }
      } else if (!('relationships' in output_object['$included_datum'])) {
        if (this.debug) {
          if (typeof console !== "undefined" && console !== null) {
            console.warn(`Missing 'relationships' property on '${$included_datum['type']}', data given was:`, $included_datum);
          }
        }
      } else if (!(key in $included_datum['relationships'])) {
        if (this.debug) {
          if (typeof console !== "undefined" && console !== null) {
            console.warn(`Missing '${key}' property on '${$included_datum['type']}.relationships', data given was: `, $included_datum['relationships']);
          }
        }
      // Take a time out to check if the linked thing is null, return null if so
      } else if ($included_datum['relationships'][key] == null) {
        return null;
      } else if (!('data' in $included_datum['relationships'][key])) {
        if (this.debug) {
          if (typeof console !== "undefined" && console !== null) {
            console.warn(`Missing 'data' property on '${$included_datum['type']}.relationships.${key}', data given was: `, $included_datum['relationships'][key]);
          }
        }
      } else {
        return $included_datum['relationships'][key]['data'];
      }
      //END if
      return null;
    }

    //END getRelationships
    generateOutputObject(linkage, existing_output_array) {
      var $included_datum, existing_output_object, i, id, j, len, len1, output_object, ref, resource, type;
      if (!_.isObject(linkage)) {
        throw new Error("linkage must be an object");
      }
      //END unless
      if (!('id' in linkage)) {
        throw new Error("Linked objects must contain an id");
      }
      //END unless
      if (!('type' in linkage)) {
        throw new Error("Linked objects must contain a type");
      }
      //END unless
      ({type, id} = linkage);
      output_object = null;
      // Find existing output objects based on matching id and type, instead of reference to save time and memory
      if (_.isArray(existing_output_array)) {
        for (i = 0, len = existing_output_array.length; i < len; i++) {
          existing_output_object = existing_output_array[i];
          ({$included_datum} = existing_output_object);
          if ($included_datum['id'] !== id) {
            continue;
          }
          if ($included_datum['type'] !== type) {
            continue;
          }
          return existing_output_object;
        }
      }
      //END for
      //END if
      $included_datum = null;
      ref = this.data['included'];
      // Try and find the correct data from the included array (data sent from server to me)
      for (j = 0, len1 = ref.length; j < len1; j++) {
        resource = ref[j];
        if (!(resource != null)) {
          continue;
        }
        if (resource['id'] !== id) {
          continue;
        }
        if (resource['type'] !== type) {
          continue;
        }
        $included_datum = resource;
        break;
      }
      //END for

      // If we found some included data then generate a base (empty-ish) output Object
      // We do it this way to be able to reduce the different attributes from the response
      //TODO: Consider removing this and instead using an 'if' around 'output_object ='
      if ($included_datum == null) {
        $included_datum = {id};
      }
      output_object = generateBaseOutputObject($included_datum);
      return output_object;
    }

    //END generateOutputObject
    attributes(attrs) {
      var $included_datum, attr, i, index, j, len, len1, output_object, ref;
      if (!_.isArray(attrs)) {
        attrs = [];
      }
      ref = this.output;
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        output_object = ref[index];
        ({$included_datum} = output_object);
        if ($included_datum == null) {
          continue;
        }
        output_object['id'] = $included_datum['id'];
        if ($included_datum['attributes'] == null) {
          continue;
        }
        for (j = 0, len1 = attrs.length; j < len1; j++) {
          attr = attrs[j];
          if (attr in $included_datum['attributes']) {
            output_object[attr] = $included_datum['attributes'][attr];
          }
        }
      }
      //END for
      //END for
      return this;
    }

    //END attributes
    relation(key) {
      var child_output_array, child_output_object, i, included, j, len, len1, output_object, ref, relationship, relationships;
      if (!_.isString(key)) {
        throw new Error("key must be a string");
      }
      //END unless
      ({included} = this.data);
      child_output_array = [];
      ref = this.output;
      for (i = 0, len = ref.length; i < len; i++) {
        output_object = ref[i];
        relationships = this.getRelationships(output_object, key);
        // Output null
        if (_.isNull(relationships)) {
          output_object[key] = null;
        }
        // Output the array as a link if the relationships value is an array
        if (_.isArray(relationships)) {
          for (j = 0, len1 = relationships.length; j < len1; j++) {
            relationship = relationships[j];
            if (!(relationship != null)) {
              continue;
            }
            // Retrieve the proper child output object, pass in the existing child_output_array to
            // re-use the 'same' objects based on type and id and re-use the existing reference
            child_output_object = this.generateOutputObject(relationship, child_output_array);
            if (child_output_object != null) {
              if (indexOf.call(child_output_array, child_output_object) < 0) {
                // Ony push this on to the output array if it doesn't already exist in the output array
                // Because we're using references here, if the actual output array has duplicate models
                // this will actual save time as the expanded json will still be correct but will need less memory
                // and iterations to perform the expansion
                child_output_array.push(child_output_object);
              }
              // Always push this on the the actual output as, even if there's duplicate models in the same array,
              // we'll still want to duplicate that model in the generated output
              (output_object[key] != null ? output_object[key] : output_object[key] = []).push(child_output_object);
            }
          }
        //END if
        //END for

        // Output the array as a relationship if the relationships value is an object
        } else if (_.isObject(relationships)) {
          // Retrieve the proper child output object, pass in the existing child_output_array to
          // re-use the 'same' objects based on type and id and re-use the existing reference
          child_output_object = this.generateOutputObject(relationships, child_output_array);
          if (child_output_object != null) {
            child_output_array.push(child_output_object);
            output_object[key] = child_output_object;
          }
        }
      }
      //END if
      //END if
      //END for
      return new JSONApiExpanderBase(this.data, child_output_array, this);
    }

    //END relation
    done() {
      var i, len, output_object, ref;
      ref = this.output;
      for (i = 0, len = ref.length; i < len; i++) {
        output_object = ref[i];
        this.cleanOutputObject(output_object);
      }
      return this.parent;
    }

  };

  JSONApiExpanderBase.prototype.parent = null;

  JSONApiExpanderBase.prototype.data = null;

  JSONApiExpanderBase.prototype.output = null;

  JSONApiExpanderBase.prototype.debug = false;

  return JSONApiExpanderBase;

}).call(this);

//END done
//END JSONApiExpanderBase
module.exports = JSONApiExpander = class JSONApiExpander extends JSONApiExpanderBase {
  constructor(data) {
    var output, root, root_datum;
    if (!_.isObject(data)) {
      throw new Error("data must be an object");
    }
    //END unless
    root = data['data'];
    if (_.isObject(root) && !_.isArray(root)) {
      root = [root];
    }
    if (!_.isArray(root)) {
      throw new Error("root must be an object or an array");
    }
    //END unless
    output = (function() {
      var i, len, results;
      results = [];
      for (i = 0, len = root.length; i < len; i++) {
        root_datum = root[i];
        results.push(generateBaseOutputObject(root_datum));
      }
      return results;
    })();
    super(data, output);
    this.parent = this;
  }

  //END constructor
  toArray() {
    return this.done().output;
  }

  toObject() {
    return this.done().output[0];
  }

};

//END JSONApiExpander

},{}],88:[function(require,module,exports){
var JWTAdapater;

module.exports = JWTAdapater = class JWTAdapater extends jQueryRestDataAdapter {
  standardizeOptions(data_object, type, options, context) {
    var sync_options;
    sync_options = super.standardizeOptions(...arguments);
    sync_options['xhrFields'] = {};
    sync_options['xhrFields']['withCredentials'] = true;
    sync_options['crossDomain'] = true;
    return sync_options;
  }

  //END standardizeOptions
  errorResponseHandler(data_object, type, options, context, response_args) {
    var ref, ref1;
    switch (parseInt((ref = response_args != null ? (ref1 = response_args.xhr) != null ? ref1.status : void 0 : void 0) != null ? ref : 0)) {
      case 401:
        // TODO: Logout the user
        this.trigger('unauthorized');
    }
    //END when
    //END switch
    return super.errorResponseHandler(...arguments);
  }

};

//END errorResponseHandler
//END JWTAdapter

},{}],89:[function(require,module,exports){
var Recaptcha;

module.exports = Recaptcha = class Recaptcha {
  static execute() {
    return Q.Promise((resolve, reject) => {
      return grecaptcha.ready(() => {
        return grecaptcha.execute("6LeTmjMpAAAAAKwTOvpYy6rE66VK16WF5Ip_vWcK", {
          action: 'submit'
        }).then(resolve);
      });
    });
  }

};

//END ready
//END execute
//END Recaptcha

},{}],90:[function(require,module,exports){
var Contest, ContestFinalist, ContestFinalists, ContestWinner, ContestWinners, Entries, Entry, FPT, Franchisee, Franchisees, GameKit, Invite, RPC, Race, RaceSelection, Session, User;

Contest = require("./$models/contest.model");

ContestFinalist = require("./$models/contest_finalist.model");

ContestFinalists = require("./$collections/contest_finalists.collection");

ContestWinner = require("./$models/contest_winner.model");

ContestWinners = require("./$collections/contest_winners.collection");

Entries = require("./$collections/entries.collection");

Entry = require("./$models/entry.model");

FPT = require("./$models/fpt.model");

Franchisee = require("./$models/franchisee.model");

Franchisees = require("./$collections/franchisees.collection");

GameKit = require("./$models/game_kit.model");

Invite = require("./$models/invite.model");

Race = require("./$models/race.model");

RaceSelection = require("./$models/race_selection.model");

Session = require("./$models/session.model");

User = require("./$models/user.model");

module.exports = RPC = new (class {
  promiseGetPresignedUrl({size, name, type} = {}) {
    return Q.Promise((resolve, reject) => {
      return (new Falcon.Model({
        endpoint: "rpc/presigned_url"
      })).set({size, name, type}).create({
        parent: null,
        attributes: ['size', 'name', 'type'],
        success: (model, resp) => {
          return resolve(resp);
        },
        error: () => {
          return reject("Could not retrieve a presigned url");
        }
      });
    });
  }

  //END Falcon.Model
  //END promiseGetPresignedUrl
  promiseUploadFile(file) {
    return Q.Promise((resolve, reject) => {
      return RPC.promiseGetPresignedUrl(file).then(function(urls) {
        return $.ajax({
          url: urls.presigned_url,
          type: 'PUT',
          data: file,
          processData: false,
          headers: {
            'Accept': file.type,
            'Content-Type': file.type
          }
        //END headers
        }).success(function() {
          return resolve(urls.public_url);
        }).error(reject);
      });
    });
  }

  //END promiseUploadFile
  promiseForgotPassword(email, recaptcha_token, role = "web") {
    return Q.Promise((resolve, reject) => {
      if (!email) {
        throw new Error("email must be present");
      }
      if (!Helpers.isEmail(email)) {
        throw new Error("email must be an valid email");
      }
      if (!recaptcha_token) {
        throw new Error("recaptcha_token must be present");
      }
      return (new Falcon.Model({
        endpoint: "rpc/forgot_password"
      })).set({email, recaptcha_token, role}).create({
        parent: null,
        attributes: ['email', 'recaptcha_token', 'role'],
        success: () => {
          return resolve();
        },
        error: (model, response) => {
          return reject({
            human: (response != null ? response.human : void 0) || "No account found for this email."
          });
        }
      });
    });
  }

  //END error
  //END Falcon.Model
  //END promiseForgotPassword
  promiseResetPassword({email, reset_code, password, recaptcha_token} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!email) {
        throw new Error("email must be present");
      }
      if (!Helpers.isEmail(email)) {
        throw new Error("email must be an valid email");
      }
      if (!reset_code) {
        throw new Error("reset_code must be present");
      }
      if (!password) {
        throw new Error("password must be present");
      }
      if (!recaptcha_token) {
        throw new Error("recaptcha_token must be present");
      }
      return (new Falcon.Model({
        endpoint: "rpc/reset_password"
      })).set({email, reset_code, password, recaptcha_token}).create({
        parent: null,
        attributes: ['email', 'reset_code', 'password', 'recaptcha_token'],
        success: (model, data) => {
          var user, user_data;
          user_data = User.prototype.expand(data).toObject();
          user = new User(user_data);
          return resolve(user);
        },
        //END success
        error: () => {
          return reject(new Error("Could not reset password"));
        }
      });
    });
  }

  //END Falcon.Model
  //END promiseResetPassword
  promiseChangePassword(old_password, new_password) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(old_password)) {
        throw new Error("old_password must be a string");
      }
      if (!_.isString(new_password)) {
        throw new Error("new_password must be a string");
      }
      if (_.isEmpty(old_password)) {
        throw new Error("old_password must not be empty");
      }
      if (_.isEmpty(new_password)) {
        throw new Error("new_password must not be empty");
      }
      return (new Falcon.Model({
        endpoint: "rpc/change_password"
      })).set({old_password, new_password}).create({
        parent: null,
        attributes: ['old_password', 'new_password'],
        success: (model, data) => {
          var user, user_data;
          user_data = User.prototype.expand(data);
          user = new User(user_data);
          return resolve(user);
        },
        //END success
        error: () => {
          return reject("Could not change password");
        }
      });
    });
  }

  //END create
  //END promiseChangePassword
  promiseAdminChangePassword(user, new_password) {
    return Q.Promise((resolve, reject) => {
      var user_id;
      if (!(user instanceof User)) {
        throw new Error("user must be a User");
      }
      if (user.isNew()) {
        throw new Error("user must not be new");
      }
      if (!_.isString(new_password)) {
        throw new Error("new_password must be a string");
      }
      if (_.isEmpty(new_password)) {
        throw new Error("new_password must not be empty");
      }
      user_id = user.get('id');
      return (new Falcon.Model({
        endpoint: "rpc/admin_change_password"
      })).set({user_id, new_password}).create({
        parent: null,
        attributes: ['user_id', 'new_password'],
        success: (model, data) => {
          var user_data;
          user_data = User.prototype.expand(data);
          user = new User(user_data);
          return resolve(user);
        },
        //END success
        error: () => {
          return reject("Could not change password");
        }
      });
    });
  }

  //END create
  //END promiseChangePassword
  promiseCheckBPNumber(bp_number) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(bp_number)) {
        throw new Error("bp_number must be a string");
      }
      return (new Falcon.Model({
        endpoint: "rpc/check_bp_number"
      })).set({bp_number}).create({
        parent: null,
        attributes: ['bp_number'],
        success: (model, data) => {
          if ((data != null ? data.success : void 0)) {
            return resolve();
          }
          return reject({});
        },
        //END success
        error: (model, error = {}) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseCheckBPNumber
  //END error
  promiseInviteByBPNumber(bp_number) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(bp_number)) {
        throw new Error("bp_number must be a string");
      }
      return (new Falcon.Model({
        endpoint: "rpc/invite_by_bp_number"
      })).set({bp_number}).create({
        parent: null,
        attributes: ['bp_number'],
        success: (model, data) => {
          var invite, invite_data;
          invite_data = Invite.prototype.expand(data).toObject();
          invite = new Invite(invite_data);
          return resolve(invite);
        },
        //END success
        error: (model, error = {}) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseInviteByBPNumber
  //END error
  promiseRegisterFranchisee({password, invite_code} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(password)) {
        throw new Error("Password must be a string");
      }
      if (_.isEmpty(password)) {
        throw new Error("Password must not be empty");
      }
      if (!_.isString(invite_code)) {
        throw new Error("Invite code must be a string");
      }
      if (_.isEmpty(invite_code)) {
        throw new Error("Invite code must not be empty");
      }
      return (new Falcon.Model({
        endpoint: "rpc/register_franchisee"
      })).set({password, invite_code}).create({
        parent: null,
        attributes: ['password', 'invite_code'],
        success: (model, data) => {
          var user, user_data;
          user_data = User.prototype.expand(data).toObject();
          user = new User(user_data);
          return resolve(user);
        },
        //END success
        error: (model, error) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseRegisterFranchisee
  //END error
  promiseRegisterFPT({password, invite_code} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(password)) {
        throw new Error("Password must be a string");
      }
      if (_.isEmpty(password)) {
        throw new Error("Password must not be empty");
      }
      if (!_.isString(invite_code)) {
        throw new Error("Invite code must be a string");
      }
      if (_.isEmpty(invite_code)) {
        throw new Error("Invite code must not be empty");
      }
      return (new Falcon.Model({
        endpoint: "rpc/register_fpt"
      })).set({password, invite_code}).create({
        parent: null,
        attributes: ['password', 'invite_code'],
        success: (model, data) => {
          var user, user_data;
          user_data = User.prototype.expand(data).toObject();
          user = new User(user_data);
          return resolve(user);
        },
        //END success
        error: (model, error) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseRegisterFPT
  //END error
  promiseRegisterRegion({password, invite_code} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(password)) {
        throw new Error("Password must be a string");
      }
      if (_.isEmpty(password)) {
        throw new Error("Password must not be empty");
      }
      if (!_.isString(invite_code)) {
        throw new Error("Invite code must be a string");
      }
      if (_.isEmpty(invite_code)) {
        throw new Error("Invite code must not be empty");
      }
      return (new Falcon.Model({
        endpoint: "rpc/register_region"
      })).set({password, invite_code}).create({
        parent: null,
        attributes: ['password', 'invite_code'],
        success: (model, data) => {
          var user, user_data;
          user_data = User.prototype.expand(data).toObject();
          user = new User(user_data);
          return resolve(user);
        },
        //END success
        error: (model, error) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseRegisterRegion
  //END error
  promiseClaimGameKit({franchisee_id, game_kit_code} = {}) {
    return Q.Promise((resolve, reject) => {
      if (franchisee_id == null) {
        throw new Error("Franchisee Id must be specified");
      }
      if (game_kit_code == null) {
        throw new Error("GameKit code must be specified");
      }
      if (!GameKit.isValidCode(game_kit_code)) {
        throw new Error("Valid GameKit code must be given");
      }
      return (new Falcon.Model({
        endpoint: "rpc/claim_game_kit"
      })).set({franchisee_id, game_kit_code}).create({
        parent: null,
        attributes: ['franchisee_id', 'game_kit_code'],
        success: (model, data) => {
          var game_kit, game_kit_data;
          game_kit_data = GameKit.prototype.expand(data).toObject();
          game_kit = new GameKit(game_kit_data);
          return resolve(game_kit);
        },
        //END success
        error: (model, error) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseClaimGameKit
  //END error
  promiseCheckGameCode(code) {
    return Q.Promise((resolve, reject) => {
      // throw new Error("GameKit code must be specified") unless code?
      // throw new Error("Valid game code must be given") unless Entry.isValidCode(code)
      return (new Falcon.Model({
        endpoint: "rpc/check_game_code"
      })).set({code}).create({
        parent: null,
        attributes: ['code'],
        success: (model, data) => {
          var entry, entry_data;
          entry_data = Entry.prototype.expand(data).toObject();
          entry = new Entry(entry_data);
          return resolve(entry);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseCheckGameCode
  //END error
  promiseClaimGameCode(code) {
    return Q.Promise((resolve, reject) => {
      if (code == null) {
        throw new Error("Game code must be specified");
      }
      if (!Entry.isValidCode(code)) {
        throw new Error("Valid game code must be given");
      }
      return (new Falcon.Model({
        endpoint: "rpc/claim_game_code"
      })).set({code}).create({
        parent: null,
        attributes: ['code'],
        success: (model, data) => {
          var entry, entry_data, i, len, notificationType, ref;
          entry_data = Entry.prototype.expand(data).toObject();
          entry = new Entry(entry_data);
          if (data['meta'] != null) {
            if (data['meta']['notifications'] != null) {
              ref = data['meta']['notifications'];
              for (i = 0, len = ref.length; i < len; i++) {
                notificationType = ref[i];
                //							if notificationType.includes "milestone"
                //								entry.reached_milestone(true)
                Application.trigger("meta:notification", notificationType);
              }
            }
          }
          return resolve(entry);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseClaimGameCode
  //END error
  promisePickGlobalContestWinner({contest} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.GLOBAL_TYPE) {
        throw new Error("contest must be a franchisee type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/pick_global_contest_winner"
      })).set({
        contest_id: contest.get('id')
      }).create({
        parent: null,
        attributes: ['contest_id'],
        success: (model, data) => {
          var contest_winner, contest_winner_data;
          contest_winner_data = ContestWinner.prototype.expand(data).toObject();
          contest_winner = new ContestWinner(contest_winner_data);
          return resolve(contest_winner);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promisePickGlobalContestWinner
  //END error
  promiseManuallyPickGlobalContestWinner({contest, winner_name} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.GLOBAL_TYPE) {
        throw new Error("contest must be a global type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/manually_pick_global_contest_winner"
      })).set({
        contest_id: contest.get('id'),
        winner_name: winner_name
      }).create({
        parent: null,
        attributes: ['contest_id', 'winner_name'],
        success: (model, data) => {
          var contest_winner, contest_winner_data;
          contest_winner_data = ContestWinner.prototype.expand(data).toObject();
          contest_winner = new ContestWinner(contest_winner_data);
          return resolve(contest_winner);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseManuallyPickFPTContestWinner
  //END error
  promisePickFPTContestWinners({contest} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.FPT_TYPE) {
        throw new Error("contest must be a franchisee type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/pick_fpt_contest_winners"
      })).set({
        contest_id: contest.get('id')
      }).create({
        parent: null,
        attributes: ['contest_id'],
        success: (model, data) => {
          var contest_winners, contest_winners_data;
          contest_winners_data = ContestWinner.prototype.expand(data).toArray();
          contest_winners = new ContestWinners(contest_winners_data);
          return resolve(contest_winners);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promisePickFPTContestWinners
  //END error
  promisePickFPTContestWinner({fpt, contest} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(fpt instanceof FPT)) {
        throw new Error("fpt must be an instanceof FPT");
      }
      if (fpt.isNew()) {
        throw new Error("fpt must not be new");
      }
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.FPT_TYPE) {
        throw new Error("contest must be a fpt type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/pick_fpt_contest_winner"
      })).set({
        fpt_id: fpt.get('id'),
        contest_id: contest.get('id')
      }).create({
        parent: null,
        attributes: ['fpt_id', 'contest_id'],
        success: (model, data) => {
          var contest_winner, contest_winner_data;
          contest_winner_data = ContestWinner.prototype.expand(data).toObject();
          contest_winner = new ContestWinner(contest_winner_data);
          return resolve(contest_winner);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promisePickFPTContestWinner
  //END error
  promiseManuallyPickFPTContestWinner({fpt, contest, winner_name} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(fpt instanceof FPT)) {
        throw new Error("fpt must be an instanceof FPT");
      }
      if (fpt.isNew()) {
        throw new Error("fpt must not be new");
      }
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.FPT_TYPE) {
        throw new Error("contest must be a fpt type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/manually_pick_fpt_contest_winner"
      })).set({
        fpt_id: fpt.get('id'),
        contest_id: contest.get('id'),
        winner_name: winner_name
      }).create({
        parent: null,
        attributes: ['fpt_id', 'contest_id', 'winner_name'],
        success: (model, data) => {
          var contest_winner, contest_winner_data;
          contest_winner_data = ContestWinner.prototype.expand(data).toObject();
          contest_winner = new ContestWinner(contest_winner_data);
          return resolve(contest_winner);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseManuallyPickFPTContestWinner
  //END error
  promisePickFranchiseeContestWinner({franchisee, contest} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(franchisee instanceof Franchisee)) {
        throw new Error("franchisee must be an instanceof Franchisee");
      }
      if (franchisee.isNew()) {
        throw new Error("franchisee must not be new");
      }
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.FRANCHISEE_TYPE) {
        throw new Error("contest must be a franchisee type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/pick_franchisee_contest_winner"
      })).set({
        franchisee_id: franchisee.get('id'),
        contest_id: contest.get('id')
      }).create({
        parent: null,
        attributes: ['franchisee_id', 'contest_id'],
        success: (model, data) => {
          var contest_winner, contest_winner_data;
          contest_winner_data = ContestWinner.prototype.expand(data).toObject();
          contest_winner = new ContestWinner(contest_winner_data);
          return resolve(contest_winner);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promisePickFranchiseeContestWinner
  //END error
  promiseManuallyPickFranchiseeContestWinner({franchisee, contest, winner_name} = {}) {
    return Q.Promise((resolve, reject) => {
      if (!(franchisee instanceof Franchisee)) {
        throw new Error("franchisee must be an instanceof Franchisee");
      }
      if (franchisee.isNew()) {
        throw new Error("franchisee must not be new");
      }
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be an instanceof Contest");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      if (contest.get('type') !== Contest.FRANCHISEE_TYPE) {
        throw new Error("contest must be a franchisee type contest");
      }
      return (new Falcon.Model({
        endpoint: "rpc/manually_pick_franchisee_contest_winner"
      })).set({
        franchisee_id: franchisee.get('id'),
        contest_id: contest.get('id'),
        winner_name: winner_name
      }).create({
        parent: null,
        attributes: ['franchisee_id', 'contest_id', 'winner_name'],
        success: (model, data) => {
          var contest_winner, contest_winner_data;
          contest_winner_data = ContestWinner.prototype.expand(data).toObject();
          contest_winner = new ContestWinner(contest_winner_data);
          return resolve(contest_winner);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseManuallyPickFranchiseeContestWinner
  //END error
  promiseDrawContestFinalists({contest, fpt, franchisee}) {
    return Q.Promise((resolve, reject) => {
      var data;
      if (!(contest instanceof Contest)) {
        throw new Error("contest must be provided");
      }
      if (contest.isNew()) {
        throw new Error("contest must not be new");
      }
      data = {};
      data['contest_id'] = contest.get('id');
      if (contest.get('type') === Contest.FPT_TYPE) {
        if (!(fpt instanceof FPT)) {
          throw new Error("fpt must be provided");
        }
        if (fpt.isNew()) {
          throw new Error("fpt must not be new");
        }
        data["fpt_id"] = fpt.get('id');
      } else if (contest.get('type') === Contest.FRANCHISEE_TYPE) {
        if (!(franchisee instanceof Franchisee)) {
          throw new Error("franchisee must be provided");
        }
        if (franchisee.isNew()) {
          throw new Error("franchisee must not be new");
        }
        data["franchisee_id"] = franchisee.get('id');
      }
      //END if
      return new Falcon.Model({
        endpoint: "rpc/draw_contest_finalists"
      }).set(data).create({
        parent: null,
        attributes: _.keys(data),
        success: (model, data) => {
          var contest_finalist_data, contest_finalists;
          contest_finalist_data = ContestFinalist.prototype.expand(data).toArray();
          contest_finalists = new ContestFinalists(contest_finalist_data);
          return resolve(contest_finalists);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseDrawContestFinalists
  //END error
  promiseMoveParticipantEntries({user_id, contest_id, franchisee_id}) {
    return Q.Promise((resolve, reject) => {
      if (user_id == null) {
        throw new Error("user_id must be present");
      }
      if (contest_id == null) {
        throw new Error("contest_id must be present");
      }
      if (franchisee_id == null) {
        throw new Error("franchisee_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/move_participant_entries",
        user_id,
        contest_id,
        franchisee_id
      }).create({
        attributes: ['user_id', 'contest_id', 'franchisee_id'],
        parent: null,
        success: (model, data) => {
          var entries, entries_data;
          entries_data = Entry.prototype.expand(data).toArray();
          entries = new Entries(entries_data);
          return resolve(entries);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseMoveParticipantEntries
  //END error
  promiseMoveEntriesBetweenUsers({from_user_id, to_user_id}) {
    return Q.Promise((resolve, reject) => {
      if (from_user_id == null) {
        throw new Error("from_user_id must be present");
      }
      if (to_user_id == null) {
        throw new Error("to_user_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/move_entries_between_users",
        from_user_id,
        to_user_id
      }).create({
        attributes: ['from_user_id', 'to_user_id'],
        parent: null,
        success: (model, data) => {
          return resolve();
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseMoveEntriesBetweenUsers

    //TODO: Move these attributes over to a ContestStatistic Model
  //END error
  promiseAdditionalContestStatistics({contest_id}) {
    return Q.Promise((resolve, reject) => {
      if (contest_id == null) {
        throw new Error("contest_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/additional_contest_statistics",
        contest_id
      }).create({
        attributes: ['contest_id'],
        parent: null,
        success: (model, data) => {
          return resolve(data);
        },
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseAdditionalContestStatistics
  //END error
  promiseEmailParticipants({franchisee_id, email_template, subject, headline, body, media, tag}) {
    return Q.Promise((resolve, reject) => {
      if (franchisee_id == null) {
        throw new Error("franchisee_id must be present");
      }
      if (subject == null) {
        throw new Error("subject must be present");
      }
      if (body == null) {
        throw new Error("body must be present");
      }
      if (headline == null) {
        throw new Error("headline must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/email_participants",
        franchisee_id,
        email_template,
        subject,
        headline,
        body,
        media,
        tag
      }).create({
        attributes: ['franchisee_id', 'email_template', 'subject', 'headline', 'body', 'media', 'tag'],
        parent: null,
        success: (model, data) => {
          return resolve(data);
        },
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseEmailParticipants
  //END error
  promiseGetFranchiseeAlertStats() {
    return Q.Promise((resolve, reject) => {
      return new Falcon.Model({
        endpoint: "rpc/franchisee_alert_stats"
      }).create({
        attributes: ['period_start_date', 'instant_winner_count', 'tool_storage_count', 'diagnostic_scan_tool_count'],
        parent: null,
        success: (model, data) => {
          return resolve(data);
        },
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseGetFranchiseeAlertStats
  //END error
  promiseGetFranchiseeUserStats({franchisee_id, tags = []}) {
    return Q.Promise((resolve, reject) => {
      if (franchisee_id == null) {
        throw new Error("franchisee_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/franchisee_user_stats",
        franchisee_id,
        tags
      }).create({
        attributes: ['franchisee_id', 'tags'],
        parent: null,
        success: (model, data) => {
          return resolve(data);
        },
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseGetFranchiseeUserStats
  //END error
  promiseGetFranchiseeTagStats({franchisee_id, tags = []}) {
    return Q.Promise((resolve, reject) => {
      if (franchisee_id == null) {
        throw new Error("franchisee_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/franchisee_tag_stats",
        franchisee_id,
        tags
      }).create({
        attributes: ['franchisee_id', 'tags'],
        parent: null,
        success: (model, data) => {
          return resolve(data);
        },
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseGetFranchiseeTagStats
  //END error
  promiseDrawIntermediaryWinner({franchisee_id}) {
    return Q.Promise((resolve, reject) => {
      if (franchisee_id == null) {
        throw new Error("franchisee_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/draw_intermediary_winner",
        franchisee_id
      }).create({
        attributes: ['franchisee_id'],
        parent: null,
        success: (model, data) => {
          var entry, entry_data;
          entry_data = Entry.prototype.expand(data).toObject();
          entry = new Entry(entry_data);
          return resolve(entry);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseDrawIntermediaryWinner
  //END error
  promiseUnlinkUser({tag, user_id, franchisee_id}) {
    return Q.Promise((resolve, reject) => {
      if (tag == null) {
        throw new Error("tag must be present");
      }
      if (franchisee_id == null) {
        throw new Error("franchisee_id must be present");
      }
      if (user_id == null) {
        throw new Error("user_id must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/unlink_user",
        franchisee_id,
        user_id,
        tag
      }).create({
        attributes: ['franchisee_id', 'user_id', 'tag'],
        parent: null,
        success: (model, data) => {
          var franchisee, franchisee_data;
          franchisee_data = Franchisee.prototype.expand(data).toObject();
          franchisee = new Franchisee(franchisee_data);
          return resolve(franchisee);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseUnlinkUser
  //END error
  promiseCheckEmail(email) {
    return Q.Promise((resolve, reject) => {
      if (email == null) {
        throw new Error("email must be present");
      }
      return new Falcon.Model({
        endpoint: "rpc/check_email",
        email
      }).create({
        attributes: ['email'],
        parent: null,
        success: (model, data) => {
          return resolve((data != null ? data.is_taken : void 0) || false);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseCheckEmail
  //END error
  promiseSelectRaceWinner(race) {
    return Q.Promise((resolve, reject) => {
      if (!(race instanceof Race)) {
        throw new Error("race must be an instanceof Race");
      }
      return new Falcon.Model({
        endpoint: "rpc/select_race_winner",
        race_id: race.get('id'),
        selected_race_option_id: race.get('selected_race_option_id')
      }).create({
        attributes: ['race_id', 'selected_race_option_id'],
        parent: null,
        success: (model, data) => {
          var race_data;
          race_data = Race.prototype.expand(data).toObject();
          race = new Race().fill(race_data);
          return resolve(race);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseSelectRaceWinner
  //END error
  promiseMarkRaceSelection(race_selection) {
    return Q.Promise((resolve, reject) => {
      if (!(race_selection instanceof RaceSelection)) {
        throw new Error("race_selection must be an instanceof RaceSelection");
      }
      return new Falcon.Model({
        endpoint: "rpc/mark_race_selection",
        race_selection_id: race_selection.get('id')
      }).create({
        attributes: ['race_selection_id'],
        parent: null,
        success: (model, data) => {
          var race_selection_data;
          race_selection_data = RaceSelection.prototype.expand(data).toObject();
          race_selection = new Race().fill(race_selection_data);
          return resolve(race_selection);
        },
        //END success
        error: (model, error) => {
          if (typeof console !== "undefined" && console !== null) {
            console.error(error);
          }
          return reject(error);
        }
      });
    });
  }

  //END promiseMarkRaceSelection
  //END error
  promiseGetTOTPInfo() {
    return Q.Promise((resolve, reject) => {
      return (new Falcon.Model({
        endpoint: "rpc/totp_info"
      })).create({
        parent: null,
        success: (model, data) => {
          return resolve(data);
        },
        //END success
        error: (model, error) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseGetTOTPInfo
  //END error
  promiseTOTPEnable(totp_code) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(totp_code)) {
        throw new Error("totp_code must be a string");
      }
      if (_.isEmpty(totp_code)) {
        throw new Error("totp_code must not be empty");
      }
      return (new Falcon.Model({
        endpoint: "rpc/totp_enable"
      })).set({totp_code}).create({
        parent: null,
        attributes: ['totp_code'],
        success: (model, data) => {
          var session, session_data;
          session_data = Session.prototype.expand(data).toObject();
          session = new Session(session_data);
          return resolve(session);
        },
        //END success
        error: (model, error) => {
          return reject(error);
        }
      });
    });
  }

  //END promiseTOTPEnable
  //END error
  promiseTOTPVerify(totp_code) {
    return Q.Promise((resolve, reject) => {
      if (!_.isString(totp_code)) {
        throw new Error("totp_code must be a string");
      }
      if (_.isEmpty(totp_code)) {
        throw new Error("totp_code must not be empty");
      }
      return (new Falcon.Model({
        endpoint: "rpc/totp_verify"
      })).set({totp_code}).create({
        parent: null,
        attributes: ['totp_code'],
        success: (model, data) => {
          var session, session_data;
          session_data = Session.prototype.expand(data).toObject();
          session = new Session(session_data);
          return resolve(session);
        },
        //END success
        error: (model, error) => {
          return reject(error);
        }
      });
    });
  }

})();

//END promiseTOTPVerify
//END class
//END error

},{"./$collections/contest_finalists.collection":25,"./$collections/contest_winners.collection":26,"./$collections/entries.collection":28,"./$collections/franchisees.collection":35,"./$models/contest.model":57,"./$models/contest_finalist.model":58,"./$models/contest_winner.model":59,"./$models/entry.model":60,"./$models/fpt.model":61,"./$models/franchisee.model":64,"./$models/game_kit.model":68,"./$models/invite.model":69,"./$models/race.model":72,"./$models/race_selection.model":74,"./$models/session.model":78,"./$models/user.model":82}],91:[function(require,module,exports){
//Import environment specific requirements
var Application, Entry, Environment, LayoutView, Session;

Environment = require("./environment");

Session = require("../$models/session.model");

Entry = require("../$models/entry.model");

LayoutView = require("./views/layout.view");

module.exports = Application = new ((function() {
  var _Class, ref;

  _Class = class extends Falcon.Object {
    //END current_user
    //END observables
    init() {
      Environment.resolve();
      Language.loadFromCache();
      Tutorial.loadFromCache();
      window.RPC = require("../rpc");
      this.checkIsOnMobile();
      this.checkIncomingGameCode();
      this.attachWindowEvents();
      this.attachAdapterEvents();
      this.Layout = new LayoutView();
      return this.promiseCheckSession().then((session) => {
        return this.login(session);
      }).fail((error) => {
        if (error == null) {
          return;
        }
        return this.flashError(error);
      }).fin(() => {
        return Falcon.apply(this.Layout, '#application', () => {
          return Finch.options({
            CoerceParameterTypes: true
          }).listen();
        });
      }).done();
    }

    //END promiseCheckSession
    //END init
    promiseCheckSession() {
      return Q.Promise((resolve, reject) => {
        if (this.is_checking_session()) {
          return reject(null);
        }
        this.is_checking_session(true);
        return (new Session()).promiseFetch().then(resolve, reject).fin(() => {
          return this.is_checking_session(false);
        }).done();
      });
    }

    //END promise chain
    //END checkSession
    login(session) {
      session = ko.unwrap(session);
      if (!(session instanceof Session)) {
        throw new Error("session must be an instance of Session");
      }
      //END unless
      this.current_session(session);
      Application.trigger('login', session);
      return this;
    }

    //END login
    logout() {
      if (!this.is_logged_in()) {
        return this;
      }
      (new Session()).promiseDestroy().then(() => {
        this.current_session(null);
        return this.trigger('logout');
      }).done();
      //END promise chain
      return this;
    }

    //END logout
    flashError(error) {
      switch (false) {
        case !RequestHelpers.isUnauthorized(error):
          return typeof console !== "undefined" && console !== null ? console.error("Session Expired") : void 0;
        default:
          return Application.reportError(error);
      }
    }

    //END flashError
    reportError(error) {
      var ref1, ref2;
      if (error == null) {
        error = {
          human: "An error occurred"
        };
      }
      if (typeof console !== "undefined" && console !== null) {
        console.error((ref1 = (ref2 = error.stack) != null ? ref2 : error.human) != null ? ref1 : "An error occurred");
      }
      return this;
    }

    //END reportError
    attachWindowEvents() {
      window.addEventListener('online', () => {
        return this.is_online(true);
      });
      window.addEventListener('offline', () => {
        return this.is_online(false);
      });
      window.addEventListener('resize', () => {
        return this.checkIsOnMobile();
      });
      window.addEventListener('click', () => {
        return Application.trigger("window:click");
      });
      return this;
    }

    //END attachWindowEvents
    attachAdapterEvents() {
      this.listenTo(Falcon.dataAdapter, 'unauthorized', this.logout);
      return this;
    }

    //END attachAdapterEvents
    checkIsOnMobile() {
      if (window.hasOwnProperty('matchMedia')) {
        return this.is_on_mobile(window.matchMedia("(max-width: 640px) and (orientation: portrait), screen and (max-width: 1138px) and (orientation: landscape)").matches);
      } else {
        return this.is_on_mobile(false);
      }
    }

    //END if
    //EHC checkIsOnMobile
    checkIncomingGameCode() {
      var code, e, i, key, len, params, query_piece, query_pieces, query_string, value;
      params = {};
      query_string = window.location.search;
      if (query_string.charAt("0") === "?") {
        query_string = query_string.slice(1);
      }
      query_pieces = query_string.split("&");
      code = null;
      for (i = 0, len = query_pieces.length; i < len; i++) {
        query_piece = query_pieces[i];
        [key, value] = query_piece.split("=", 2);
        if (key === "code") {
          code = value;
        }
      }
      //END for
      this.incoming_code(code);
      if (code != null) {
        try {
          return gtag('event', 'load', {
            'event_category': 'qr-code',
            'event_label': 'Dream Drive 2021',
            'value': 1
          });
        } catch (error1) {
          e = error1;
          return console.error(e);
        }
      }
    }

    //END try/catch
    //END if
    //END checkIncomingGameCode
    hasClaimedEntry() {
      return this.claimed_entry() instanceof Entry;
    }

    getClaimedEntry() {
      return this.claimed_entry();
    }

    clearClaimedEntry() {
      return this.claimed_entry(null);
    }

    setClaimedEntry(entry) {
      if (!(entry instanceof Entry)) {
        throw new Error("entry must be an instanceof Entry");
      }
      return this.claimed_entry(entry);
    }

    //END setClaimedEntry
    retrieveIncomingGameCode() {
      var code;
      code = this.incoming_code();
      this.incoming_code(null);
      return code;
    }

  };

  _Class.prototype.observables = {
    'is_online': (ref = typeof navigator !== "undefined" && navigator !== null ? navigator.onLine : void 0) != null ? ref : true,
    'is_checking_session': false,
    'claimed_entry': null,
    'incoming_code': null,
    'current_session': null,
    'is_logged_in': function() {
      return this.current_session() instanceof Session;
    },
    'is_on_mobile': false,
    'current_user': function() {
      if (!this.is_logged_in()) {
        return null;
      }
      return this.current_session().get('user');
    }
  };

  return _Class;

}).call(this))();

//END retrieveIncomingGameCode
//END Application

},{"../$models/entry.model":60,"../$models/session.model":78,"../rpc":90,"./environment":96,"./views/layout.view":108}],92:[function(require,module,exports){
var DOMHelpers;

DOMHelpers = require("../../$helpers/dom.helpers");

Falcon.addBinding("customHeroAnimation", {
  init: function(element, valueAccessor) {
    var hero_banners, hero_content, player, src;
    src = ko.unwrap(valueAccessor());
    element.setAttribute("src", src);
    player = new Vimeo.Player(element);
    player.setMuted(true);
    player.ready().then(() => {
      return console.log("READY");
    });
    hero_content = $(".so-hero--content");
    hero_banners = $(".so-hero--banners");
    return player.on('timeupdate', (info) => {
      if (info.seconds >= 4) {
        hero_banners.addClass("is-visible");
      }
      if (info.seconds >= 4.5) {
        return hero_content.addClass("is-visible");
      }
    });
  }
});

//END on
//END customHeroAnimation

},{"../../$helpers/dom.helpers":52}],93:[function(require,module,exports){
var tempElm;

tempElm = document.createElement("div");

Falcon.addBinding("lang", true, function(element, valueAccessor) {
  tempElm.innerHTML = Language(ko.unwrap(valueAccessor()));
  return ko.virtualElements.setDomNodeChildren(element, Array.prototype.slice.call(tempElm.childNodes));
});

//END lang

},{}],94:[function(require,module,exports){
Falcon.addBinding('placeholder', function(element, valueAccessor) {
  var temp;
  temp = document.createElement('span');
  temp.innerHTML = Language(ko.unwrap(valueAccessor()));
  return element.setAttribute('placeholder', temp.textContent);
});

//END addBinding

},{}],95:[function(require,module,exports){
(function (global){(function (){
// Import globals
require("../$polyfills/function.bind");

require("../$polyfills/requestAnimationFrame");

require("../$bindings/dateText.binding");

require("../$bindings/dateTimeText.binding");

require("../$bindings/dateValue.binding");

require("../$bindings/daysUntilText.binding");

require("../$bindings/fromNowText.binding");

require("../$bindings/hashHref.binding");

require("../$bindings/href.binding");

require("../$bindings/isHovered.binding");

require("../$bindings/moment.binding");

require("../$bindings/monthText.binding");

require("../$bindings/monthYearText.binding");

require("../$bindings/followCursor.binding");

require("../$bindings/onEnter.binding");

require("../$bindings/onScrollBottom.binding");

require("../$bindings/preventDefault.binding");

require("../$bindings/s3Upload.binding");

require("../$bindings/selectize.binding");

require("../$bindings/src.binding");

require("../$bindings/stopEvent.binding");

require("../$bindings/stopPropagation.binding");

require("../$bindings/percent.binding");

require("../$bindings/integer.binding");

require("../$bindings/decimal.binding");

require("../$bindings/recaptcha.binding");

require("./bindings/lang.binding");

require("./bindings/placeholder.binding");

require("./bindings/customHeroAnimation.binding");

require("../extenders");

require("./ipinfo");

global.Helpers = require("../$helpers/default.helpers");

global.DOMHelpers = require("../$helpers/dom.helpers");

global.RequestHelpers = require("../$helpers/request.helpers");

global.Router = require("./router");

global.Application = require("./application");

global.Language = require("./language");

global.Tutorial = require("./tutorial");

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../$bindings/dateText.binding":1,"../$bindings/dateTimeText.binding":2,"../$bindings/dateValue.binding":3,"../$bindings/daysUntilText.binding":4,"../$bindings/decimal.binding":5,"../$bindings/followCursor.binding":6,"../$bindings/fromNowText.binding":7,"../$bindings/hashHref.binding":8,"../$bindings/href.binding":9,"../$bindings/integer.binding":10,"../$bindings/isHovered.binding":11,"../$bindings/moment.binding":12,"../$bindings/monthText.binding":13,"../$bindings/monthYearText.binding":14,"../$bindings/onEnter.binding":15,"../$bindings/onScrollBottom.binding":16,"../$bindings/percent.binding":17,"../$bindings/preventDefault.binding":18,"../$bindings/recaptcha.binding":19,"../$bindings/s3Upload.binding":20,"../$bindings/selectize.binding":21,"../$bindings/src.binding":22,"../$bindings/stopEvent.binding":23,"../$bindings/stopPropagation.binding":24,"../$helpers/default.helpers":51,"../$helpers/dom.helpers":52,"../$helpers/request.helpers":53,"../$polyfills/function.bind":84,"../$polyfills/requestAnimationFrame":85,"../extenders":86,"./application":91,"./bindings/customHeroAnimation.binding":92,"./bindings/lang.binding":93,"./bindings/placeholder.binding":94,"./ipinfo":97,"./language":98,"./router":99,"./tutorial":100}],96:[function(require,module,exports){
//==================================================================
// Class: Environment
//	Class used to configure the application with specific
//	environment related settings.  This should never be instantiated
//	and should only be used for its static methods
//==================================================================
var Environment, JWTAdapater;

JWTAdapater = require("../jwt_adapter");

// Analytics = require("../analytics")
module.exports = Environment = new ((function() {
  var _Class;

  _Class = class {
    //--------------------------------------------------------------
    // Method: Environment.configure('environment')
    //	Used to configure the environment variables for a given
    //	environment. If no environment is given or the given
    //	environment is not defined, the "local" environment method
    //	is called.
    //--------------------------------------------------------------
    configure(environment) {
      var setup_method;
      if (!_.isString(environment)) {
        environment = "local";
      }
      environment = Helpers.trim(environment).toLowerCase();
      if (environment === "configure") {
        environment = "local";
      }
      setup_method = this[environment];
      if (!_.isFunction(setup_method)) {
        setup_method = this.local;
      }
      if (setup_method == null) {
        setup_method = (function() {});
      }
      this.all();
      setup_method();
      return this;
    }

    //END configure

      //--------------------------------------------------------------
    // Method: Environment.resolve()
    //	Attempts to resolve the environment based on the window location
    //--------------------------------------------------------------
    resolve() {
      var _match;
      _match = function(url) {
        return window.location.href.indexOf(url) > -1;
      };
      if (_match("localhost:9000") || _match("localhost.com:9000")) {
        // return @redirect('localhost:9000') if _match("localhost.com:9000")
        return this.configure('local');
      }
      if (_match("www-dev.snaponpromotion.com")) {
        return this.configure('development_na');
      }
      if (_match("www-dev.snaponpromotion.co.uk")) {
        return this.configure('development_uk');
      }
      if (_match("snaponpromotion.com")) {
        return this.configure('production_na');
      }
      if (_match("snaponpromotion.co.uk")) {
        return this.configure('production_uk');
      }
      throw "Could not resolve the environment.";
    }

    //END resolve
    redirect(url) {
      url = url + "/" + window.location.hash;
      url = ` ${url}`.replace(/([^:])\/+/gi, "$1/");
      url = Helpers.trim(url);
      if (!/^https?:\/\//gi.test(url)) {
        url = `http://${url}`;
      }
      window.location.href = url;
      return this;
    }

    //END redirect

      //--------------------------------------------------------------
    // Method: Environment.all
    //	Called before each environment specific configure
    //--------------------------------------------------------------
    all() {
      Falcon.dataAdapter = new JWTAdapater();
      Falcon.dataAdapter.cache = true;
      //Set up cors
      $.ajaxSetup({
        headers: {
          'Accept': "application/json; charset=utf-8",
          'Content-Type': "application/json; charset=utf-8"
        },
        //END headers
        crossDomain: true
      });
      //END ajaxSetup
      $.support.cors = true;
      return this;
    }

    //END all

      //--------------------------------------------------------------
    // Method: Environment.production_na()
    //	Sets up production settings
    //--------------------------------------------------------------
    production_na() {
      Falcon.baseApiUrl = "https://api.snaponpromotion.com";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.config('https://f50384c08c0c46f48bd5f681ed254ccd@o58646.ingest.sentry.io/4504052875001856').install({
          environment: "production",
          tags: {
            app: "web"
          }
        });
      }
      // Analytics.init("e2388cfbb4cb18b9e0f580360d8305e2", 'technician')
      return this;
    }

    //END production_na

      //--------------------------------------------------------------
    // Method: Environment.production_uk()
    //	Sets up production settings
    //--------------------------------------------------------------
    production_uk() {
      Falcon.baseApiUrl = "https://api.snaponpromotion.co.uk";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.config('https://f50384c08c0c46f48bd5f681ed254ccd@o58646.ingest.sentry.io/4504052875001856').install({
          environment: "production",
          tags: {
            app: "web"
          }
        });
      }
      // Analytics.init("e2388cfbb4cb18b9e0f580360d8305e2", 'technician')
      return this;
    }

    //END production_uk

      //--------------------------------------------------------------
    // Method: Environment.development_na()
    //	Sets up development settings
    //--------------------------------------------------------------
    development_na() {
      Falcon.baseApiUrl = "https://api-dev.snaponpromotion.com";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.config('https://4a6ed715b0ea45ff91894d97f8b30e5a@o58646.ingest.sentry.io/4504052871659520').install({
          environment: "development",
          tags: {
            app: "web"
          }
        });
      }
      // Analytics.init("b3b9b35d23a5fc6a02f7168f6cf95dab", 'technician', true)
      return this;
    }

    //END development_na

      //--------------------------------------------------------------
    // Method: Environment.development_uk()
    //	Sets up development settings
    //--------------------------------------------------------------
    development_uk() {
      Falcon.baseApiUrl = "https://api-dev.snaponpromotion.co.uk";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.config('https://4a6ed715b0ea45ff91894d97f8b30e5a@o58646.ingest.sentry.io/4504052871659520').install({
          environment: "development",
          tags: {
            app: "web"
          }
        });
      }
      // Analytics.init("b3b9b35d23a5fc6a02f7168f6cf95dab", 'technician', true)
      return this;
    }

    //END development_uk

      //--------------------------------------------------------------
    // Method: Environment.local()
    //	Sets up local settings
    //--------------------------------------------------------------
    local() {
      Falcon.baseApiUrl = "https://localhost:65431";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.config('https://69ad8cff7b9b499aad29bb135da1f8ec@o58646.ingest.sentry.io/4504052891582464').install({
          environment: "local",
          tags: {
            app: "web"
          }
        });
      }
      // Analytics.init("a469757d470f4a7bb24cd0803954a408", 'technician', true)
      return this;
    }

  };

  window.ENV = {};

  return _Class;

}).call(this))();

//END local
//END Environement

},{"../jwt_adapter":88}],97:[function(require,module,exports){
(function() {
  var country, ip, script;
  ip = ko.observable();
  country = ko.observable();
  window.IPInfo = {
    ip,
    country,
    isLoaded: ko.observable(false),
    isInUnitedStates: ko.computed(function() {
      return /^(united states|us)$/i.test(country());
    }),
    //END isInUnitedStates
    isInCanada: ko.computed(function() {
      return /^ca(nada)?$/i.test(country());
    })
  };
  //END isInCanada
  window.ipinfoJsonpResponse = function(data) {
    IPInfo.ip(data.ip);
    IPInfo.country(data.country);
    return IPInfo.isLoaded(true);
  };
  //END ipinfoJsonpResponse
  script = document.createElement('script');
  script.src = window.location.protocol + '//ipinfo.io?callback=ipinfoJsonpResponse';
  return document.head.appendChild(script);
})();

// document.getElementsByTagName('head')[0].appendChild(script);
//END do

},{}],98:[function(require,module,exports){
var LANGUAGE_CODE_KEY, Language;

LANGUAGE_CODE_KEY = "__SO_LANGUAGE_CODE__";

Language = function(translationText) {
  var language;
  if (!_.isString(translationText)) {
    return translationText;
  }
  language = Language.resolveLanguage();
  if ((translationText in language.translations) && (language.translations[translationText] != null)) {
    return language.translations[translationText];
  }
  //END if
  if (language !== Language.DEFAULT) {
    if (typeof console !== "undefined" && console !== null) {
      console.warn(`Couldn't find translation for: '${translationText}'`);
    }
  }
  //END if
  return translationText;
};

//END Language
Language.LANGUAGES = {
  "us/en": require("../$languages/en-us.language"),
  "ca/en": require("../$languages/en-ca.language"),
  "ca/fr": require("../$languages/fr-ca.language")
};

Language.DEFAULT = Language.LANGUAGES["us/en"];

Language.selectedLanguageCode = ko.observable(void 0);

Language.hasSelectedLanguage = ko.computed(function() {
  var code;
  code = Language.selectedLanguageCode();
  if (code == null) {
    return false;
  }
  return code in Language.LANGUAGES;
});

//END hasSelectedLanguage
Language.isFrench = ko.computed(function() {
  return Language.selectedLanguageCode() === "ca/fr";
});

Language.selectCode = function(code) {
  var e, message, ref;
  if (_.isString(code) && (code in Language.LANGUAGES)) {
    Language.selectedLanguageCode(code);
    try {
      localStorage[LANGUAGE_CODE_KEY] = code;
    } catch (error) {
      e = error;
      message = (ref = e.message) != null ? ref : "QuotaExceededError";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.captureMessage(message, {
          'level': 'warning'
        });
      }
      if (typeof console !== "undefined" && console !== null) {
        console.error(e);
      }
    }
  }
  //END try
  //END if
  return Language.selectedLanguageCode();
};

//END selectByCode
Language.loadFromCache = function() {
  var code, e, language, message, ref;
  try {
    if (localStorage[LANGUAGE_CODE_KEY] == null) {
      return;
    }
    code = localStorage[LANGUAGE_CODE_KEY];
    if (!_.isString(code)) {
      delete localStorage[LANGUAGE_CODE_KEY];
      return;
    }
    //END unless
    language = Language.LANGUAGES[code];
    if (code in Language.LANGUAGES) {
      return Language.selectedLanguageCode(code);
    } else {
      return delete localStorage[LANGUAGE_CODE_KEY];
    }
  } catch (error) {
    //END If
    e = error;
    message = (ref = e.message) != null ? ref : "QuotaExceededError";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.captureMessage(message, {
        'level': 'warning'
      });
    }
    return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
  }
};

//END try
//END loadFromCache
Language.clear = function() {
  var code, e, message, ref;
  if (!Language.hasSelectedLanguage()) {
    return;
  }
  code = Language.selectedLanguageCode();
  Language.selectedLanguageCode(void 0);
  try {
    return delete localStorage[code];
  } catch (error) {
    e = error;
    message = (ref = e.message) != null ? ref : "QuotaExceededError";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.captureMessage(message, {
        'level': 'warning'
      });
    }
    return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
  }
};

//END try
//END clear
Language.resolveLanguage = function() {
  var code, ref;
  code = Language.selectedLanguageCode() || "";
  return (ref = Language.LANGUAGES[code]) != null ? ref : Language.DEFAULT;
};

//END resolveLanguage
Language.isWithinUnitedStates = ko.computed(function() {
  var ref;
  return (ref = Language.selectedLanguageCode()) === "us/en";
});

Language.isWithinCanada = ko.computed(function() {
  var ref;
  return (ref = Language.selectedLanguageCode()) === "ca/en" || ref === "ca/fr";
});

module.exports = Language;

},{"../$languages/en-ca.language":54,"../$languages/en-us.language":55,"../$languages/fr-ca.language":56}],99:[function(require,module,exports){
//Require models
var ChangePasswordView, CheckGameCodeView, DashboardView, ForgotPasswordView, HomeView, LoginView, ManageAccountView, RegistrationView, ResetPasswordView, Router, SurveyView, User;

User = require("../$models/user.model");

//Require Views
ChangePasswordView = require("./views/change_password.view");

CheckGameCodeView = require("./views/check_game_code.view");

DashboardView = require("./views/dashboard.view");

ForgotPasswordView = require("./views/forgot_password.view");

HomeView = require("./views/home.view");

LoginView = require("./views/login.view");

ManageAccountView = require("./views/manage_account.view");

RegistrationView = require("./views/registration.view");

ResetPasswordView = require("./views/reset_password.view");

SurveyView = require("./views/survey.view");

//Definition
module.exports = Router = new ((function() {
  var _Class, appendParams;

  _Class = class {
    //END load
    //END setup
    makeMainUrl(params) {
      return appendParams("/", params);
    }

    gotoMain(params) {
      var main_url;
      main_url = Router.makeMainUrl(params);
      Finch.navigate(main_url);
      return Router;
    }

    //END unload
    //END route
    makeCheckGameCodeUrl(params) {
      return appendParams("/check_game_code", params);
    }

    //END makeCheckGameCodeUrl
    gotoCheckGameCode(params) {
      var url;
      url = Router.makeCheckGameCodeUrl(params);
      Finch.navigate(url);
      return Router;
    }

    //END unload
    //END route
    makeLoginUrl(params) {
      return appendParams("/login", params);
    }

    //END makeLoginUrl
    gotoLogin(params) {
      var url;
      url = Router.makeLoginUrl(params);
      Finch.navigate(url);
      return Router;
    }

    //END unload
    //END route
    makeForgotPasswordUrl(params) {
      return appendParams("/forgot_password", params);
    }

    //END makeForgotPasswordUrl
    gotoForgotPassword() {
      var url;
      url = Router.makeForgotPasswordUrl();
      Finch.navigate(url);
      return Router;
    }

    //END unload
    //END route
    makeResetPasswordUrl(params) {
      return appendParams("/forgot_password", params);
    }

    //END makeResetPasswordUrl
    gotoResetPassword() {
      var url;
      url = Router.makeResetPasswordUrl();
      Finch.navigate(url);
      return Router;
    }

    //END unload
    //END route
    makeRegistrationUrl(params) {
      return appendParams("/registration", params);
    }

    //END makeRegistrationUrl
    gotoRegistration(params) {
      var url;
      url = Router.makeRegistrationUrl(params);
      Finch.navigate(url);
      return Router;
    }

    //END unload
    //END route
    makeManageAccountUrl(params) {
      return appendParams("/manage_account", params);
    }

    //END makeManageAccountUrl
    gotoManageAccount() {
      var url;
      url = Router.makeManageAccountUrl();
      Finch.navigate(url);
      return Router;
    }

    //END unload
    //END route
    createChangePasswordUrl(params) {
      return appendParams("/change_password", params);
    }

    //END createChangePasswordUrl
    gotoChangePassword() {
      var url;
      url = Router.createChangePasswordUrl();
      Finch.navigate(url);
      return Router;
    }

    //END teardown
    //END route
    makeSurveyUrl(params) {
      return appendParams("/manage_account", params);
    }

    //END makeSurveyUrl
    gotoSurvey() {
      var url;
      url = Router.makeSurveyUrl();
      Finch.navigate(url);
      return Router;
    }

  };

  appendParams = function(url, params) {
    var key, value;
    url = Helpers.trim(url);
    if (params == null) {
      return url;
    }
    url += (url.indexOf("?") === -1 ? "?" : "&");
    url += ((function() {
      var results;
      results = [];
      for (key in params) {
        value = params[key];
        results.push(`${key}=${value}`);
      }
      return results;
    })()).join("&");
    return url;
  };

  //END appendParams
  Finch.route("/", {
    setup: function() {
      if (!Application.is_logged_in()) {
        Finch.abort();
        return Router.gotoCheckGameCode();
      }
    },
    //END unless
    //END setup
    load: function() {
      return Application.Layout.setAuthorizedView(this.view = new HomeView());
    }
  });

  //END gotoMain
  Finch.route("/check_game_code", {
    setup: function() {
      if (Application.is_logged_in()) {
        Finch.abort();
        return Router.gotoMain();
      }
    },
    //END unless
    //END setup
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new CheckGameCodeView();
      Finch.observe("not_authorized", (not_authorized) => {
        if (not_authorized) {
          return this.view.showNotAuthorized();
        }
      });
      return Application.Layout.setUnauthorizedView(this.view);
    },
    //END load
    unload: function() {
      var ref;
      Application.Layout.tryShowAuthorizedView();
      return (ref = this.view) != null ? ref.off() : void 0;
    }
  });

  //END gotoCheckGameCode
  Finch.route("/login", {
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new LoginView();
      Finch.observe((params) => {
        var game_code, not_authorized;
        not_authorized = params('not_authorized');
        if (not_authorized) {
          this.view.showNotAuthorized();
        }
        game_code = params('game_code');
        Application.Layout.setGameCode(game_code);
        return this.view.setGameCode(game_code);
      });
      //END observe
      Application.Layout.setUnauthorizedView(this.view);
      return Application.Layout.showRecaptchaBadge();
    },
    //END load
    unload: function() {
      Application.Layout.tryShowAuthorizedView();
      return this.view.off();
    }
  });

  //END gotoLogin
  Finch.route("/forgot_password", {
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new ForgotPasswordView();
      Application.Layout.setUnauthorizedView(this.view);
      return Application.Layout.showRecaptchaBadge();
    },
    //END load
    unload: function() {
      Application.Layout.tryShowAuthorizedView();
      return this.view.off();
    }
  });

  //END gotoForgotPassword
  Finch.route("/reset_password", {
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new ResetPasswordView();
      Finch.observe((params) => {
        this.view.setEmail(params('email'));
        return this.view.setResetCode(params('reset_code'));
      });
      //END observe
      Application.Layout.setUnauthorizedView(this.view);
      return Application.Layout.showRecaptchaBadge();
    },
    //END load
    unload: function() {
      Application.Layout.tryShowAuthorizedView();
      return this.view.off();
    }
  });

  //END gotoResetPassword
  Finch.route("/registration", {
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new RegistrationView();
      Finch.observe("game_code", (game_code) => {
        Application.Layout.setGameCode(game_code);
        return this.view.setGameCode(game_code);
      });
      //END observe
      Application.Layout.setUnauthorizedView(this.view);
      return Application.Layout.showRecaptchaBadge();
    },
    //END load
    unload: function() {
      Application.Layout.tryShowAuthorizedView();
      return this.view.off();
    }
  });

  //END gotoRegistration
  Finch.route("[/]manage_account", {
    load: function() {
      this.view = new ManageAccountView();
      return Application.Layout.setAuthorizedView(this.view);
    },
    //END load
    unload: function() {
      return this.view.off();
    }
  });

  //END gotoManageAccount
  Finch.route("[/]change_password", {
    load: function() {
      this.view = new ChangePasswordView();
      return Application.Layout.setAuthorizedView(this.view);
    },
    //END load
    unload: function() {
      return this.view.off();
    }
  });

  //END gotoChangePassword
  Finch.route("[/]survey", {
    setup: function() {
      this.view = new SurveyView();
      return Application.Layout.setAuthorizedView(this.view);
    },
    //END setup
    teardown: function() {
      return this.view.off();
    }
  });

  return _Class;

}).call(this))();

//END gotoSurvey
//END Router

},{"../$models/user.model":82,"./views/change_password.view":101,"./views/check_game_code.view":102,"./views/dashboard.view":103,"./views/forgot_password.view":105,"./views/home.view":106,"./views/login.view":109,"./views/manage_account.view":110,"./views/registration.view":116,"./views/reset_password.view":117,"./views/survey.view":119}],100:[function(require,module,exports){
var TUTORIAL_KEY, Tutorial;

TUTORIAL_KEY = "__SO_COMPLETED_TUTORIAL__";

Tutorial = {};

Tutorial.didComplete = ko.observable(false);

Tutorial.complete = function() {
  var e, message, ref;
  Tutorial.didComplete(true);
  try {
    return localStorage[TUTORIAL_KEY] = true;
  } catch (error) {
    e = error;
    message = (ref = e.message) != null ? ref : "QuotaExceededError";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.captureMessage(message, {
        'level': 'warning'
      });
    }
    return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
  }
};

//END try
//END complete
Tutorial.loadFromCache = function() {
  var didComplete, e, message, ref;
  try {
    didComplete = ["true", true].indexOf(localStorage[TUTORIAL_KEY]) !== -1;
    return Tutorial.didComplete(didComplete);
  } catch (error) {
    e = error;
    message = (ref = e.message) != null ? ref : "QuotaExceededError";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.captureMessage(message, {
        'level': 'warning'
      });
    }
    return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
  }
};

//END try
//END loadFromCache
Tutorial.clear = function() {
  var e, message, ref;
  Tutorial.didComplete(false);
  try {
    return delete localStorage[TUTORIAL_KEY];
  } catch (error) {
    e = error;
    message = (ref = e.message) != null ? ref : "QuotaExceededError";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.captureMessage(message, {
        'level': 'warning'
      });
    }
    return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
  }
};

//END try
//END clear
module.exports = Tutorial;

},{}],101:[function(require,module,exports){
var ChangePasswordView, RPC;

RPC = require("../../rpc");

module.exports = ChangePasswordView = (function() {
  class ChangePasswordView extends Falcon.View {
    //END observables
    initialize() {
      this.alert.decorate('validatable');
      //END alert
      this.old_password.decorate('validatable').subscribe(this.validateOldPassword, this);
      //END old_password
      this.new_password.decorate('validatable').subscribe(this.validateNewPassword, this);
      //END new_password
      return this.retype_password.decorate('validatable').subscribe(this.validateRetypePassword, this);
    }

    //END retype_password
    //END initialize
    validateOldPassword() {
      var old_password;
      old_password = Helpers.trim(this.old_password());
      if (_.isEmpty(old_password)) {
        return this.old_password.setIsValid(false, "Please enter your current password");
      }
      return this.old_password.setIsValid(true);
    }

    //END validateOldPassword
    validateNewPassword() {
      var new_password;
      new_password = Helpers.trim(this.new_password());
      if (_.isEmpty(new_password)) {
        return this.new_password.setIsValid(false, "Please enter a new password");
      }
      return this.new_password.setIsValid(true);
    }

    //END validateNewPassword
    validateRetypePassword() {
      var new_password, retype_password;
      retype_password = Helpers.trim(this.retype_password());
      if (_.isEmpty(retype_password)) {
        return this.retype_password.setIsValid(false, "Please retype your new password");
      }
      new_password = Helpers.trim(this.new_password());
      if (new_password !== retype_password) {
        return this.retype_password.setIsValid(false, "Passwords don't match");
      }
      return this.retype_password.setIsValid(true);
    }

    //END validateRetypePassword
    save() {
      var new_password, old_password;
      if (!Application.is_logged_in()) {
        return this;
      }
      if (this.is_saving()) {
        return this;
      }
      if (!(this.validateOldPassword() && this.validateNewPassword() && this.validateRetypePassword())) {
        return this;
      }
      old_password = ko.unwrap(this.old_password);
      new_password = ko.unwrap(this.new_password);
      this.is_saving(true);
      RPC.promiseChangePassword(old_password, new_password).then((user) => {
        this.alert.setIsValid(true, "Successfully changed password!");
        return this.resetFields();
      }).fail(() => {
        //TODO: Add better error handlin here
        return this.alert.setIsValid(false, "An error occurred while saving account information");
      }).fin(() => {
        return this.is_saving(false);
      }).done();
      //END RPC
      return this;
    }

    //END save
    resetFields() {
      this.old_password("");
      this.old_password.resetValidations();
      this.new_password("");
      this.new_password.resetValidations();
      this.retype_password("");
      this.retype_password.resetValidations();
      return this;
    }

  };

  ChangePasswordView.prototype.endpoint = "#change_password-template";

  ChangePasswordView.prototype.observables = {
    'is_saving': false,
    'alert': "",
    'old_password': "",
    'new_password': "",
    'retype_password': ""
  };

  return ChangePasswordView;

}).call(this);

//END resetFields
//END ChangePasswordView

},{"../../rpc":90}],102:[function(require,module,exports){
var CheckGameCodeView, Entry, RPC, VideoModalView;

Entry = require("../../$models/entry.model");

RPC = require("../../rpc");

VideoModalView = require("./video_modal.view");

module.exports = CheckGameCodeView = (function() {
  class CheckGameCodeView extends Falcon.View {
    //END observables
    initialize() {
      var incoming_code;
      this.alert.decorate('validatable');
      //END alert
      this.game_code.decorate('validatable').subscribe(this.validateGameCode, this);
      //END password
      incoming_code = Application.retrieveIncomingGameCode();
      if (incoming_code != null) {
        this.game_code(incoming_code);
        return this.check();
      }
    }

    //END if
    //END initialize
    validateGameCode() {
      var game_code;
      game_code = this.game_code();
      if (!Entry.isValidCode(game_code)) {
        return this.game_code.setIsValid(false, "Please enter a valid Game Code");
      }
      return this.game_code.setIsValid(true);
    }

    //END validateGameCode
    resetFields() {
      this.alert("");
      this.alert.resetValidations();
      this.game_code("");
      this.game_code.resetValidations();
      return this;
    }

    //END resetFields
    check() {
      var game_code;
      if (!this.validateGameCode()) {
        alert(Language("Invalid game code. Please try again."));
        return this;
      }
      if (this.is_checking()) {
        //END unless
        return this;
      }
      game_code = this.game_code();
      this.is_checking(true);
      RPC.promiseCheckGameCode(game_code).then((entry) => {
        this.resetFields();
        return Router.gotoLogin({game_code});
      }).fail((error) => {
        if ((error != null ? error.human : void 0) != null) {
          alert(Language(error.human));
        }
        Application.flashError(error);
        return this.alert.setIsValid(false, error.human);
      }).fin(() => {
        return this.is_checking(false);
      }).done();
      //END user
      return this;
    }

    //END check
    showNotAuthorized() {
      return this.alert.setIsValid(false, "You're not authorized to login here");
    }

    //END showNotAuthorized
    gotoLogin() {
      return Router.gotoLogin();
    }

    gotoRegistration() {
      return Router.gotoRegistration();
    }

    showVideoModal() {
      return Application.Layout.setModalView(new VideoModalView());
    }

  };

  CheckGameCodeView.prototype.endpoint = '#check_game_code-template';

  CheckGameCodeView.prototype.observables = {
    'alert': "",
    'is_checking': false,
    'submit_is_disabled': function() {
      if (this.is_checking()) {
        return true;
      }
      if (this.game_code().length !== 12) {
        return true;
      }
      return false;
    },
    //END submit_is_disabled
    'game_code': ""
  };

  return CheckGameCodeView;

}).call(this);

//END CheckGameCodeView

},{"../../$models/entry.model":60,"../../rpc":90,"./video_modal.view":120}],103:[function(require,module,exports){
var DashboardView, HomeView, ManageAccountView;

HomeView = require("./home.view");

ManageAccountView = require("./manage_account.view");

module.exports = DashboardView = (function() {
  class DashboardView extends Falcon.View {
    //END observables
    setInternalView(view) {
      if (!Falcon.isView(view)) {
        throw new Error("view must be a Falcon.View");
      }
      this.internal_view(view);
      return this;
    }

    //END setInternalView
    gotoHome() {
      return Router.gotoMain();
    }

    gotoManageAccount() {
      return Router.gotoManageAccount();
    }

    logout() {
      Application.logout();
      return Router.gotoLogin();
    }

  };

  DashboardView.prototype.endpoint = "#dashboard-template";

  DashboardView.prototype.observables = {
    'internal_view': null,
    'home_is_selected': function() {
      return this.internal_view() instanceof HomeView;
    },
    'manage_account_is_selected': function() {
      return this.internal_view() instanceof ManageAccountView;
    }
  };

  return DashboardView;

}).call(this);

//END logout
//END DashboardView

},{"./home.view":106,"./manage_account.view":110}],104:[function(require,module,exports){
var EntryModalView, RPC;

RPC = require("../../rpc");

module.exports = EntryModalView = (function() {
  class EntryModalView extends Falcon.View {
    //END content_class
    //END observables
    show(entry) {
      this.deferred = Q.defer();
      this.entry(entry);
      this.is_visible(true);
      return this.deferred.promise;
    }

    //END show
    showSimple() {
      this.is_visible(true);
      return this.is_simple(true);
    }

    //END
    close() {
      this.is_visible(false);
      if (this.is_simple() === true) {
        Application.Layout.removeNotificationModal(this);
      }
      //END if
      if (this.is_simple() === false) {
        return this.deferred.resolve();
      }
    }

    //END if
    //END close
    shareImageUrl() {
      return `${window.location.origin}/images/${Language("super-speedway-share.png")}`;
    }

    shareFacebook() {
      var params, text, url;
      if (Application.is_on_mobile() && (typeof navigator !== "undefined" && navigator !== null ? navigator.share : void 0)) {
        navigator.share({
          url: this.shareImageUrl()
        });
      } else {
        text = "";
        params = [];
        params.push(`u=${encodeURIComponent(this.shareImageUrl())}`);
        params.push(`text=${encodeURIComponent(text)}`);
        url = `https://www.facebook.com/sharer/sharer.php?${params.join('&')}`;
        window.open(url, "_blank");
      }
    }

    //END shareFacebook
    //END if
    shareTwitter() {
      var params, text, url;
      if (Application.is_on_mobile() && (typeof navigator !== "undefined" && navigator !== null ? navigator.share : void 0)) {
        navigator.share({
          url: this.shareImageUrl()
        });
      } else {
        text = "";
        params = [];
        params.push(`url=${encodeURIComponent(this.shareImageUrl())}`);
        params.push(`text=${encodeURIComponent(text)}`);
        url = `https://twitter.com/share?${params.join('&')}`;
        window.open(url, "_blank");
      }
    }

  };

  EntryModalView.prototype.endpoint = "#entry_modal-template";

  EntryModalView.prototype.defaults = {
    'promise': null
  };

  //END defaults
  EntryModalView.prototype.observables = {
    'is_visible': false,
    'is_simple': false,
    'entry': null,
    'entry_count': function() {
      var entry;
      entry = this.entry();
      if (entry == null) {
        return 0;
      }
      return 1 + (entry.get('bonus_entries') || 0);
    },
    //END entry_count
    'has_multiple_entries': function() {
      return this.entry_count() > 1;
    },
    'content_class': function() {
      if (this.entry_count() === 1) {
        return 'is-one-entry';
      }
      if (this.entry_count() === 2) {
        return 'is-two-entries';
      }
      if (this.entry_count() === 3) {
        return 'is-three-entries';
      }
      if (this.entry_count() === 5) {
        return 'is-five-entries';
      }
      if (this.entry_count() === 10) {
        return 'is-ten-entries';
      }
      if (this.entry_count() === 20) {
        return 'is-twenty-entries';
      }
    }
  };

  return EntryModalView;

}).call(this);

//END shareTwitter
//END EntryModalView
//END if

},{"../../rpc":90}],105:[function(require,module,exports){
var ForgotPasswordView, RPC;

RPC = require("../../rpc");

module.exports = ForgotPasswordView = (function() {
  class ForgotPasswordView extends Falcon.View {
    //END observables
    initialize() {
      this.alert.decorate('validatable');
      //END alert
      return this.email.decorate('validatable').subscribe(this.validateEmail, this);
    }

    //END email
    //END initialize
    resetFields() {
      this.alert("");
      this.alert.resetValidations();
      this.email("");
      this.email.resetValidations();
      return this;
    }

    //END resetFields
    validateEmail() {
      var email;
      email = Helpers.trim(this.email());
      if (_.isEmpty(email)) {
        return this.email.setIsValid(false, "Email must not be empty");
      }
      if (!Helpers.isEmail(email)) {
        return this.email.setIsValid(false, "Email is formatted incorrectly");
      }
      return this.email.setIsValid(true);
    }

    //END validateEmail
    validateRecaptcha(recaptcha_token) {
      if (!recaptcha_token) {
        return this.alert.setIsValid(false, "Please complete the recaptcha");
      }
      return true;
    }

    //END validateRecaptcha
    send(recaptcha_token) {
      var email;
      if (!this.validateRecaptcha(recaptcha_token)) {
        return this;
      }
      if (!this.validateEmail()) {
        return this;
      }
      if (this.is_sending()) {
        return this;
      }
      email = Helpers.trim(this.email());
      this.is_sending(true);
      RPC.promiseForgotPassword(email, recaptcha_token).then(() => {
        this.reset_did_send(true);
        return this.resetFields();
      }).fail((error) => {
        Application.flashError(error);
        return this.alert.setIsValid(false, error.human);
      }).fin(() => {
        return this.is_sending(false);
      }).done();
      //END RPC
      return this;
    }

    //END send
    gotoLogin() {
      return Router.gotoLogin();
    }

  };

  ForgotPasswordView.prototype.endpoint = '#forgot_password-template';

  ForgotPasswordView.prototype.observables = {
    'alert': "",
    'is_sending': false,
    'reset_did_send': false,
    'email': ""
  };

  return ForgotPasswordView;

}).call(this);

//END ForgotPasswordView

},{"../../rpc":90}],106:[function(require,module,exports){
var Contest, Contests, Entry, HomeView, InstantWinnerModalView, MilestoneGoalsMobileModalView, NotificationModalView, RPC, Race, RaceSelection, RaceSelections, RaceView, RaceWinnerModalView, Races, SELECTED_CONTEST, SurveyView, Surveys, User, UserContestStatistic, UserContestStatistics, VideoModalView;

User = require("../../$models/user.model");

Entry = require("../../$models/entry.model");

Contest = require("../../$models/contest.model");

Contests = require("../../$collections/contests.collection");

UserContestStatistic = require("../../$models/user_contest_statistic.model");

UserContestStatistics = require("../../$collections/user_contest_statistics.collection");

Surveys = require("../../$collections/surveys.collection");

Race = require("../../$models/race.model");

Races = require("../../$collections/races.collection");

RaceSelection = require("../../$models/race_selection.model");

RaceSelections = require("../../$collections/race_selections.collection");

RPC = require("../../rpc");

RaceView = require("./race.view");

RaceWinnerModalView = require("./race_winner_modal.view");

NotificationModalView = require("./notification_modal.view");

SurveyView = require("./survey.view");

VideoModalView = require("./video_modal.view");

InstantWinnerModalView = require("./instant_winner_modal.view");

MilestoneGoalsMobileModalView = require("./milestone_goals_mobile_modal.view");

SELECTED_CONTEST = "italia";

module.exports = HomeView = (function() {
  class HomeView extends Falcon.View {
    //END
    //END obseravbles
    initialize() {
      var incoming_code;
      this.alert.decorate('validatable');
      this.game_code.decorate('validatable').subscribe(this.validateGameCode, this);
      //END game_code
      if (Application.is_logged_in()) {
        this.fetchInformation();
      } else {
        this.listenToOnce(Application, 'login', this.fetchInformation);
      }
      //END if
      incoming_code = Application.retrieveIncomingGameCode();
      if (incoming_code != null) {
        this.game_code(incoming_code);
        return this.claimGameCode();
      }
    }

    //END if
    //END initialize
    validateGameCode() {
      var game_code;
      game_code = ko.unwrap(this.game_code);
      if (!Entry.isValidCode(game_code)) {
        return this.game_code.setIsValid(false, "Invalid Game Code");
      }
      return this.game_code.setIsValid(true);
    }

    //END validateGameCode
    fetchInformation() {
      var current_user;
      if (!Application.is_logged_in()) {
        return this;
      }
      if (this.is_loading()) {
        return this;
      }
      this.is_loading(true);
      current_user = Application.current_user();
      Q.all([
        this.contests.promiseFetch({
          parent: current_user
        }),
        this.races.promiseFetch(),
        this.race_selections.promiseFetch({
          parent: current_user
        }),
        this.user_contest_statistics.promiseFetch({
          parent: current_user
        })
      ]).fail((error) => {
        return console.error(error);
      }).fin(() => {
        var entry, modal;
        this.is_loading(false);
        if (!Application.hasClaimedEntry()) {
          return this.tryShowOverlay();
        }
        entry = Application.getClaimedEntry();
        Application.trigger("entry:save", entry);
        this.trigger("entry:save", entry);
        if (entry.get("is_instant_winner") === true) {
          modal = new InstantWinnerModalView();
          Application.Layout.addNotificationModal(modal);
          Application.clearClaimedEntry();
          return this.tryShowOverlay();
        } else {
          return Application.Layout.entry_modal.show(entry).then(() => {
            Application.clearClaimedEntry();
            return this.tryShowOverlay();
          });
        }
      });
      return this;
    }

    //END fetchInformation
    tryShowOverlay() {
      return Q.Promise((resolve, reject) => {
        var current_user, race_selection, race_winner_modal_view;
        if (!Application.is_logged_in()) {
          // return resolve() # TODO: Remove this for the next contest
          return resolve();
        }
        race_selection = this.race_selections.first((race_selection) => {
          if (!race_selection.get('entry_id')) {
            return false;
          }
          if (race_selection.get('did_notify')) {
            return false;
          }
          return true;
        });
        //END first
        console.log(race_selection);
        if (race_selection != null) {
          if (race_selection.notify_milestone != null) {
            Application.trigger("meta:notification", race_selection.notify_milestone());
          }
          //END if
          race_winner_modal_view = new RaceWinnerModalView(race_selection);
          race_winner_modal_view.on("close", () => {
            Application.Layout.clearModalView();
            return this.tryShowOverlay();
          });
          Application.Layout.setModalView(race_winner_modal_view);
          return console.log("END race_selection");
        } else if (this.redeemed_entry_count() > 0 && !this.did_close_survey()) {
          current_user = Application.current_user();
          return this.surveys.promiseFetch({
            parent: current_user
          }).then(() => {
            var survey_view;
            if (!(this.surveys.length() > 0)) {
              return;
            }
            survey_view = new SurveyView(this.surveys.first());
            survey_view.on("entry:create", () => {
              return this.refreshStatistics();
            });
            survey_view.on("close", () => {
              Application.Layout.clearModalView();
              return this.did_close_survey(true);
            });
            return Application.Layout.setModalView(survey_view);
          }).then(resolve, reject);
        } else {
          return resolve();
        }
      });
    }

    //END if
    //END tryShowOverlay
    showRaceModal() {
      var race_view;
      if (!this.has_active_race()) {
        return;
      }
      race_view = new RaceView(this.active_race());
      race_view.on("race_selection:create", (race_selection) => {
        return this.race_selections.push(race_selection);
      });
      race_view.on("close", () => {
        return Application.Layout.clearModalView();
      });
      return Application.Layout.setModalView(race_view);
    }

    //END showRaceModal
    refreshStatistics() {
      var current_user;
      if (!Application.is_logged_in()) {
        return this;
      }
      if (this.is_loading()) {
        return this;
      }
      current_user = Application.current_user();
      this.user_contest_statistics.promiseFetch({
        parent: current_user
      });
      return this;
    }

    //END refreshStatistics
    resetFields() {
      this.game_code("");
      this.game_code.resetValidations();
      return this;
    }

    //END resetFields
    claimGameCode() {
      var game_code;
      if (!Application.is_logged_in()) {
        return this;
      }
      if (this.is_claiming()) {
        return this;
      }
      if (!this.validateGameCode()) {
        alert(Language("Invalid game code. Please try again."));
        return this;
      }
      //END unless
      game_code = this.game_code();
      this.is_claiming(true);
      RPC.promiseClaimGameCode(game_code).then((entry) => {
        var modal;
        this.resetFields();
        Application.trigger("entry:save", entry);
        this.trigger("entry:save", entry);
        if (entry.get("is_instant_winner") === true) {
          modal = new InstantWinnerModalView();
          Application.Layout.addNotificationModal(modal);
          this.tryShowOverlay();
        } else {
          Application.Layout.entry_modal.show(entry).then(() => {
            var statistic;
            statistic = this.getStatisticsFor(this.getContest(SELECTED_CONTEST));
            if (statistic == null) {
              return;
            }
            if (statistic.get('redeemed_entry_count') !== 1) {
              return;
            }
            return this.tryShowOverlay();
          });
        }
        return Q.all([
          this.user_contest_statistics.promiseFetch({
            parent: Application.current_user()
          })
        ]);
      }).fail((error) => {
        if ((error != null ? error.human : void 0) != null) {
          alert(Language(error.human));
        }
        Application.flashError(error);
        return this.game_code.setIsValid(false, error.human);
      }).fin(() => {
        return this.is_claiming(false);
      });
      //END RPC
      return this;
    }

    //END claimGameCode
    getContest(code) {
      return this.contests.first(function(contest) {
        return contest.get('code') === code;
      });
    }

    getStatisticsFor(contest) {
      return this.user_contest_statistics.first(function(statistic) {
        return contest.equals(statistic.get('contest_id'));
      });
    }

    makeFacebookLink() {
      var params, text;
      text = `I've got ${this.redeemed_entry_count()} entries! #SnaponSuperSpeedway`;
      params = [];
      params.push(`u=${encodeURIComponent("https://www.snapon.com/dreamdrive")}`);
      params.push(`text=${encodeURIComponent(text)}`);
      return `https://www.facebook.com/sharer/sharer.php?${params.join('&amp;')}`;
    }

    //END makeFacebookLink
    makeTwitterLink() {
      var params, text;
      text = `I've got ${this.redeemed_entry_count()} entries! #SnaponSuperSpeedway`;
      params = [];
      params.push(`url=${encodeURIComponent("https://www.snapon.com/dreamdrive")}`);
      params.push(`text=${encodeURIComponent(text)}`);
      return `https://twitter.com/share?${params.join('&amp;')}`;
    }

    //END makeTwitterLink
    showVideoModal() {
      return Application.Layout.setModalView(new VideoModalView());
    }

    showMilestoneGoalsMobileModal() {
      var modal;
      modal = new MilestoneGoalsMobileModalView();
      return Application.Layout.addNotificationModal(modal);
    }

  };

  HomeView.prototype.endpoint = "#home-template";

  HomeView.prototype.defaults = {
    'contests': function() {
      return (new Contests()).setFilter('codes', [SELECTED_CONTEST]);
    },
    'surveys': function() {
      return new Surveys();
    },
    'races': function() {
      return new Races();
    },
    'race_selections': function() {
      return new RaceSelections();
    },
    'user_contest_statistics': function() {
      return new UserContestStatistics();
    }
  };

  //END defaults
  HomeView.prototype.observables = {
    'alert': "",
    'is_loading': false,
    'is_claiming': false,
    'name': function() {
      var ref;
      return (ref = Application.current_user()) != null ? ref.get('name') : void 0;
    },
    'game_code': "",
    'game_code_has_focus': false,
    'did_close_survey': false,
    'should_show_add_code_button': function() {
      if (this.game_code_has_focus()) {
        return true;
      }
      if (!_.isEmpty(this.game_code())) {
        return true;
      }
      return false;
    },
    //END should_show_add_code_button
    'add_is_disabled': function() {
      if (!Entry.isValidCode(this.game_code())) {
        return true;
      }
      return false;
    },
    //END add_is_disabled
    'current_user_first_name': function() {
      var ref, ref1;
      if (!Application.is_logged_in()) {
        return "";
      }
      return (ref = (ref1 = Application.current_user()) != null ? ref1.get('first_name') : void 0) != null ? ref : "";
    },
    //END current_user_first_name
    'redeemed_entry_count': function() {
      var contest, statistic;
      contest = this.getContest(SELECTED_CONTEST);
      if (contest == null) {
        return 0;
      }
      statistic = this.getStatisticsFor(contest);
      if (statistic == null) {
        return 0;
      }
      return statistic.get('redeemed_entry_count');
    },
    //END redeemed_entry_count
    'has_redeemed_entry': function() {
      return this.redeemed_entry_count() > 0;
    },
    'end_date': function() {
      var contest;
      contest = this.getContest(SELECTED_CONTEST);
      return contest != null ? contest.get('end_date') : void 0;
    },
    //END end_date
    'active_race': function() {
      var now_moment, races;
      now_moment = moment();
      races = this.races.all();
      races = races.filter((race) => {
        if (now_moment.isBefore(race.get('start_date'))) {
          return false;
        }
        if (now_moment.isAfter(race.get('end_date'))) {
          return false;
        }
        return true;
      });
      //END filter
      races = races.sort((a, b) => {
        var a_moment, b_moment;
        a_moment = moment(a.get('start_date'));
        b_moment = moment(b.get('start_date'));
        if (a_moment.isBefore(b_moment)) {
          return -1;
        }
        if (a_moment.isAfter(b_moment)) {
          return 1;
        }
        return 0;
      });
      //END sort
      return races[0];
    },
    //END active_race
    'has_active_race': function() {
      return this.active_race() instanceof Race;
    },
    'active_race_selection': function() {
      var active_race;
      if (!this.has_active_race()) {
        return null;
      }
      active_race = this.active_race();
      return this.race_selections.first((race_selection) => {
        return race_selection.get('race_id') === active_race.get('id');
      });
    },
    //END first
    //END active_race_selection
    'active_race_selection_label': function() {
      var ref, ref1;
      return (ref = this.active_race_selection()) != null ? (ref1 = ref.get('race_option')) != null ? ref1.get('label') : void 0 : void 0;
    },
    'has_active_race_selection': function() {
      return this.active_race_selection() instanceof RaceSelection;
    },
    'upcoming_race': function() {
      var now_moment, races;
      if (this.has_active_race()) {
        return null;
      }
      now_moment = moment();
      races = this.races.all();
      races = races.filter((race) => {
        return now_moment.isBefore(race.get('start_date'));
      });
      //END filter
      races = races.sort((a, b) => {
        var a_moment, b_moment;
        a_moment = moment(a.get('start_date'));
        b_moment = moment(b.get('start_date'));
        if (a_moment.isBefore(b_moment)) {
          return -1;
        }
        if (a_moment.isAfter(b_moment)) {
          return 1;
        }
        return 0;
      });
      //END sort
      return races[0];
    },
    //END upcoming_race
    'has_upcoming_race': function() {
      return this.upcoming_race() instanceof Race;
    },
    'upcoming_race_week_of': function() {
      return moment(this.upcoming_race().get('start_date')).startOf('week').format("MM/DD");
    },
    'completed_tour': function() {
      var entry_count;
      entry_count = this.redeemed_entry_count();
      return entry_count >= 60;
    },
    'youarehere_opacity': function() {
      var entry_count;
      entry_count = this.redeemed_entry_count();
      if (entry_count <= 0) {
        return 0;
      }
      if (entry_count >= 60) {
        return 0;
      }
      return 1;
    },
    //END
    'youarehere_padding': function() {
      var entry_count;
      entry_count = this.redeemed_entry_count();
      if (entry_count >= 40) {
        return '29.9vw';
      }
      if (entry_count >= 25) {
        return '24.5vw';
      }
      if (entry_count >= 15) {
        return '19.5vw';
      }
      if (entry_count >= 10) {
        return '14.5vw';
      }
      if (entry_count >= 7) {
        return '9.5vw';
      }
      if (entry_count >= 4) {
        return '4.5vw';
      }
      return '0vw';
    },
    //END
    'youarehere_img_url': function() {
      var entry_count;
      entry_count = this.redeemed_entry_count();
      if (entry_count >= 60) {
        return '/images/tour-desktop-08.png';
      }
      if (entry_count >= 40) {
        return '/images/tour-desktop-07.png';
      }
      if (entry_count >= 25) {
        return '/images/tour-desktop-06.png';
      }
      if (entry_count >= 15) {
        return '/images/tour-desktop-05.png';
      }
      if (entry_count >= 10) {
        return '/images/tour-desktop-04.png';
      }
      if (entry_count >= 7) {
        return '/images/tour-desktop-03.png';
      }
      if (entry_count >= 4) {
        return '/images/tour-desktop-02.png';
      }
      return '/images/tour-desktop-01.png';
    },
    //END
    'milestone_next_goal': function() {
      var entry_count;
      entry_count = this.redeemed_entry_count();
      if (entry_count >= 60) {
        return '';
      }
      if (entry_count >= 40) {
        return entry_count + " / 60";
      }
      if (entry_count >= 25) {
        return entry_count + " / 40";
      }
      if (entry_count >= 15) {
        return entry_count + " / 25";
      }
      if (entry_count >= 10) {
        return entry_count + " / 15";
      }
      if (entry_count >= 7) {
        return entry_count + " / 10";
      }
      if (entry_count >= 4) {
        return entry_count + " / 7";
      }
      if (entry_count >= 1) {
        return entry_count + " / 4";
      }
      return '';
    },
    //END
    'mobile_milestone_next_goal': function() {
      var entry_count;
      entry_count = this.redeemed_entry_count();
      if (entry_count >= 60) {
        return '';
      }
      if (entry_count >= 40) {
        return 60 - entry_count;
      }
      if (entry_count >= 25) {
        return 40 - entry_count;
      }
      if (entry_count >= 15) {
        return 25 - entry_count;
      }
      if (entry_count >= 10) {
        return 15 - entry_count;
      }
      if (entry_count >= 7) {
        return 10 - entry_count;
      }
      if (entry_count >= 4) {
        return 7 - entry_count;
      }
      if (entry_count >= 1) {
        return 4 - entry_count;
      }
      return '';
    },
    //END
    'mobile_milestone_icon_img_url': function() {
      var entry_count;
      entry_count = this.redeemed_entry_count();
      if (entry_count >= 60) {
        return '/images/tour-iconcheck.png';
      }
      if (entry_count >= 40) {
        return '/images/tour-icon5.png';
      }
      if (entry_count >= 25) {
        return '/images/tour-icon3.png';
      }
      if (entry_count >= 15) {
        return '/images/tour-icon3.png';
      }
      if (entry_count >= 10) {
        return '/images/tour-icon2.png';
      }
      if (entry_count >= 7) {
        return '/images/tour-icon2.png';
      }
      if (entry_count >= 4) {
        return '/images/tour-icon1.png';
      }
      return '/images/tour-icon1.png';
    },
    //END
    'mobile_milestone_city_img_url': function() {
      var entry_count;
      entry_count = this.redeemed_entry_count();
      if (entry_count >= 60) {
        return '/images/tour-city7.png';
      }
      if (entry_count >= 40) {
        return '/images/tour-city7.png';
      }
      if (entry_count >= 25) {
        return '/images/tour-city6.png';
      }
      if (entry_count >= 15) {
        return '/images/tour-city5.png';
      }
      if (entry_count >= 10) {
        return '/images/tour-city4.png';
      }
      if (entry_count >= 7) {
        return '/images/tour-city3.png';
      }
      if (entry_count >= 4) {
        return '/images/tour-city2.png';
      }
      return '/images/tour-city1.png';
    }
  };

  return HomeView;

}).call(this);

//END
//END HomeView

},{"../../$collections/contests.collection":27,"../../$collections/race_selections.collection":39,"../../$collections/races.collection":40,"../../$collections/surveys.collection":46,"../../$collections/user_contest_statistics.collection":47,"../../$models/contest.model":57,"../../$models/entry.model":60,"../../$models/race.model":72,"../../$models/race_selection.model":74,"../../$models/user.model":82,"../../$models/user_contest_statistic.model":83,"../../rpc":90,"./instant_winner_modal.view":107,"./milestone_goals_mobile_modal.view":111,"./notification_modal.view":113,"./race.view":114,"./race_winner_modal.view":115,"./survey.view":119,"./video_modal.view":120}],107:[function(require,module,exports){
var InstantWinnerModalView;

module.exports = InstantWinnerModalView = (function() {
  class InstantWinnerModalView extends Falcon.View {
    //END observables'
    show() {
      return this.is_visible(true);
    }

    //END show
    close() {
      this.is_visible(false);
      return Application.Layout.removeNotificationModal(this);
    }

  };

  InstantWinnerModalView.prototype.endpoint = "#instant_winner_modal-template";

  InstantWinnerModalView.prototype.defaults = {
    'promise': null
  };

  //END defaults
  InstantWinnerModalView.prototype.observables = {
    'is_visible': false
  };

  return InstantWinnerModalView;

}).call(this);

//END close
//END NotificationModalView

},{}],108:[function(require,module,exports){
var ChangePasswordView, CheckGameCodeView, EntryModalView, ForgotPasswordView, HomeView, LayoutView, LoginView, ManageAccountView, MilestoneModalView, NotificationModalView, RegistrationView, ResetPasswordView, RulesView;

ChangePasswordView = require("./change_password.view");

CheckGameCodeView = require("./check_game_code.view");

EntryModalView = require("./entry_modal.view");

ForgotPasswordView = require("./forgot_password.view");

ResetPasswordView = require("./reset_password.view");

HomeView = require("./home.view");

LoginView = require("./login.view");

ManageAccountView = require("./manage_account.view");

RegistrationView = require("./registration.view");

RulesView = require("./rules.view");

NotificationModalView = require("./notification_modal.view");

MilestoneModalView = require("./milestone_modal.view");

module.exports = LayoutView = (function() {
  class LayoutView extends Falcon.View {
    //END observables
    initialize() {
      var computed;
      computed = ko.computed(() => {
        if (!Language.hasSelectedLanguage() && IPInfo.isLoaded()) {
          // Check if they're in canada
          if (IPInfo.isInCanada()) {
            this.showSelectLanguage();
          } else {
            this.selectEnUsLanguage();
          }
          //END if
          return computed != null ? computed.dispose() : void 0;
        }
      });
      //END if
      //END computed
      return this.listenTo(Application, "meta:notification", this.onMetaNotification);
    }

    //END initialize
    setAuthorizedView(view) {
      if (!Falcon.isView(view)) {
        throw new Error("view must be an instanceof a Falcon.View");
      }
      //END unless
      this.hideRecaptchaBadge();
      this.authorized_view(view);
      return view;
    }

    //END setAuthorizedView
    clearAuthorizedView() {
      return this.authorized_view(null);
    }

    tryShowAuthorizedView() {
      this.force_show_unauthorized_view(false);
      return this;
    }

    //END tryShowAuthorizedView
    setUnauthorizedView(view) {
      if (!Falcon.isView(view)) {
        throw new Error("view must be an instanceof a Falcon.View");
      }
      //END unless
      this.hideRecaptchaBadge();
      this.unauthorized_view(view);
      return view;
    }

    //END setAuthorizedView
    clearUnauthorizedView() {
      this.unauthorized_view(null);
      return this;
    }

    //END clearUnauthorizedView
    forceShowUnauthorizedView() {
      this.force_show_unauthorized_view(true);
      return this;
    }

    //END forceShowUnauthorizedView
    setModalView(view) {
      if (!Falcon.isView(view)) {
        throw new Error("view must be an instanceof Falcon.View");
      }
      this.modal_view(view);
      return view;
    }

    //END setModalView
    clearModalView() {
      this.modal_view(null);
      return this;
    }

    //END clearModalView
    showRules() {
      return this.rules_view(new RulesView());
    }

    hideRules() {
      return this.rules_view(null);
    }

    gotoLogin() {
      var params;
      this.hideMenu();
      this.hideSelectLanguage();
      params = {};
      if (this.has_game_code()) {
        params['game_code'] = this.game_code();
      }
      return Router.gotoLogin(params);
    }

    //END gotoLogin
    gotoRegistration() {
      var params;
      this.hideMenu();
      this.hideSelectLanguage();
      params = {};
      if (this.has_game_code()) {
        params['game_code'] = this.game_code();
      }
      return Router.gotoRegistration(params);
    }

    //END gotoRegistration
    gotoMain() {
      this.hideMenu();
      this.hideSelectLanguage();
      return Router.gotoMain();
    }

    //END gotoMain
    gotoManageAccount() {
      this.hideMenu();
      this.hideSelectLanguage();
      return Router.gotoManageAccount();
    }

    //END gotoManageAccount
    gotoChangePassword() {
      this.hideMenu();
      this.hideSelectLanguage();
      return Router.gotoChangePassword();
    }

    //END gotoChangePassword
    logout() {
      this.hideMenu();
      this.hideSelectLanguage();
      Application.logout();
      return Router.gotoLogin();
    }

    //END logout
    toggleMenu() {
      return this.menu_is_visible(!this.menu_is_visible());
    }

    //END toggleMenu
    showMenu() {
      return this.menu_is_visible(true);
    }

    //END showMenu
    hideMenu() {
      return this.menu_is_visible(false);
    }

    //END hideMenu
    toggleSelectLanguage() {
      this.select_language_is_visible(!this.select_language_is_visible());
      return this.hideMenu();
    }

    //END toggleSelectLanguage
    showSelectLanguage() {
      this.select_language_is_visible(true);
      return this.hideMenu();
    }

    //END showSelectlanguage
    hideSelectLanguage() {
      return this.select_language_is_visible(false);
    }

    //END hideSelectLanguage
    selectEnUsLanguage() {
      Language.selectCode("us/en");
      return this.hideSelectLanguage();
    }

    //END selectEnUsLanguage
    selectEnCaLanguage() {
      Language.selectCode("ca/en");
      return this.hideSelectLanguage();
    }

    //END selectEnCaLanguage
    selectFrCaLanguage() {
      Language.selectCode("ca/fr");
      return this.hideSelectLanguage();
    }

    //END selectFrCaLanguage
    toggleLanguage() {
      if (Language.selectedLanguageCode() === "us/en") {
        return Language.selectCode("ca/fr");
      } else {
        return Language.selectCode("us/en");
      }
    }

    //END if
    //END toggleLanguage
    frCaIsSelected() {
      return Language.selectedLanguageCode() === "ca/fr";
    }

    //END selectFrCaLanguage
    setGameCode(game_code) {
      this.game_code(game_code);
      return this;
    }

    //END setGameCode
    showRecaptchaBadge() {
      if (!document.body.classList.contains('recaptcha-visible')) {
        document.body.classList.add('recaptcha-visible');
      }
      //END unless
      return this;
    }

    //END showRecaptchaBadge
    hideRecaptchaBadge() {
      if (document.body.classList.contains('recaptcha-visible')) {
        document.body.classList.remove('recaptcha-visible');
      }
      //END if
      return this;
    }

    //END hideRecaptchaBadge
    onMetaNotification(data) {
      var modal;
      if (data.includes("milestone")) {
        modal = new MilestoneModalView();
        modal.setMilestone(data);
        Application.Layout.addNotificationModal(modal);
      }
      if (data === "completed_all_surveys") {
        modal = new EntryModalView();
        modal.showSimple();
        return Application.Layout.addNotificationModal(modal);
      }
    }

    //END onMetaNotification
    addNotificationModal(view) {
      this.notification_modals.push(view);
      view.show;
      return view;
    }

    //END addNotificationModal
    removeNotificationModal(view) {
      this.notification_modals.remove(view);
      return this;
    }

  };

  LayoutView.prototype.endpoint = '#layout-template';

  LayoutView.prototype.defaults = {
    'entry_modal': function() {
      return new EntryModalView();
    }
  };

  //END defaults
  LayoutView.prototype.observables = {
    'is_displayed': false,
    'game_code': null,
    'has_game_code': function() {
      return this.game_code() != null;
    },
    'is_on_light_background': function() {
      if (this.should_show_authorized_view()) {
        if (this.authorized_view() instanceof ManageAccountView) {
          return true;
        }
        if (this.authorized_view() instanceof ChangePasswordView) {
          return true;
        }
      } else {
        if (this.unauthorized_view() instanceof LoginView) {
          return true;
        }
        if (this.unauthorized_view() instanceof RegistrationView) {
          return true;
        }
        if (this.unauthorized_view() instanceof ForgotPasswordView) {
          return true;
        }
        if (this.unauthorized_view() instanceof ResetPasswordView) {
          return true;
        }
      }
      //END if
      return false;
    },
    //END is_on_light_background
    'background_class': function() {
      if (this.should_show_authorized_view()) {
        if (this.authorized_view() instanceof HomeView) {
          return 'with-plain-background';
        }
      } else {
        if (this.unauthorized_view() instanceof CheckGameCodeView) {
          return 'with-plain-background';
        }
      }
      //END if
      return null;
    },
    //END has_plain_background
    'should_show_loader': function() {
      return ko.unwrap(Application.is_checking_session);
    },
    //END should_show_loader
    'should_render_views': function() {
      return !ko.unwrap(Application.is_checking_session);
    },
    //END should_render_views
    'force_show_unauthorized_view': false,
    'authorized_view': null,
    'should_show_authorized_view': function() {
      if (Application.is_checking_session()) {
        return false;
      }
      if (!Application.is_logged_in()) {
        return false;
      }
      return !this.force_show_unauthorized_view();
    },
    //END should_show_authorized_view
    'unauthorized_view': null,
    'should_show_unauthorized_view': function() {
      if (Application.is_checking_session()) {
        return false;
      }
      return !this.should_show_authorized_view();
    },
    //END should_show_unauthorized_view
    'modal_view': null,
    'should_show_modal_view': function() {
      if (Application.is_checking_session()) {
        return false;
      }
      return Falcon.isView(this.modal_view());
    },
    //END should_show_modal_view
    'rules_view': null,
    'should_show_rules_view': function() {
      if (Application.is_checking_session()) {
        return false;
      }
      return Falcon.isView(this.rules_view());
    },
    //END should_show_rules_view
    'current_user_first_name': function() {
      var current_user, ref;
      if (!Application.is_logged_in()) {
        return "";
      }
      current_user = Application.current_user();
      return (ref = current_user != null ? current_user.get('first_name') : void 0) != null ? ref : "";
    },
    //END current_user_first_name
    'select_language_is_visible': false,
    'menu_is_visible': false,
    'is_showing_manage_account': function() {
      return this.authorized_view() instanceof ManageAccountView;
    },
    'notification_modals': []
  };

  return LayoutView;

}).call(this);

//END removeNotificationModal
//END LayoutView

},{"./change_password.view":101,"./check_game_code.view":102,"./entry_modal.view":104,"./forgot_password.view":105,"./home.view":106,"./login.view":109,"./manage_account.view":110,"./milestone_modal.view":112,"./notification_modal.view":113,"./registration.view":116,"./reset_password.view":117,"./rules.view":118}],109:[function(require,module,exports){
var Entry, LoginView, RPC, Session;

Session = require("../../$models/session.model");

Entry = require("../../$models/entry.model");

RPC = require("../../rpc");

module.exports = LoginView = (function() {
  class LoginView extends Falcon.View {
    //END observables
    initialize() {
      this.alert.decorate('validatable');
      //END alert
      this.email.decorate('validatable').subscribe(this.validateEmail, this);
      //END email
      return this.password.decorate('validatable').subscribe(this.validatePassword, this);
    }

    //END password
    //END initialize
    validateEmail() {
      var email;
      email = Helpers.trim(this.email());
      if (_.isEmpty(email)) {
        return this.email.setIsValid(false, "Email must not be empty");
      }
      if (!Helpers.isEmail(email)) {
        return this.email.setIsValid(false, "Email is formatted incorrectly");
      }
      return this.email.setIsValid(true);
    }

    //END validateEmail
    validatePassword() {
      var password;
      password = this.password();
      if (!Helpers.isPassword(password)) {
        return this.password.setIsValid(false, "Password must be at least 6 characters long and must not contain white space");
      }
      return this.password.setIsValid(true);
    }

    //END validatePassword
    validateRecaptcha(recpactha_token) {
      if (!recpactha_token) {
        return this.alert.setIsValid(false, "Please complete the recaptcha");
      }
      return true;
    }

    //END validateRecaptcha
    resetFields() {
      this.alert("");
      this.alert.resetValidations();
      this.email("");
      this.email.resetValidations();
      this.password("");
      this.password.resetValidations();
      return this;
    }

    //END resetFields
    login(recaptcha_token) {
      var email, email_is_valid, password, password_is_valid, recaptcha_token_is_valid;
      email_is_valid = this.validateEmail();
      password_is_valid = this.validatePassword();
      recaptcha_token_is_valid = this.validateRecaptcha(recaptcha_token);
      if (!(email_is_valid && password_is_valid && recaptcha_token_is_valid)) {
        return this;
      }
      if (this.is_logging_in()) {
        return this;
      }
      email = Helpers.trim(this.email());
      password = this.password();
      this.is_logging_in(true);
      new Session({email, password, recaptcha_token}).promiseCreate({
        attributes: ['email', 'password', 'recaptcha_token']
      }).then((session) => {
        Application.login(session);
        this.trigger('session:create', session);
        return Application.trigger('session:create', session);
      }).then(() => {
        if (!this.has_game_code()) {
          return null;
        }
        return RPC.promiseClaimGameCode(this.game_code()).then(function(entry) {
          return Application.setClaimedEntry(entry);
        });
      }).then((entry) => {
        this.resetFields();
        return Router.gotoMain();
      }).fail((error) => {
        if (typeof console !== "undefined" && console !== null) {
          console.log(error);
        }
        if (typeof console !== "undefined" && console !== null) {
          console.log(JSON.stringify(error));
        }
        Application.flashError(error);
        return this.alert.setIsValid(false, error.human);
      }).fin(() => {
        return this.is_logging_in(false);
      }).done();
      //END session
      return this;
    }

    //END login
    setGameCode(game_code) {
      this.game_code(game_code);
      return this;
    }

    //END setGameCode
    showNotAuthorized() {
      return this.alert.setIsValid(false, "You're not authorized to login here");
    }

    //END showNotAuthorized
    gotoRegistration() {
      var params;
      params = {};
      if (this.has_game_code()) {
        params['game_code'] = this.game_code();
      }
      return Router.gotoRegistration(params);
    }

    //END gotoRegistration
    gotoForgotPassword() {
      return Router.gotoForgotPassword();
    }

  };

  LoginView.prototype.endpoint = '#login-template';

  LoginView.prototype.observables = {
    'alert': "",
    'is_logging_in': false,
    'email': "",
    'password': "",
    'game_code': "",
    'has_game_code': function() {
      return Entry.isValidCode(this.game_code());
    }
  };

  return LoginView;

}).call(this);

//END LoginView

},{"../../$models/entry.model":60,"../../$models/session.model":78,"../../rpc":90}],110:[function(require,module,exports){
var ManageAccountView, STATES;

STATES = require("../../$constants/states.constants");

module.exports = ManageAccountView = (function() {
  class ManageAccountView extends Falcon.View {
    //END if
    //END read
    //END formatted_phone_number
    //END observables
    initialize() {
      this.alert.decorate('validatable');
      //END alert
      this.name.decorate('validatable').subscribe(this.validateName, this);
      //END name
      this.email.decorate('validatable').subscribe(this.validateEmail, this);
      //END email
      this.phone_number.decorate('validatable').subscribe(this.validatePhoneNumber, this);
      //END phone_number
      if (Application.is_logged_in()) {
        return this.populateData();
      } else {
        return this.listenToOnce(Application, 'login', this.populateData);
      }
    }

    //END if
    //END initialize
    validateName() {
      var name;
      name = Helpers.trim(this.name());
      if (_.isEmpty(name)) {
        return this.name.setIsValid(false, "Name must not be empty");
      }
      return this.name.setIsValid(true);
    }

    //END validateName
    validateEmail() {
      var email;
      email = Helpers.trim(this.email());
      if (_.isEmpty(email)) {
        return this.email.setIsValid(false, "Email must not be empty");
      }
      if (!Helpers.isEmail(email)) {
        return this.email.setIsValid(false, "Email is formatted incorrectly");
      }
      return this.email.setIsValid(true);
    }

    //END validateEmail
    validatePhoneNumber() {
      var phone_number;
      phone_number = this.phone_number() || "";
      if (phone_number.length !== 10 && !/[0-9]{10}/.test(phone_number)) {
        return this.phone_number.setIsValid(false, "Please enter a valid phone number");
      }
      return this.phone_number.setIsValid(true);
    }

    //END validatePhoneNumber
    populateData() {
      var current_user;
      if (!Application.is_logged_in()) {
        return this;
      }
      current_user = Application.current_user();
      this.name(current_user.get("name"));
      this.email(current_user.get("email"));
      this.address_1(current_user.get('address_1'));
      this.address_2(current_user.get('address_2'));
      this.city(current_user.get('city'));
      this.state(current_user.get('state'));
      this.zip_code(current_user.get('zip_code'));
      this.formatted_phone_number(current_user.get('phone_number'));
      return this.is_subscribed_to_newsletter(current_user.get('is_subscribed_to_newsletter'));
    }

    //END populateData
    save() {
      if (!Application.is_logged_in()) {
        return this;
      }
      if (this.is_saving()) {
        return this;
      }
      if (!(this.validateName() && this.validateEmail() && this.validatePhoneNumber())) {
        return this;
      }
      this.is_saving(true);
      Application.current_user().clone(['id']).set({
        name: this.name(),
        email: this.email(),
        address_1: this.address_1(),
        address_2: this.address_2(),
        city: this.city(),
        state: this.state(),
        zip_code: this.zip_code(),
        phone_number: this.phone_number(),
        is_subscribed_to_newsletter: this.is_subscribed_to_newsletter()
      }).promiseSave({
        parent: null,
        attributes: ['name', 'email', 'address_1', 'address_2', 'city', 'state', 'zip_code', 'phone_number', 'is_subscribed_to_newsletter']
      }).then((user) => {
        this.alert.setIsValid(true, "Successfully saved account information!");
        return Application.current_user().set({
          name: user.get('name'),
          email: user.get('email'),
          ddress_1: user.get('address_1'),
          address_2: user.get('address_2'),
          city: user.get('city'),
          state: user.get('state'),
          zip_code: user.get('zip_code'),
          phone_number: user.get('phone_number')
        });
      }).fail(() => {
        //TODO: Add better error handlin here
        return this.alert.setIsValid(false, "An error occurred while saving account information");
      }).fin(() => {
        return this.is_saving(false);
      }).done();
      //END application
      return this;
    }

  };

  ManageAccountView.prototype.endpoint = "#manage_account-template";

  ManageAccountView.prototype.STATES = STATES;

  ManageAccountView.prototype.observables = {
    'is_saving': false,
    'alert': "",
    'name': null,
    'email': null,
    'address_1': null,
    'address_2': null,
    'city': null,
    'state': null,
    'zip_code': null,
    'phone_number': null,
    'is_subscribed_to_newsletter': null,
    'formatted_phone_number': {
      write: function(value) {
        value = (value || "").toString().replace(/[^0-9]*/gi, "");
        return this.phone_number(value);
      },
      //END write
      read: function() {
        var first_piece, phone, second_piece, third_piece;
        phone = (this.phone_number() || "").toString().replace(/[^0-9]*/gi, "");
        first_piece = phone.slice(0, 3);
        second_piece = phone.slice(3, 6);
        third_piece = phone.slice(6, 10);
        if (third_piece.length > 0) {
          return `(${first_piece}) ${second_piece}-${third_piece}`;
        } else if (second_piece.length > 0) {
          return `${first_piece}-${second_piece}`;
        } else {
          return `${first_piece}`;
        }
      }
    }
  };

  return ManageAccountView;

}).call(this);

//END save
//END ManageAccountView

},{"../../$constants/states.constants":50}],111:[function(require,module,exports){
var Contest, Contests, MilestoneGoalsMobileModalView, SELECTED_CONTEST, UserContestStatistic, UserContestStatistics;

Contest = require("../../$models/contest.model");

Contests = require("../../$collections/contests.collection");

UserContestStatistic = require("../../$models/user_contest_statistic.model");

UserContestStatistics = require("../../$collections/user_contest_statistics.collection");

SELECTED_CONTEST = "italia";

module.exports = MilestoneGoalsMobileModalView = (function() {
  class MilestoneGoalsMobileModalView extends Falcon.View {
    //END

      //END observables'
    initialize() {
      if (Application.is_logged_in()) {
        return this.fetchInformation();
      } else {
        return this.listenToOnce(Application, 'login', this.fetchInformation);
      }
    }

    //END if
    //END initialize
    fetchInformation() {
      var current_user;
      if (!Application.is_logged_in()) {
        return this;
      }
      if (this.is_loading()) {
        return this;
      }
      this.is_loading(true);
      current_user = Application.current_user();
      Q.all([
        this.contests.promiseFetch({
          parent: current_user
        }),
        this.user_contest_statistics.promiseFetch({
          parent: current_user
        })
      ]).fail((error) => {
        return console.error(error);
      }).fin(() => {
        return this.is_loading(false);
      });
      return this;
    }

    //END fetchInformation
    getContest(code) {
      return this.contests.first(function(contest) {
        return contest.get('code') === code;
      });
    }

    getStatisticsFor(contest) {
      return this.user_contest_statistics.first(function(statistic) {
        return contest.equals(statistic.get('contest_id'));
      });
    }

    show() {
      return this.is_visible(true);
    }

    //END show
    close() {
      this.is_visible(false);
      return Application.Layout.removeNotificationModal(this);
    }

  };

  MilestoneGoalsMobileModalView.prototype.endpoint = "#milestone_goals_mobile_modal-template";

  MilestoneGoalsMobileModalView.prototype.defaults = {
    'contests': function() {
      return (new Contests()).setFilter('codes', [SELECTED_CONTEST]);
    },
    'user_contest_statistics': function() {
      return new UserContestStatistics();
    }
  };

  //END defaults
  MilestoneGoalsMobileModalView.prototype.observables = {
    'redeemed_entry_count': function() {
      var contest, statistic;
      contest = this.getContest(SELECTED_CONTEST);
      if (contest == null) {
        return 0;
      }
      statistic = this.getStatisticsFor(contest);
      if (statistic == null) {
        return 0;
      }
      return statistic.get('redeemed_entry_count');
    },
    //END redeemed_entry_count
    'is_visible': false,
    'is_loading': false,
    'youarehere_opacity': function() {
      var entry_count;
      entry_count = this.redeemed_entry_count();
      if (entry_count <= 0) {
        return 0;
      }
      if (entry_count >= 60) {
        return 0;
      }
      return 1;
    },
    //END
    'youarehere_padding': function() {
      var entry_count;
      entry_count = this.redeemed_entry_count();
      if (entry_count >= 40) {
        return '95vw';
      }
      if (entry_count >= 25) {
        return '80vw';
      }
      if (entry_count >= 15) {
        return '64.5vw';
      }
      if (entry_count >= 10) {
        return '49vw';
      }
      if (entry_count >= 7) {
        return '33.8vw';
      }
      if (entry_count >= 4) {
        return '18.5vw';
      }
      return '2vw';
    },
    //END
    'youarehere_img_url': function() {
      var entry_count;
      entry_count = this.redeemed_entry_count();
      if (entry_count >= 60) {
        return '/images/tour-mobile-08.jpg';
      }
      if (entry_count >= 40) {
        return '/images/tour-mobile-07.jpg';
      }
      if (entry_count >= 25) {
        return '/images/tour-mobile-06.jpg';
      }
      if (entry_count >= 15) {
        return '/images/tour-mobile-05.jpg';
      }
      if (entry_count >= 10) {
        return '/images/tour-mobile-04.jpg';
      }
      if (entry_count >= 7) {
        return '/images/tour-mobile-03.jpg';
      }
      if (entry_count >= 4) {
        return '/images/tour-mobile-02.jpg';
      }
      return '/images/tour-mobile-01.jpg';
    },
    //END
    'milestone_next_goal': function() {
      var entry_count;
      entry_count = this.redeemed_entry_count();
      if (entry_count >= 60) {
        return '';
      }
      if (entry_count >= 40) {
        return entry_count + " / 60";
      }
      if (entry_count >= 25) {
        return entry_count + " / 40";
      }
      if (entry_count >= 15) {
        return entry_count + " / 25";
      }
      if (entry_count >= 10) {
        return entry_count + " / 15";
      }
      if (entry_count >= 7) {
        return entry_count + " / 10";
      }
      if (entry_count >= 4) {
        return entry_count + " / 7";
      }
      if (entry_count >= 1) {
        return entry_count + " / 4";
      }
      return '';
    }
  };

  return MilestoneGoalsMobileModalView;

}).call(this);

//END close
//END NotificationModalView

},{"../../$collections/contests.collection":27,"../../$collections/user_contest_statistics.collection":47,"../../$models/contest.model":57,"../../$models/user_contest_statistic.model":83}],112:[function(require,module,exports){
var MilestoneModalView;

module.exports = MilestoneModalView = (function() {
  class MilestoneModalView extends Falcon.View {
    //END content_class
    //END observables'
    setMilestone(data) {
      console.log(data);
      return this.milestone(data);
    }

    //END setMilestone
    show() {
      return this.is_visible(true);
    }

    //END show
    close() {
      this.is_visible(false);
      return Application.Layout.removeNotificationModal(this);
    }

  };

  MilestoneModalView.prototype.endpoint = "#milestone_modal-template";

  MilestoneModalView.prototype.defaults = {
    'promise': null
  };

  //END defaults
  MilestoneModalView.prototype.observables = {
    'is_visible': false,
    'milestone': null,
    'milestone_name': function() {
      var milestone;
      milestone = this.mileston();
      if (milestone == null) {
        return '';
      }
      return milestone;
    },
    'content_class': function() {
      if (this.milestone() === 'reached_milestone_4') {
        return 'is-milestone-one';
      }
      if (this.milestone() === 'reached_milestone_7') {
        return 'is-milestone-two';
      }
      if (this.milestone() === 'reached_milestone_10') {
        return 'is-milestone-three';
      }
      if (this.milestone() === 'reached_milestone_15') {
        return 'is-milestone-four';
      }
      if (this.milestone() === 'reached_milestone_25') {
        return 'is-milestone-five';
      }
      if (this.milestone() === 'reached_milestone_40') {
        return 'is-milestone-six';
      }
      if (this.milestone() === 'reached_milestone_60') {
        return 'is-milestone-seven';
      }
    }
  };

  return MilestoneModalView;

}).call(this);

//END close
//END NotificationModalView

},{}],113:[function(require,module,exports){
var NotificationModalView;

module.exports = NotificationModalView = (function() {
  class NotificationModalView extends Falcon.View {
    //END observables'
    setContent(content) {
      return this.content(content);
    }

    //END setContent
    show() {
      return this.is_visible(true);
    }

    //END show
    close() {
      this.is_visible(false);
      return Application.Layout.removeNotificationModal(this);
    }

  };

  NotificationModalView.prototype.endpoint = "#notification_modal-template";

  NotificationModalView.prototype.defaults = {
    'promise': null
  };

  //END defaults
  NotificationModalView.prototype.observables = {
    'is_visible': false,
    'content_class': 'A',
    'content': ''
  };

  return NotificationModalView;

}).call(this);

//END close
//END NotificationModalView

},{}],114:[function(require,module,exports){
var Question, Race, RaceOption, RaceOptions, RaceSelection, RaceSelections, RaceView, Races;

Question = require("../../$models/question.model");

Race = require("../../$models/race.model");

RaceOption = require("../../$models/race_option.model");

RaceOptions = require("../../$collections/race_options.collection");

RaceSelection = require("../../$models/race_selection.model");

RaceSelections = require("../../$collections/race_selections.collection");

Races = require("../../$collections/races.collection");

module.exports = RaceView = (function() {
  class RaceView extends Falcon.View {
    //END sorted_race_options
    //END observables
    initialize() {
      return this.alert.decorate("validatable");
    }

    //END initialize
    raceOptionId(race_option) {
      return `race_option-${race_option.get('id')}`;
    }

    close() {
      return this.trigger("close");
    }

    isFrench() {
      return Language.selectedLanguageCode() === "ca/fr";
    }

    submit() {
      if (this.is_saving()) {
        return this;
      }
      if (!this.race_selection.validate()) {
        return;
      }
      this.is_saving(true);
      return this.race_selection.clone().promiseCreate({
        attributes: ['race_id', 'race_option_id']
      }).then((race_selection) => {
        this.alert.setIsValid(true);
        this.trigger("race_selection:create", race_selection);
        Application.trigger("race_selection:create", race_selection);
        return this.close();
      }).fail((error) => {
        console.error(error);
        return this.alert.setIsValid(false, error.human || error.msg || "An error occurred");
      }).fin(() => {
        return this.is_saving(false);
      }).done();
    }

  };

  RaceView.prototype.endpoint = "#race-template";

  RaceView.prototype.defaults = {
    race: function(race) {
      return race;
    },
    race_selection: function(race) {
      return new RaceSelection().fill({
        race_id: race.get('id')
      });
    }
  };

  //END defaults
  RaceView.prototype.observables = {
    alert: void 0,
    is_loading: false,
    is_saving: false,
    sorted_race_options: function() {
      return this.race.race_options.sort((a, b) => {
        if (a.get('order') < b.get('order')) {
          return -1;
        }
        if (a.get('order') > b.get('order')) {
          return 1;
        }
        return 0;
      });
    }
  };

  return RaceView;

}).call(this);

//END submit
//END ManageAccountView

},{"../../$collections/race_options.collection":38,"../../$collections/race_selections.collection":39,"../../$collections/races.collection":40,"../../$models/question.model":71,"../../$models/race.model":72,"../../$models/race_option.model":73,"../../$models/race_selection.model":74}],115:[function(require,module,exports){
var RPC, RaceWinnerModalView;

RPC = require("../../rpc");

module.exports = RaceWinnerModalView = (function() {
  class RaceWinnerModalView extends Falcon.View {
    //END content_class
    //END observables'
    initialize(race_selection) {
      return RPC.promiseMarkRaceSelection(race_selection).then((race_selection) => {
        return this.race_selection.fill(race_selection);
      });
    }

    //END promiseMarkRaceSelection
    //END initiailize
    close() {
      return this.trigger("close");
    }

  };

  RaceWinnerModalView.prototype.endpoint = "#race_winner_modal-template";

  RaceWinnerModalView.prototype.defaults = {
    'race_selection': function(race_selection) {
      return race_selection;
    }
  };

  //END defaults
  RaceWinnerModalView.prototype.observables = {
    'is_visible': false,
    'entry': function() {
      return this.race_selection.entry;
    },
    'entry_count': function() {
      var entry;
      entry = this.entry();
      if (entry == null) {
        return 0;
      }
      return 1 + (entry.get('bonus_entries') || 0);
    },
    //END entry_count
    'has_multiple_entries': function() {
      return this.entry_count() > 1;
    },
    'content_class': function() {
      if (this.entry_count() === 1) {
        return 'is-one-entry';
      }
      if (this.entry_count() === 2) {
        return 'is-two-entries';
      }
      if (this.entry_count() === 3) {
        return 'is-three-entries';
      }
      if (this.entry_count() === 5) {
        return 'is-five-entries';
      }
      if (this.entry_count() === 10) {
        return 'is-ten-entries';
      }
      if (this.entry_count() === 20) {
        return 'is-twenty-entries';
      }
    }
  };

  return RaceWinnerModalView;

}).call(this);

//END RaceWinnerModalView

},{"../../rpc":90}],116:[function(require,module,exports){
var Entry, RPC, Recaptcha, RegistrationView, Session, User;

Session = require("../../$models/session.model");

Entry = require("../../$models/entry.model");

User = require("../../$models/user.model");

RPC = require("../../rpc");

Recaptcha = require("../../recaptcha");

module.exports = RegistrationView = (function() {
  class RegistrationView extends Falcon.View {
    //END can_goto_second_screen
    //END observables
    initialize() {
      this.alert.decorate('validatable');
      //END alert
      this.first_name.decorate('validatable').subscribe(this.validateFirstName, this);
      //END first_name
      this.last_name.decorate('validatable').subscribe(this.validateLastName, this);
      //END last_name
      this.email.decorate('lowercase').decorate('validatable').subscribe(this.validateEmail, this);
      //END email
      this.email.subscribe(this.checkEmail, this);
      this.repeat_email.decorate('lowercase').decorate('validatable').subscribe(this.validateRepeatEmail, this);
      //END repeat_email
      this.phone.decorate('validatable').subscribe(this.validatePhone, this);
      //END phone
      this.password.decorate('validatable').subscribe(this.validatePassword, this);
      //END password
      return this.repeat_password.decorate('validatable').subscribe(this.validateRepeatPassword, this);
    }

    //END repeat_password
    //END initialize
    validateFirstName() {
      var first_name;
      first_name = Helpers.trim(this.first_name());
      if (_.isEmpty(first_name)) {
        return this.first_name.setIsValid(false, "First name must not be empty");
      }
      return this.first_name.setIsValid(true);
    }

    //END validateFirstName
    validateLastName() {
      var last_name;
      last_name = Helpers.trim(this.last_name());
      if (_.isEmpty(last_name)) {
        return this.last_name.setIsValid(false, "Last name must not be empty");
      }
      return this.last_name.setIsValid(true);
    }

    checkEmail() {
      var email;
      email = Helpers.trim(this.email());
      if (this._checkEmailTimeout) {
        clearTimeout(this._checkEmailTimeout);
      }
      //END if
      return this._checkEmailTimeout = setTimeout(() => {
        this._checkEmailTimeout = null;
        return RPC.promiseCheckEmail(email).then((is_taken) => {
          return this.email_is_taken(is_taken);
        });
      }, 250);
    }

    //END checkEmail
    validateEmail() {
      var email;
      email = Helpers.trim(this.email());
      if (_.isEmpty(email)) {
        return this.email.setIsValid(false, "Email must not be empty");
      }
      if (!Helpers.isEmail(email)) {
        return this.email.setIsValid(false, "Email is formatted incorrectly");
      }
      if (!_.isEmpty(this.repeat_email())) {
        this.validateRepeatEmail();
      }
      return this.email.setIsValid(true);
    }

    //END validateEmail
    validateRepeatEmail() {
      var email, repeat_email;
      email = this.email();
      repeat_email = this.repeat_email();
      if (_.isEmpty(repeat_email)) {
        return this.repeat_email.setIsValid(false, "Please re-enter your email");
      }
      if (email !== repeat_email) {
        return this.repeat_email.setIsValid(false, "Emails do not match");
      }
      return this.repeat_email.setIsValid(true);
    }

    //END validateRepeatEmail
    validatePassword() {
      var password;
      password = this.password();
      if (!Helpers.isPassword(password)) {
        return this.password.setIsValid(false, "Password must be at least 6 characters long and must not contain white space");
      }
      if (!_.isEmpty(this.repeat_password())) {
        this.validateRepeatPassword();
      }
      return this.password.setIsValid(true);
    }

    //END validatePassword
    validateRepeatPassword() {
      var password, repeat_password;
      password = this.password();
      repeat_password = this.repeat_password();
      if (_.isEmpty(repeat_password)) {
        return this.repeat_password.setIsValid(false, "Please re-enter your password");
      }
      if (password !== repeat_password) {
        return this.repeat_password.setIsValid(false, "Passwords do not match");
      }
      return this.repeat_password.setIsValid(true);
    }

    //END validateRepeatPassword
    validatePhone() {
      var phone;
      phone = this.phone() || "";
      if (phone.length !== 10 && !/[0-9]{10}/.test(phone)) {
        return this.phone.setIsValid(false, "Please enter a valid phone number");
      }
      return this.phone.setIsValid(true);
    }

    //END validatePhone
    validateRecaptcha(recpactha_token) {
      if (!recpactha_token) {
        return this.alert.setIsValid(false, "Please complete the recaptcha");
      }
      return true;
    }

    //END validateRecaptcha
    resetFields() {
      this.alert("");
      this.alert.resetValidations();
      this.first_name("");
      this.first_name.resetValidations();
      this.last_name("");
      this.last_name.resetValidations();
      this.email("");
      this.email.resetValidations();
      this.repeat_email("");
      this.repeat_email.resetValidations();
      this.password("");
      this.password.resetValidations();
      this.repeat_password("");
      this.repeat_password.resetValidations();
      this.phone("");
      this.phone.resetValidations();
      return this;
    }

    //END resetFields
    gotoFirstScreen() {
      this.showing_first_screen(true);
      return true;
    }

    //END gotoFirstScreen
    gotoSecondScreen() {
      if (!this.can_goto_second_screen()) {
        return false;
      }
      this.showing_first_screen(false);
      return true;
    }

    //END gotoSecondScreen
    register(recaptcha_token) {
      var attributes, email, email_is_valid, first_name_is_valid, is_subscribed_to_newsletter, last_name_is_valid, legal_agreements, name, password, password_is_valid, phone_is_valid, phone_number, recaptcha_token_is_valid, repeat_email_is_valid, repeat_password_is_valid, user;
      first_name_is_valid = this.validateFirstName();
      last_name_is_valid = this.validateLastName();
      email_is_valid = this.validateEmail();
      repeat_email_is_valid = this.validateRepeatEmail();
      password_is_valid = this.validatePassword();
      repeat_password_is_valid = this.validateRepeatPassword();
      phone_is_valid = this.validatePhone();
      recaptcha_token_is_valid = this.validateRecaptcha(recaptcha_token);
      if (!(first_name_is_valid && last_name_is_valid && email_is_valid && repeat_email_is_valid)) {
        this.gotoFirstScreen();
      }
      if (!(first_name_is_valid && last_name_is_valid && email_is_valid && repeat_email_is_valid && password_is_valid && repeat_password_is_valid && phone_is_valid && recaptcha_token_is_valid)) {
        return this;
      }
      if (!this.can_register()) {
        return this;
      }
      if (this.is_registering()) {
        return this;
      }
      name = Helpers.trim(this.name());
      email = Helpers.trim(this.email());
      phone_number = this.formatted_phone();
      password = this.password();
      is_subscribed_to_newsletter = this.opted_in_emails();
      legal_agreements = {
        'did_read_rules_dream_drive_2019': true,
        'opted_in_to_dream_drive_2019': true
      };
      this.is_registering(true);
      user = new User({name, email, password, phone_number, is_subscribed_to_newsletter, legal_agreements, recaptcha_token});
      attributes = ['name', 'email', 'password', 'phone_number', 'is_subscribed_to_newsletter', 'legal_agreements', 'recaptcha_token'];
      user.promiseCreate({attributes}).then((user) => {
        this.trigger('user:create', user);
        Application.trigger('user:create', user);
        return user;
      }).then(() => {
        return Recaptcha.execute();
      }).then((recaptcha_token) => {
        return new Session({email, password, recaptcha_token}).promiseCreate({
          attributes: ['email', 'password', 'recaptcha_token']
        });
      }).then((session) => {
        Application.login(session);
        this.trigger('session:create', session);
        return Application.trigger('session:create', session);
      }).then(() => {
        if (!this.has_game_code()) {
          return null;
        }
        return RPC.promiseClaimGameCode(this.game_code()).then(function(entry) {
          return Application.setClaimedEntry(entry);
        });
      }).then((entry) => {
        this.resetFields();
        Router.gotoMain();
        return Tutorial.clear();
      }).fail((error) => {
        Application.flashError(error);
        this.alert.setIsValid(false, error.human);
        return this.gotoFirstScreen();
      }).fin(() => {
        return this.is_registering(false);
      }).done();
      //END user
      return this;
    }

    //END register
    setGameCode(game_code) {
      this.game_code(game_code);
      return this;
    }

    //END setGameCode
    gotoLogin() {
      var params;
      params = {};
      if (this.has_game_code()) {
        params['game_code'] = this.game_code();
      }
      return Router.gotoLogin(params);
    }

    //END gotoLogin
    showRules() {
      return Application.Layout.showRules();
    }

  };

  RegistrationView.prototype.endpoint = '#registration-template';

  RegistrationView.prototype.observables = {
    'alert': "",
    'is_registering': false,
    'email_is_taken': false,
    'first_name': "",
    'last_name': "",
    'name': function() {
      return Helpers.trim(this.first_name() + " " + this.last_name());
    },
    'email': "",
    'repeat_email': "",
    'phone': "",
    'password': "",
    'repeat_password': "",
    'game_code': "",
    'has_game_code': function() {
      return Entry.isValidCode(this.game_code());
    },
    'formatted_phone': {
      write: function(value) {
        value = (value || "").toString().replace(/[^0-9]+/gi, "");
        return this.phone(value);
      },
      //END write
      read: function() {
        var first_piece, phone, second_piece, third_piece;
        phone = (this.phone() || "").toString();
        if (!/^[0-9]+$/.test(phone)) {
          return phone;
        }
        first_piece = phone.slice(0, 3);
        second_piece = phone.slice(3, 6);
        third_piece = phone.slice(6, 10);
        if (third_piece.length > 0) {
          return `(${first_piece}) ${second_piece}-${third_piece}`;
        } else if (second_piece.length > 0) {
          return `${first_piece}-${second_piece}`;
        } else {
          return `${first_piece}`;
        }
      }
    },
    //END if
    //END read
    //END formatted_phone
    '_opted_in_emails': void 0,
    'opted_in_emails': {
      write: function(value) {
        return this._opted_in_emails(value);
      },
      read: function() {
        var opted_in_emails;
        opted_in_emails = this._opted_in_emails();
        if (opted_in_emails != null) {
          return opted_in_emails;
        }
        return Language.isWithinUnitedStates();
      }
    },
    //END read
    //END opted_in_emails
    'did_read_rules': false,
    'can_register': function() {
      if (this.is_registering()) {
        return false;
      }
      if (!this.first_name.is_valid()) {
        return false;
      }
      if (!this.last_name.is_valid()) {
        return false;
      }
      if (!this.email.is_valid()) {
        return false;
      }
      if (!this.repeat_email.is_valid()) {
        return false;
      }
      if (!this.phone.is_valid()) {
        return false;
      }
      if (!this.password.is_valid()) {
        return false;
      }
      if (!this.repeat_password.is_valid()) {
        return false;
      }
      if (!this.did_read_rules()) {
        return false;
      }
      return true;
    },
    //END can_register
    'showing_first_screen': true,
    'should_show_first_screen': function() {
      if (Application.is_on_mobile()) {
        return true;
      }
      return this.showing_first_screen();
    },
    //END should_show_first_screen
    'should_show_first_screen_actions': function() {
      if (Application.is_on_mobile()) {
        return false;
      }
      return true;
    },
    //END should_show_first_screen_actions
    'should_show_second_screen': function() {
      if (Application.is_on_mobile()) {
        return true;
      }
      return !this.showing_first_screen();
    },
    //END should_show_second_screen
    'should_show_back_action': function() {
      if (Application.is_on_mobile()) {
        return false;
      }
      return true;
    },
    //END should_show_back_action
    'can_goto_second_screen': function() {
      if (this.is_registering()) {
        return false;
      }
      if (!this.first_name.is_valid()) {
        return false;
      }
      if (!this.last_name.is_valid()) {
        return false;
      }
      if (!this.email.is_valid()) {
        return false;
      }
      if (!this.repeat_email.is_valid()) {
        return false;
      }
      return true;
    }
  };

  //END validateLastName
  RegistrationView.prototype._checkEmailTimeout = null;

  return RegistrationView;

}).call(this);

//END RegistrationView

},{"../../$models/entry.model":60,"../../$models/session.model":78,"../../$models/user.model":82,"../../recaptcha":89,"../../rpc":90}],117:[function(require,module,exports){
var RPC, Recaptcha, ResetPasswordView, Session;

RPC = require("../../rpc");

Session = require("../../$models/session.model");

Recaptcha = require("../../recaptcha");

module.exports = ResetPasswordView = (function() {
  class ResetPasswordView extends Falcon.View {
    //END can_reset_password
    //END observables
    initialize() {
      this.alert.decorate('validatable');
      //END alert
      this.password.decorate('validatable').subscribe(this.validatePassword, this);
      //END password
      return this.repeat_password.decorate('validatable').subscribe(this.validateRepeatPassword, this);
    }

    //END repeat_password
    //END initialize
    setEmail(email) {
      return this.email(decodeURIComponent(email));
    }

    setResetCode(reset_code) {
      return this.reset_code(decodeURIComponent(reset_code));
    }

    validatePassword() {
      var password;
      password = this.password();
      if (!Helpers.isPassword(password)) {
        return this.password.setIsValid(false, "Password must be at least 6 characters long and must not contain white space");
      }
      if (!_.isEmpty(this.repeat_password())) {
        this.validateRepeatPassword();
      }
      return this.password.setIsValid(true);
    }

    //END validatePassword
    validateRepeatPassword() {
      var password, repeat_password;
      password = this.password();
      repeat_password = this.repeat_password();
      if (_.isEmpty(repeat_password)) {
        return this.repeat_password.setIsValid(false, "Please re-enter your password");
      }
      if (password !== repeat_password) {
        return this.repeat_password.setIsValid(false, "Passwords do not match");
      }
      return this.repeat_password.setIsValid(true);
    }

    //END validateRepeatPassword
    validateRecaptcha(recpactha_token) {
      if (!recpactha_token) {
        return this.alert.setIsValid(false, "Please complete the recaptcha");
      }
      return true;
    }

    //END validateRecaptcha
    resetFields() {
      this.alert("");
      this.alert.resetValidations();
      this.password("");
      this.password.resetValidations();
      this.repeat_password("");
      this.repeat_password.resetValidations();
      return this;
    }

    //END resetFields
    reset(recaptcha_token) {
      var email, password, reset_code;
      if (!(this.validatePassword() && this.validateRepeatPassword() && this.validateRecaptcha(recaptcha_token))) {
        return this;
      }
      if (!this.can_reset_password()) {
        return this;
      }
      if (this.is_resetting()) {
        return this;
      }
      email = Helpers.trim(this.email());
      reset_code = Helpers.trim(this.reset_code());
      password = Helpers.trim(this.password());
      this.is_resetting(true);
      console.log(recaptcha_token);
      RPC.promiseResetPassword({email, reset_code, password, recaptcha_token}).then((user) => {
        return Recaptcha.execute();
      }).then((recaptcha_token) => {
        console.log(recaptcha_token);
        return new Session({email, password, recaptcha_token}).promiseCreate({
          attributes: ['email', 'password', 'recaptcha_token']
        });
      }).then((session) => {
        Application.login(session);
        this.resetFields();
        this.trigger('session:create', session);
        Application.trigger('session:create', session);
        return Router.gotoMain();
      }).fail((error) => {
        var ref;
        Application.flashError(error);
        return this.alert.setIsValid(false, (ref = error.human) != null ? ref : error.message);
      }).fin(() => {
        return this.is_resetting(false);
      }).done();
      //END RPC
      return this;
    }

    //END send
    gotoLogin() {
      return Router.gotoLogin();
    }

  };

  ResetPasswordView.prototype.endpoint = '#reset_password-template';

  ResetPasswordView.prototype.observables = {
    'alert': "",
    'is_resetting': false,
    'email': "",
    'reset_code': "",
    'password': "",
    'repeat_password': "",
    'email_is_valid': function() {
      return Helpers.isEmail(this.email());
    },
    'reset_code_is_valid': function() {
      return !_.isEmpty(this.reset_code());
    },
    'can_reset_password': function() {
      if (!this.email_is_valid()) {
        return false;
      }
      if (!this.reset_code_is_valid()) {
        return false;
      }
      return true;
    }
  };

  return ResetPasswordView;

}).call(this);

//END ResetPasswordView

},{"../../$models/session.model":78,"../../recaptcha":89,"../../rpc":90}],118:[function(require,module,exports){
var Language, RulesView;

Language = require("../language");

module.exports = RulesView = class RulesView extends Falcon.View {
  endpoint() {
    var ret;
    ret = (function() {
      switch (Language.selectedLanguageCode()) {
        case "ca/en":
          return "#rules_ca_en-template";
        case "ca/fr":
          return "#rules_ca_fr-template";
        default:
          return "#rules_us_en-template";
      }
    })();
    //END switch
    return ret;
  }

};

//END endpoint
//END RulesView

},{"../language":98}],119:[function(require,module,exports){
var Question, Survey, SurveyAnswer, SurveyAnswers, SurveyResponse, SurveyResponses, SurveyView, Surveys;

Question = require("../../$models/question.model");

Survey = require("../../$models/survey.model");

SurveyAnswer = require("../../$models/survey_answer.model");

SurveyAnswers = require("../../$collections/survey_answers.collection");

SurveyResponse = require("../../$models/survey_response.model");

SurveyResponses = require("../../$collections/survey_responses.collection");

Surveys = require("../../$collections/surveys.collection");

module.exports = SurveyView = (function() {
  class SurveyView extends Falcon.View {
    //END active_answer
    //END observables
    initialize() {
      return this.alert.decorate("validatable");
    }

    //END initialize
    gotoNext() {
      var active_answer;
      if (this.is_saving()) {
        return this;
      }
      active_answer = this.active_answer();
      if ((active_answer != null) && !active_answer.validate()) {
        return;
      }
      this.active_index(this.active_index() + 1);
      if (this.active_index() === this.survey_response.answers.length()) {
        return this.submit();
      }
    }

    //END gotoNext
    close() {
      return this.trigger("close");
    }

    isFrench() {
      return Language.selectedLanguageCode() === "ca/fr";
    }

    submit() {
      if (this.is_saving() || this.is_successful()) {
        return this;
      }
      if (!this.survey_response.validate()) {
        return;
      }
      this.is_saving(true);
      return this.survey_response.clone().promiseCreate({
        attributes: {
          'survey_id': true,
          'answers': ['question_id', 'selections']
        }
      }).then((survey_response) => {
        this.is_successful(true);
        this.alert.setIsValid(true);
        this.trigger("entry:create", survey_response.entry);
        return Application.trigger("entry:create", survey_response.entry);
      }).fail((error) => {
        console.error(error);
        return this.alert.setIsValid(false, error.human || error.msg || "An error occurred");
      }).fin(() => {
        return this.is_saving(false);
      }).done();
    }

  };

  SurveyView.prototype.endpoint = "#survey-template";

  SurveyView.prototype.defaults = {
    survey: function(survey) {
      return survey;
    },
    survey_response: function(survey) {
      return (new SurveyResponse()).mapSurvey(survey);
    }
  };

  //END defaults
  SurveyView.prototype.observables = {
    alert: void 0,
    is_loading: false,
    is_saving: false,
    is_successful: false,
    active_index: 0,
    is_showing_thank_you: function() {
      return this.active_index() === this.survey_response.answers.length();
    },
    has_next_question: function() {
      return this.active_index() < this.survey_response.answers.length() - 1;
    },
    active_answer: function() {
      var answers;
      answers = this.survey_response.answers.all();
      answers.sort((a, b) => {
        a = parseInt(a.question.get('order'));
        b = parseInt(b.question.get('order'));
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        return 0;
      });
      return answers[this.active_index()];
    }
  };

  return SurveyView;

}).call(this);

//END submit
//END ManageAccountView

},{"../../$collections/survey_answers.collection":44,"../../$collections/survey_responses.collection":45,"../../$collections/surveys.collection":46,"../../$models/question.model":71,"../../$models/survey.model":79,"../../$models/survey_answer.model":80,"../../$models/survey_response.model":81}],120:[function(require,module,exports){
var RPC, VideoModalView;

RPC = require("../../rpc");

module.exports = VideoModalView = (function() {
  class VideoModalView extends Falcon.View {
    close() {
      return Application.Layout.clearModalView();
    }

  };

  VideoModalView.prototype.endpoint = "#video_modal-template";

  return VideoModalView;

}).call(this);

//END close
//END VideoModalView

},{"../../rpc":90}]},{},[95]);
